{
  "common": {
    "actions": "İşlemler",
    "add": "Ekle",
    "all": "Tümü",
    "back": "Geri",
    "cancel": "Vazgeç",
    "close": "Kapat",
    "confirm": "Onayla",
    "copied": "Kopyalandı",
    "copy": "Kopyala",
    "copyFailed": "Panoya kopyalanamadı",
    "create": "Oluştur",
    "delete": "Sil",
    "description": "Açıklama",
    "edit": "Düzenle",
    "goHome": "Ana sayfaya dön",
    "loading": "Yükleniyor…",
    "next": "İleri",
    "no": "Hayır",
    "remove": "Kaldır",
    "retry": "Tekrar dene",
    "save": "Kaydet",
    "saved": "Kaydedildi",
    "search": "Ara",
    "view": "Görüntüle",
    "yes": "Evet",
    "you": "sen"
  },
  "nav": {
    "activity": "Etkinliğim",
    "adminFraud": "Bağlantılı hesaplar",
    "adminOverview": "Genel bakış",
    "adminUsers": "Kullanıcılar",
    "allLogs": "Tüm kayıtlar",
    "assignments": "Görevlerim",
    "billing": "Ödemeler",
    "communities": "Topluluklar",
    "devices": "Cihazlarım",
    "disputes": "İtirazlar",
    "earnings": "Kazançlarım",
    "exploratory": "Serbest test",
    "getStarted": "Başlarken",
    "jobs": "İş ilanları",
    "logs": "Kayıtlar",
    "myBugs": "Bildirdiğim buglar",
    "myDisputes": "İtirazlarım",
    "organization": "Organizasyon",
    "payments": "Ödemeler",
    "profile": "Profilim",
    "projects": "Projeler",
    "reputation": "İtibar puanım",
    "talent": "Test uzmanı bul",
    "teamPanel": "Ekip paneli",
    "teams": "Ekipler",
    "cv": "CV'm",
    "adminErrors": "Hatalar",
    "membership": "Üyelik",
    "myMembership": "Üyeliğim",
    "memberships": "Üyelikler"
  },
  "shell": {
    "areas": "Çalışma alanı",
    "language": "Dil",
    "logout": "Çıkış yap",
    "mainNav": "Ana menü",
    "newOrg": "Yeni organizasyon",
    "openMenu": "Menüyü aç",
    "organizations": "Organizasyonlar",
    "skipToContent": "İçeriğe geç",
    "switchLanguage": "Dili değiştir",
    "switchOrg": "Organizasyon değiştir",
    "theme": "Tema",
    "themeDark": "Koyu",
    "themeFosforlu": "Fosforlu",
    "themeLight": "Açık",
    "themeOzalit": "Ozalit",
    "themeSystem": "Sistem",
    "themeToggle": "Tema: {{mode}}",
    "userMenu": "Kullanıcı menüsü"
  },
  "area": {
    "admin": "Yönetim",
    "customer": "Müşteri",
    "lead": "Lider",
    "tester": "Testçi"
  },
  "errors": {
    "conflict": "Kayıt siz düzenlerken başka biri tarafından değiştirildi. Sayfayı yenileyip tekrar deneyin.",
    "forbidden": "Bu işlem için yetkiniz yok.",
    "loadFailed": "Veriler yüklenemedi",
    "network": "Sunucuya ulaşılamadı. Bağlantınızı ve API'nin çalıştığını kontrol edin.",
    "notFound": "Aradığınız kayıt bulunamadı.",
    "notFoundTitle": "Bulunamadı",
    "pageNotFound": "Sayfa bulunamadı",
    "pageNotFoundBody": "Bağlantı hatalı olabilir ya da sayfa taşınmış olabilir.",
    "server": "Sunucuda beklenmeyen bir hata oluştu. Biraz sonra tekrar deneyin.",
    "unknown": "Bilinmeyen bir hata oluştu."
  },
  "validation": {
    "email": "Geçerli bir e-posta adresi girin.",
    "minLength": "En az {{n}} karakter girin.",
    "number": "Sayı girin.",
    "passwordLength": "Parola en az 8 karakter olmalı.",
    "range": "{{min}} ile {{max}} arasında bir değer girin.",
    "required": "Bu alan zorunlu.",
    "url": "http:// veya https:// ile başlayan geçerli bir adres girin.",
    "appLink": "https://… ya da uygulamanın kendi adresi (ör. demoshop://open) olmalı."
  },
  "auth": {
    "devHint": "Geliştirme hesapları:",
    "displayName": "Ad soyad",
    "email": "E-posta",
    "haveAccount": "Hesabın var mı?",
    "intent": "TestRome'u nasıl kullanacaksın?",
    "intentHint": {
      "customer": "Senaryolarını yaz, test uzmanı bul, kayıtlı ve puanlı sonuçları incele.",
      "tester": "Freelance test uzmanı olarak ilanlara başvur, tek başına ya da bir ekiple çalış."
    },
    "intentOption": {
      "customer": "Uygulamamı test ettirmek istiyorum",
      "tester": "Test yaparak kazanmak istiyorum"
    },
    "login": "Giriş yap",
    "loginSubtitle": "Testleri, kayıtları ve kanıtları tek yerden yönetin.",
    "loginTitle": "TestRome'a giriş",
    "noAccount": "Hesabın yok mu?",
    "password": "Parola",
    "passwordHint": "En az 8 karakter.",
    "register": "Kayıt ol",
    "registerSubtitle": "Müşteri, topluluk lideri veya test uzmanı olarak aynı hesapla çalışırsınız.",
    "registerTitle": "Hesap oluştur"
  },
  "invite": {
    "accept": "Daveti kabul et",
    "body": "{{inviter}}, seni {{community}} topluluğuna {{role}} olarak davet ediyor.",
    "invalid": "Bu davet geçersiz, süresi dolmuş ya da kullanım sınırına ulaşmış.",
    "joined": "{{community}} topluluğuna katıldın.",
    "signInFirst": "Daveti kabul etmek için giriş yap ya da hesap oluştur.",
    "title": "Topluluk daveti"
  },
  "communityRole": {
    "Lead": "Lider",
    "Tester": "Test uzmanı"
  },
  "memberStatus": {
    "Active": "Aktif",
    "Invited": "Davet edildi",
    "Removed": "Çıkarıldı"
  },
  "orgRole": {
    "Admin": "Yönetici",
    "Owner": "Sahip",
    "Reviewer": "İnceleyici"
  },
  "welcome": {
    "browseJobs": "İş ilanlarına bak",
    "communityName": "Topluluk adı",
    "communityPlaceholder": "Örn. Mobil Test Ekibi",
    "createCommunity": "Topluluk oluştur",
    "createOrg": "Organizasyon oluştur",
    "createProfile": "Profilimi oluştur",
    "customerBody": "Uygulamanızın test senaryolarını yükleyin, bir test topluluğuna iş verin ve her çalıştırmanın kaydını inceleyin.",
    "customerTitle": "Uygulamamı test ettirmek istiyorum",
    "freelancerBody": "Profilini oluştur, iş ilanlarına başvur ya da açık havuzdan görev al. Kabul edilen her test ve doğrulanan her bug için kazanırsın.",
    "freelancerTitle": "Freelance test uzmanı ol",
    "inviteLink": "Davet bağlantısı veya kodu",
    "leadBody": "Kendi test ekibinizi kurun, üyeleri davet edin ve müşterilerle partner koduyla eşleşin.",
    "leadTitle": "Bir test topluluğu yönetiyorum",
    "openInvite": "Daveti aç",
    "orgName": "Organizasyon adı",
    "orgPlaceholder": "Örn. Acme Yazılım",
    "subtitle": "Nasıl başlamak istersin? İstediğin zaman diğer rolleri de ekleyebilirsin.",
    "testerBody": "Bir topluluk liderinden aldığın davet bağlantısını yapıştır.",
    "testerTitle": "Test uzmanı olarak katılıyorum",
    "title": "Hoş geldin, {{name}}"
  },
  "org": {
    "create": "Organizasyon oluştur",
    "newSubtitle": "Projeleriniz, test senaryolarınız ve ekip arkadaşlarınız bu organizasyonun altında toplanır.",
    "newTitle": "Yeni organizasyon"
  },
  "orgSettings": {
    "add": "Ekle",
    "addHint": "Kişinin önce TestRome hesabı oluşturmuş olması gerekir.",
    "link": "Bağla",
    "linked": "{{name}} topluluğu bağlandı.",
    "linkedAt": "Bağlandı: {{at}}",
    "memberAdded": "{{name}} eklendi.",
    "memberCount": "{{count}} üye",
    "members": "Ekip üyeleri",
    "membersHint": "Sahip ve yöneticiler proje ve döngüleri yönetir; inceleyiciler çalıştırmaları ve bugları değerlendirir.",
    "noOrg": "Henüz bir organizasyonun yok.",
    "noPartners": "Bağlı topluluk yok",
    "noPartnersBody": "Bir topluluk liderinden partner kodunu isteyin ve buraya girin; o topluluk döngülerinizde seçilebilir hale gelir.",
    "partnerCode": "Partner kodu",
    "partners": "Partner topluluklar",
    "partnersHint": "Testlerinizi yürütebilecek dış test toplulukları.",
    "remove": "Çıkar",
    "removeBody": "Bu kişi organizasyonun projelerine artık erişemeyecek.",
    "removeTitle": "{{name}} organizasyondan çıkarılsın mı?",
    "role": "Rol",
    "title": "Organizasyon ayarları"
  },
  "platform": {
    "Android": "Android",
    "Ios": "iOS",
    "Web": "Web"
  },
  "projects": {
    "activeCycles": "Aktif döngü",
    "allowedOrigins": "İzinli origin'ler",
    "allowedOriginsHint": "Kayıt SDK'sının veri gönderebileceği adresler (her satıra bir tane). Boş bırakılırsa uygulama adresinin origin'i kullanılır.",
    "appUrl": "Uygulama adresi",
    "appUrlHint": "Test uzmanlarının açacağı ortam, örn. https://staging.ornek.com",
    "create": "Projeyi oluştur",
    "emptyBody": "Test ettirmek istediğiniz uygulama için bir proje oluşturun.",
    "emptyTitle": "Henüz proje yok",
    "name": "Proje adı",
    "new": "Yeni proje",
    "newDescription": "Sonraki adımda kayıt SDK'sını uygulamanıza ekleyeceksiniz.",
    "newTitle": "Yeni proje",
    "openBugs": "Açık bug",
    "pendingReviews": "İnceleme bekleyen",
    "platform": "Platform",
    "title": "Projeler"
  },
  "projectNav": {
    "bugs": "Buglar",
    "cases": "Test senaryoları",
    "cycles": "Test döngüleri",
    "knownIssues": "Bilinen hatalar",
    "label": "Proje bölümleri",
    "logs": "Kayıtlar",
    "overview": "Genel bakış",
    "project": "Proje",
    "proposals": "Öneriler",
    "quality": "Kalite",
    "rhythm": "Çalışma ritmi",
    "review": "İnceleme",
    "settings": "Ayarlar"
  },
  "overview": {
    "activeCycles": "Aktif döngüler",
    "averageConfidence": "Ortalama güven puanı",
    "confidence": "Güven dağılımı",
    "confidenceHint": "Teslim edilen çalıştırmaların güven bandlarına göre dağılımı.",
    "executions": "{{count}} çalıştırma",
    "gettingStarted": "Başlarken",
    "noScores": "Henüz puanlanmış çalıştırma yok.",
    "openBugs": "Açık buglar",
    "outcomes": "Sonuçlar",
    "pendingReviews": "İnceleme bekleyenler",
    "recentCycles": "Son döngüler",
    "step1": "SDK'yı ekleyin",
    "step1Body": "Kayıt SDK'sını uygulamanıza ekleyin; yalnızca test uzmanı TestRome'dan açtığında kayıt yapar.",
    "step2": "Test senaryolarını yükleyin",
    "step2Body": "Senaryoları tek tek yazın ya da CSV ile içe aktarın.",
    "step3": "İlk döngüyü başlatın",
    "step3Body": "Senaryoları seçin, topluluğu belirleyin ve görevleri dağıtın."
  },
  "cases": {
    "allSuites": "Tüm gruplar",
    "anyPriority": "Tüm öncelikler",
    "chooseFile": "Dosya seç",
    "csvContent": "CSV içeriği",
    "csvHint": "Başlık satırı zorunlu; aynı case_key'e sahip satırlar tek senaryonun adımlarıdır.",
    "deleteSuiteBody": "Gruptaki senaryolar silinmez, grupsuz kalır.",
    "deleteSuiteTitle": "\"{{name}}\" grubu silinsin mi?",
    "editSuite": "Grubu düzenle",
    "emptyBody": "İlk senaryonuzu yazın ya da CSV dosyasından içe aktarın.",
    "emptyTitle": "Bu filtrede senaryo yok",
    "import": "CSV içe aktar",
    "importDescription": "Önce önizleme yapılır; hatalı satır varsa hiçbir şey kaydedilmez.",
    "importN": "{{count}} senaryoyu içe aktar",
    "importTitle": "CSV'den senaryo içe aktar",
    "imported": "{{count}} senaryo içe aktarıldı.",
    "key": "Anahtar",
    "line": "Satır {{line}}",
    "new": "Yeni senaryo",
    "newSuite": "Yeni grup",
    "noSuitesBody": "Senaryoları gruplamak için önce bir grup (suite) oluşturun, örn. \"Ödeme\" ya da \"Giriş\".",
    "noSuitesTitle": "Henüz senaryo grubu yok",
    "preview": "Önizle",
    "previewCases": "{{count}} senaryo okundu",
    "previewErrors": "{{count}} hata",
    "priority": "Öncelik",
    "searchPlaceholder": "Başlık veya anahtar ara…",
    "status": "Durum",
    "statusFilter": "Durum filtresi",
    "stepCount": "{{count}} adım",
    "steps": "Adım",
    "suiteName": "Grup adı",
    "suites": "Gruplar",
    "targetSuite": "Hedef grup",
    "title": "Başlık",
    "updated": "Güncellendi",
    "useExample": "Örnek CSV'yi kullan"
  },
  "caseStatus": {
    "Active": "Aktif",
    "Archived": "Arşivlendi",
    "Draft": "Taslak",
    "Proposed": "Önerildi",
    "Rejected": "Reddedildi"
  },
  "priority": {
    "Critical": "Kritik",
    "High": "Yüksek",
    "Low": "Düşük",
    "Medium": "Orta"
  },
  "evidence": {
    "None": "Gerekmiyor",
    "Screenshot": "Ekran görüntüsü",
    "Video": "Video"
  },
  "checkpointType": {
    "Event": "Olay",
    "None": "Yok",
    "Route": "Sayfa adresi"
  },
  "caseEditor": {
    "action": "Yapılacak işlem",
    "addStep": "Adım ekle",
    "atLeastOneStep": "En az bir adım gerekli.",
    "checkpoint": "Kontrol noktası",
    "checkpointNoneHint": "Adım gerçekten yapıldığında uygulamada oluşması gereken iz.",
    "checkpointValue": "Kontrol değeri",
    "created": "{{key}} oluşturuldu.",
    "createdBy": "Oluşturan: {{name}}",
    "deleteBody": "Senaryo arşive taşınır; geçmiş çalıştırmalar ve raporlar korunur.",
    "deleteTitle": "{{key}} silinsin mi?",
    "dragStep": "{{n}}. adımı taşı",
    "duplicateStep": "Adımı çoğalt",
    "eventHint": "Uygulamanın checkpoint('…') ile gönderdiği olay adı.",
    "evidence": "Kanıt",
    "expected": "Beklenen sonuç",
    "linkedIssues": "Bu senaryo bilinen hatalarla ilişkili:",
    "minSeconds": "En az süre (sn)",
    "newTitle": "Yeni test senaryosu",
    "noSuite": "Grup seçilmedi",
    "preconditions": "Ön koşullar",
    "preconditionsPlaceholder": "Örn. Sepette en az bir ürün olan, giriş yapmış kullanıcı",
    "removeStep": "Adımı sil",
    "revision": "Revizyon {{n}}",
    "routeHint": "Adım sonunda açılması gereken sayfa, örn. /checkout/success veya /orders/:id",
    "routeMustStart": "Adres / ile başlamalı.",
    "saved": "Senaryo kaydedildi.",
    "steps": "Adımlar",
    "stepsHint": "Her adım tek bir işlem ve gözlemlenebilir bir beklenen sonuç içermeli. Sürükleyerek sıralayabilirsiniz.",
    "suite": "Grup",
    "title": "Başlık"
  },
  "knownIssues": {
    "active": "Aktif",
    "activeLabel": "Aktif (bu hata hâlâ uygulamada)",
    "affectedCases": "{{count}} senaryo",
    "deleteTitle": "Bilinen hata silinsin mi?",
    "dialogHint": "Aktif bir bilinen hatanın etkilediği senaryo \"Geçti\" olarak işaretlenirse, çalıştırma şüpheli sayılır.",
    "edit": "Bilinen hatayı düzenle",
    "emptyBody": "Uygulamada bildiğiniz bir hata varsa ekleyin: o senaryoyu geçti diye işaretleyen test uzmanı adımları gerçekten yapmamış olabilir.",
    "emptyTitle": "Kayıtlı bilinen hata yok",
    "inactive": "Pasif",
    "new": "Bilinen hata ekle",
    "noCases": "Bağlı senaryo yok",
    "subtitle": "Kasıtlı \"tuzak\" kontroller: bilinen bir hatayı göremeyen test, gerçekten yapılmamış olabilir.",
    "title": "Bilinen hatalar",
    "titleLabel": "Hata başlığı"
  },
  "cycles": {
    "bugs": "Bug",
    "community": "Topluluk",
    "confidence": "Güven",
    "due": "Bitiş:",
    "empty": "Henüz döngü yok.",
    "emptyBody": "Bir döngü; seçili senaryoların bir topluluğa, belirli bir sürüm ve tarih aralığı için dağıtılmasıdır.",
    "emptyTitle": "Henüz test döngüsü yok",
    "name": "Döngü",
    "new": "Yeni döngü",
    "notStarted": "Başlamadı",
    "progress": "İlerleme",
    "status": "Durum",
    "subtitle": "Her döngü bir sürümün belirli bir test ekibi tarafından test edilmesidir.",
    "title": "Test döngüleri"
  },
  "cycle": {
    "progressLabel": "{{done}}/{{total}} görev tamamlandı"
  },
  "cycleStatus": {
    "Active": "Aktif",
    "Closed": "Kapandı",
    "Draft": "Taslak"
  },
  "distribution": {
    "EveryoneRunsAll": "Herkes tüm senaryoları",
    "NTestersPerCase": "Senaryo başına N kişi"
  },
  "deviceKind": {
    "Desktop": "Masaüstü",
    "Phone": "Telefon",
    "Tablet": "Tablet"
  },
  "wizard": {
    "activateNote": "Etkinleştirdiğinizde görevler oluşturulur ve test uzmanlarına bildirilir; sonrasında senaryo listesi değiştirilemez.",
    "activateNoteMarketplace": "Yayınladığınızda ilan iş ilanlarında görünür. Senaryo listesi sonradan değiştirilemez.",
    "activated": "Döngü başladı: {{count}} görev oluşturuldu.",
    "activeCycles": "{{count}} aktif döngü",
    "addEnvironment": "Ortam ekle",
    "allowExploratory": "Serbest teste izin ver",
    "allowExploratoryHint": "Test uzmanları senaryoların dışında, belirli bir amaçla serbest test oturumu açıp bug ve yeni senaryo önerebilir.",
    "any": "Fark etmez",
    "anyDevice": "Herhangi bir cihaz",
    "appVersion": "Uygulama sürümü",
    "applyBy": "Son başvuru",
    "applyByOrder": "Son başvuru bitiş tarihinden önce olmalı.",
    "casesHint": "Aktif {{count}} senaryo arasından seçin.",
    "casesSelected": "{{count}} senaryo seçildi",
    "categories": "Kategori",
    "categoriesHint": "Test edilecek ürünün türü. İlan, iş ilanlarında bu kategorilerle bulunur. En fazla 3 seçin.",
    "categoriesRequired": "En az bir kategori seçin.",
    "claimHours": "Teslim süresi (saat)",
    "claimHoursHint": "Bu sürede teslim edilmeyen görev havuza döner.",
    "communityHint": "Yönettiğiniz topluluklar ve organizasyonunuza partner koduyla bağlanan topluluklar.",
    "costEstimate": "Tahmini en yüksek tutar",
    "costEstimateHint": "testler ve sabit ücret, %{{fee}} platform ücreti dahil; bug ödülleri hariç",
    "distribution": "Dağıtım",
    "distributionHint": {
      "Applications": "Kabul ettiğiniz her katılımcı bütün senaryoları çalıştırır. Ekiplerde görevler liderine gider, lider üyelerine dağıtır.",
      "EveryoneRunsAll": "Topluluktaki her aktif test uzmanı seçilen tüm senaryoları çalıştırır.",
      "NTestersPerCase": "Her senaryo, en az görevi olan N test uzmanına verilir; ortam matrisi dengeli dağıtılır.",
      "OpenPool": "Her senaryo için belirlediğiniz sayıda çalıştırma açılır; uygun test uzmanları bunları sırayla alır."
    },
    "draftSaved": "Taslak kaydedildi.",
    "dueAfterStart": "Bitiş tarihi başlangıçtan sonra olmalı.",
    "dueAt": "Bitiş",
    "dueAtHint": "Bu tarihten sonra başlanmamış görevler süresi dolmuş sayılır.",
    "editTitle": "Döngüyü düzenle",
    "envBrowser": "Tarayıcı",
    "envDevice": "Cihaz",
    "envLabel": "Etiket",
    "envOs": "İşletim sistemi",
    "envUnique": "Ortam etiketleri benzersiz olmalı.",
    "environments": "Ortam matrisi",
    "environmentsHint": "Testlerin hangi cihaz/tarayıcılarda yapılmasını istiyorsunuz? Görevler bu ortamlara dağıtılır.",
    "escrow": "Ödeme güvencesi",
    "escrowAmount": "Ayrılacak tutar",
    "escrowBalance": "Kullanılabilir bakiye: {{available}}.",
    "escrowHint": "Bütçeyi bakiyenizden önden ayırırsanız ilanda “Ödeme güvencede” yazar; onaylanan çalışmalar bu tutardan ödenir, artan kısım iş bitince size döner.",
    "escrowOn": "Bütçeyi bakiyeden önden ayır",
    "escrowOnPublish": "yayınlanınca bakiyeden ayrılır",
    "escrowShort": "bakiye yetersiz (kullanılabilir {{available}}); yayınlamadan önce yükleyin",
    "escrowTopUp": "Bakiye yükle",
    "escrowUseEstimate": "Tahmini kullan ({{amount}})",
    "estimate": "Oluşacak görev",
    "estimateOpen": "Kabul ettiğiniz katılımcı sayısına bağlı",
    "estimateValue": "≈ {{count}} görev",
    "goToCases": "Senaryolara git",
    "instructions": "Test uzmanlarına notlar",
    "instructionsHint": "Test hesabı bilgileri, kapsam dışı alanlar, dikkat edilecek noktalar…",
    "languages": "Diller",
    "languagesHint": "Virgülle: tr, en. Boş = şart yok.",
    "listing": "İlan",
    "listingHint": "Test uzmanlarının iş ilanlarında gördüğü bilgiler.",
    "maxOpenClaims": "Kişi başına açık görev",
    "maxOpenClaimsHint": "Kimse görevleri biriktiremesin.",
    "maxParticipants": "Kontenjan",
    "maxParticipantsHint": "Kabul edeceğiniz en fazla katılımcı (boş = sınırsız).",
    "members": "{{count}} üye",
    "minLevelHint": "Ekipte en az bir üyenin bu seviyede olması yeter.",
    "minReputation": "En düşük itibar puanı",
    "moneyError": "Tutarı 1250 ya da 1250,50 biçiminde girin.",
    "name": "Döngü adı",
    "namePlaceholder": "Örn. Sürüm 2.4 kabul testi",
    "noActiveCases": "Bu projede aktif senaryo yok.",
    "noCommunities": "Kullanılabilir topluluk yok",
    "noCommunitiesBody": "Bir topluluk oluşturun ya da organizasyon ayarlarından partner kodu ile bir topluluk bağlayın.",
    "noEnvironments": "Ortam belirtilmedi; test uzmanları kendi cihazlarında test eder.",
    "noEnvironmentsShort": "Ortam kısıtı yok",
    "notDraft": "Bu döngü artık taslak değil, düzenlenemez.",
    "openBoard": "Döngü panosunu aç",
    "ownCommunities": "Topluluklarınız",
    "pickCases": "En az bir senaryo seçin.",
    "pickCommunity": "Bir topluluk ya da ilan türü seçin.",
    "price": {
      "bugCritical": "Kritik bug",
      "bugMajor": "Büyük bug",
      "bugMinor": "Küçük bug",
      "bugTrivial": "Önemsiz bug",
      "fixedFee": "Sabit ücret (katılımcı başına)",
      "perAcceptedRun": "Kabul edilen test başına"
    },
    "pricing": "Ücret",
    "pricingHint": "Test uzmanının eline geçecek tutarlar. %{{fee}} platform ücreti size ayrıca yansıtılır.",
    "pricingHintCommunity": "İsteğe bağlı: topluluk üyelerine ödeme yapacaksanız girin (%{{fee}} platform ücreti eklenir). Boş bırakırsanız ücretsizdir.",
    "pricingRequired": "İlan için en az bir ücret girin.",
    "published": "İlan yayında.",
    "rangeError": "Geçerli bir sayı girin.",
    "recording": "Kayıt yöntemi",
    "requireMatchingDevice": "Ortamlara uyan cihaz şartı",
    "requireMatchingDeviceHint": "Test uzmanının (ya da ekipten birinin) ortam listesindeki cihazlardan birine sahip olması gerekir.",
    "requirements": "Koşullar",
    "requirementsHint": "Koşulları sağlamayanlar başvuramaz ve görev alamaz.",
    "reviewApplications": "Her katılımcı tüm senaryolar · kontenjan {{count}}",
    "reviewOpenPool": "Açık havuz · senaryo başına {{count}} çalıştırma",
    "runsPerCase": "Senaryo başına çalıştırma",
    "saveAndActivate": "Kaydet ve başlat",
    "saveAndPublish": "Kaydet ve yayınla",
    "saveDraft": "Taslak olarak kaydet",
    "selectAll": "Tümünü seç",
    "sourceBody": {
      "Applications": "İlan açın; freelance test uzmanları ve ekipler başvursun, siz seçin.",
      "OpenPool": "Uygun olan herkes boş görevleri ilk gelen alır; başvuru beklemezsiniz."
    },
    "sourceHint": "İşi kendi topluluğunuza verin ya da freelance test uzmanlarına ilan olarak açın.",
    "startsAt": "Başlangıç",
    "startsAtHint": "Boş bırakılırsa döngü başlatıldığı anda açılır.",
    "step": {
      "basics": "Temel bilgiler",
      "cases": "Senaryolar",
      "community": "Test uzmanları",
      "distribution": "Dağıtım",
      "pricing": "Ücret ve koşullar",
      "review": "Özet",
      "schedule": "Takvim"
    },
    "stepCount": "{{count}} adım",
    "steps": "Sihirbaz adımları",
    "subtitle": "Senaryoları seçin, test ekibini belirleyin ve görevleri dağıtın.",
    "summary": "İlan açıklaması",
    "summaryHint": "Herkese açıktır. Uygulama adresi, talimatlar ve test hesapları yalnızca kabul edilenlere gösterilir.",
    "summaryPlaceholder": "Örn. Mobil ödeme akışını gerçek iPhone ve Android cihazlarda test edecek 4 kişi arıyoruz.",
    "targetUrl": "Test edilecek adres",
    "targetUrlHint": "Test uzmanları uygulamayı bu adresten, kayıt bağlantısıyla açar.",
    "testersPerCase": "Senaryo başına kişi",
    "testersPerCaseRange": "1 ile 50 arasında olmalı.",
    "title": "Yeni test döngüsü",
    "visibility": "Kimler görsün",
    "visibilityHint": {
      "InviteOnly": "Yalnızca davet ettikleriniz görür ve katılabilir.",
      "Public": "İlan bütün test uzmanlarına görünür."
    },
    "appLink": "Uygulama bağlantısı",
    "appLinkHint": "Uygulamanın kendi adresi (ör. demoshop://open) ya da https bağlantısı (mağaza sayfası, App Link). SDK'lı işlerde test uzmanının telefonu uygulamayı bu bağlantıyla açar.",
    "confidential": "Gizli iş: gizlilik sözleşmesi (NDA) ve filigran",
    "confidentialHint": "Test uzmanları senaryoları, talimatları ve uygulama adresini sözleşmeyi kabul ettikten sonra görür. Test ekranı, test edilen uygulama (SDK ile) ve inceleme sayfaları görüntüleyen kişinin adı ve koduyla filigranlanır.",
    "ndaText": "Gizlilik sözleşmesi metni",
    "ndaTextHint": "Boş bırakırsanız şirketinizin ve işin adıyla hazır bir metin kullanılır. Yayınlandıktan sonra değiştirilemez.",
    "ndaPlaceholder": "Boş bırakılırsa hazır metin kullanılır.",
    "ndaShort": "Sözleşme en az 50 karakter olmalı (ya da boş bırakın).",
    "confidentialShort": "Gizlilik",
    "confidentialOwnText": "Gizli iş · kendi sözleşme metniniz",
    "confidentialDefaultText": "Gizli iş · hazır sözleşme metni",
    "pricingHintNoFee": "Test uzmanının eline geçecek tutarlar. Üzerine komisyon eklenmez.",
    "pricingHintCommunityNoFee": "İsteğe bağlı: topluluk üyelerine ödeme yapacaksanız girin. Boş bırakırsanız ücretsizdir.",
    "costEstimateHintNoFee": "testler ve sabit ücret; bug ödülleri hariç"
  },
  "board": {
    "activate": "Döngüyü başlat",
    "billing": "Ödemeler",
    "boardTab": "Pano",
    "charter": "Amaç",
    "close": "Döngüyü kapat",
    "closeBody": "Başlanmamış görevler süresi dolmuş sayılır, devam eden kayıtlar durur. Teslim edilmiş çalıştırmaları incelemeye devam edebilirsiniz.",
    "closeBodyEscrow": "Açık görevler sona erer. Onaylanmış çalışmaların hakedişi bu işe ayrılan bütçeden hemen ödenir; kalan tutar 14 gün (itiraz süresi) sonra bakiyenize döner.",
    "closeBodyPaid": "Açık görevler sona erer. Sabit ücret, kabul edilmiş testi olan katılımcılara yazılır; ardından Ödemeler sayfasından hakediş oluşturabilirsiniz.",
    "closeTitle": "Döngü kapatılsın mı?",
    "empty": "Bu döngüde henüz görev yok.",
    "exploratory": "Serbest test oturumları",
    "exploratoryHint": "Test uzmanlarının senaryo dışında açtığı oturumlar.",
    "live": {
      "connected": "Canlı",
      "connecting": "Bağlanıyor…",
      "disconnected": "Canlı bağlantı yok",
      "reconnecting": "Yeniden bağlanıyor…"
    },
    "noExploratory": "Henüz serbest test oturumu yok.",
    "participantsTab": "Katılımcılar",
    "publish": "Yayınla",
    "questionsTab": "Sorular",
    "receiving": "Şu anda kayıt alınıyor",
    "report": "Rapor",
    "reviewQueue": "İnceleme kuyruğu",
    "started": "Başladı",
    "state": "Durum",
    "tabs": "Döngü sekmeleri",
    "target": "Hedef ortam: {{env}}",
    "tester": "Test uzmanı",
    "viewListing": "İlanı gör"
  },
  "assignmentStatus": {
    "Accepted": "Kabul edildi",
    "Assigned": "Atandı",
    "Expired": "Süresi doldu",
    "InProgress": "Devam ediyor",
    "Rejected": "Reddedildi",
    "Submitted": "Teslim edildi"
  },
  "executionStatus": {
    "Abandoned": "Yarıda bırakıldı",
    "InProgress": "Devam ediyor",
    "Submitted": "Teslim edildi"
  },
  "executionKind": {
    "Exploratory": "Serbest",
    "Scripted": "Senaryolu"
  },
  "outcome": {
    "Blocked": "Engellendi",
    "Failed": "Başarısız",
    "Passed": "Geçti",
    "none": "Sonuç yok"
  },
  "stepStatus": {
    "Blocked": "Engellendi",
    "Failed": "Başarısız",
    "NotRun": "Yapılmadı",
    "Passed": "Geçti",
    "Skipped": "Atlandı"
  },
  "reviewStatus": {
    "Accepted": "Kabul edildi",
    "Pending": "İnceleme bekliyor",
    "Rejected": "Reddedildi"
  },
  "band": {
    "Check": "Kontrol et",
    "Suspicious": "Şüpheli",
    "Trusted": "Güvenilir",
    "none": "Puan yok",
    "pending": "Puan hesaplanıyor"
  },
  "confidence": {
    "scoreAria": "Güven puanı {{score}}, {{band}}"
  },
  "progress": {
    "accepted": "Kabul",
    "inProgress": "Devam eden",
    "rejected": "Ret",
    "submitted": "Teslim"
  },
  "reason": {
    "CheckpointMissing": {
      "description": "Adımın kontrol noktası (sayfa adresi veya olay) adım süresince kayıtta görülmedi.",
      "title": "Kontrol noktası yok"
    },
    "CopiedText": {
      "description": "Gerçekleşen sonuç metni başka bir çalıştırmadakiyle neredeyse aynı.",
      "title": "Kopya metin"
    },
    "DuplicateEvidence": {
      "description": "Aynı ya da çok benzer ekran görüntüsü başka bir çalıştırmada da kullanılmış.",
      "title": "Tekrarlanan kanıt"
    },
    "EnvironmentMismatch": {
      "description": "Beyan edilen cihaz/işletim sistemi/tarayıcı, SDK'nın algıladığıyla uyuşmuyor.",
      "title": "Ortam uyuşmazlığı"
    },
    "KnownIssuePassed": {
      "description": "Aktif bir bilinen hatanın etkilediği senaryo \"Geçti\" olarak işaretlendi.",
      "title": "Bilinen hata görülmedi"
    },
    "NoInteraction": {
      "description": "Adım süresince uygulamada tıklama veya veri girişi yok.",
      "title": "Etkileşim yok"
    },
    "NoRecording": {
      "description": "Çalıştırma boyunca uygulamadan hiç kayıt gelmedi.",
      "title": "Kayıt yok"
    },
    "StepTooFast": {
      "description": "Adım, senaryoda belirtilen en kısa süreden hızlı tamamlandı.",
      "title": "Çok hızlı"
    },
    "NoVideo": {
      "description": "Ekran videosuyla yapılan bir işte video yüklenmedi.",
      "title": "Ekran kaydı yok"
    },
    "ShortVideo": {
      "description": "Ekran kaydı, testteki adımlar için fazla kısa.",
      "title": "Kısa video"
    },
    "DuplicateVideo": {
      "description": "Aynı video dosyası başka bir çalıştırma için de yüklendi.",
      "title": "Aynı video"
    }
  },
  "reviewQueue": {
    "allCycles": "Tüm döngüler",
    "band": "Güven bandı",
    "cycle": "Döngü",
    "emptyBody": "Yeni teslimler geldiğinde en düşük puanlılar en üstte listelenir.",
    "emptyTitle": "İnceleme bekleyen çalıştırma yok",
    "execution": "Çalıştırma",
    "outcome": "Sonuç",
    "reasons": "Bulgu",
    "score": "Puan",
    "submitted": "Teslim",
    "subtitle": "Teslim edilen çalıştırmalar, en şüpheliden başlayarak.",
    "tester": "Test uzmanı",
    "title": "İnceleme kuyruğu"
  },
  "review": {
    "accept": "Kabul et",
    "accepted": "Çalıştırma kabul edildi.",
    "actual": "Gerçekleşen",
    "backToBoard": "Döngü panosu",
    "charter": "Amaç",
    "checkpointMatched": "görüldü",
    "checkpointMissing": "görülmedi",
    "checkpointUnknown": "değerlendirilmedi",
    "confidence": "Güven puanı",
    "decidedAs": "Karar: {{decision}}",
    "declared": "Beyan edilen ortam",
    "detected": "Algılanan",
    "deviceTitle": "{{name}} adlı test uzmanının cihazı",
    "duration": "Adım süresi",
    "events": "Olaylar ({{count}})",
    "expected": "Beklenen",
    "exploratoryHint": "Serbest test oturumu: adım yok. Notları, kanıtları ve kaydı inceleyin.",
    "filter": {
      "all": "Tümü",
      "important": "Önemli"
    },
    "keys": {
      "accept": "Kabul et",
      "help": "Kısayolları göster",
      "next": "Sonraki çalıştırma",
      "play": "Oynat / duraklat",
      "previous": "Önceki çalıştırma",
      "reject": "Reddet (not zorunlu)",
      "steps": "Adımlar arasında gezin",
      "title": "Klavye kısayolları"
    },
    "legendCheckpoint": "Kontrol noktası",
    "legendError": "Hata",
    "legendNavigation": "Sayfa geçişi",
    "loadingRecording": "Kayıt yükleniyor…",
    "next": "Sonraki",
    "noDetection": "SDK bağlanmadı",
    "noDeviceDetails": "Ayrıntılı cihaz bilgisi yok",
    "noDeviceDetailsHint": "Ayrıntılı cihaz bilgileri (işlemci, bellek, ekran kartı…) bu test için mevcut değil.",
    "noEvents": "Gösterilecek olay yok.",
    "noReasons": "Puanı düşüren bir bulgu yok.",
    "noRecordingBody": "Test uzmanı uygulamayı TestRome bağlantısıyla açmadı ya da uygulamada SDK yüklü değil. Adımların gerçekten yapıldığını kayıt olmadan doğrulayamazsınız.",
    "noRecordingTitle": "Bu çalıştırmanın kaydı yok",
    "noVideoBody": "Test uzmanı bu çalıştırma için ekran kaydı yüklemedi.",
    "noVideoTitle": "Ekran kaydı yok",
    "notDeclared": "Beyan yok",
    "notMarked": "işaretsiz",
    "notSubmitted": "Çalıştırma henüz teslim edilmedi.",
    "note": "İnceleme notu",
    "notePlaceholder": "Not (isteğe bağlı)",
    "notes": "Notlar",
    "pause": "Duraklat",
    "play": "Oynat",
    "previous": "Önceki",
    "recordedByVideo": "Ekran kaydıyla (SDK yok)",
    "reject": "Reddet",
    "rejectNotePlaceholder": "Neden reddettiğinizi yazın; test uzmanı bu notu görür.",
    "rejected": "Çalıştırma reddedildi.",
    "replayFailed": "Kayıt oynatılamadı.",
    "rescore": "Yeniden puanla",
    "scorePending": "Puan hesaplanıyor; birkaç saniye içinde güncellenir.",
    "screenVideo": "Test uzmanının ekran kaydı",
    "screenVideoMeta": "{{name}} · {{size}} · {{duration}}",
    "skipInactive": "Boşlukları atla",
    "speed": "Hız",
    "stepN": "{{n}}. adım",
    "submittedAt": "Teslim: {{at}}",
    "tabs": {
      "evidence": "Kanıt",
      "label": "İnceleme bölümleri",
      "replay": "Kayıt",
      "steps": "Adımlar",
      "appFlow": "Uygulama akışı"
    },
    "timeline": "Kayıt zaman çizelgesi",
    "videoSteps": "Adımların videodaki yeri",
    "app": {
      "title": "Uygulamada izlenen yol",
      "screens_one": "{{count}} ekran",
      "screens_other": "{{count}} ekran",
      "taps_one": "{{count}} dokunma",
      "taps_other": "{{count}} dokunma",
      "problems_one": "{{count}} hata",
      "problems_other": "{{count}} hata",
      "crashed": "Uygulama çöktü",
      "beforeFirstScreen": "İlk ekrandan önce",
      "emptyTitle": "Uygulamadan kayıt gelmedi",
      "emptyBody": "Uygulama bu teste hiç bağlanmadı (QR kod ya da eşleştirme kodu kullanılmadı) ya da SDK uygulamaya eklenmemiş. Güven puanı bunu dikkate alır."
    }
  },
  "bugs": {
    "allCycles": "Tüm döngüler",
    "allSeverities": "Tüm önem dereceleri",
    "allStatuses": "Tüm durumlar",
    "created": "Bildirildi",
    "cycle": "Döngü",
    "emptyBody": "Test uzmanlarının bildirdiği buglar burada listelenir.",
    "emptyTitle": "Henüz bug bildirilmedi",
    "noMatchBody": "Filtreleri değiştirin ya da temizleyin.",
    "noMatchTitle": "Eşleşen bug yok",
    "reporter": "Bildiren",
    "searchPlaceholder": "Bug başlığında ara…",
    "severity": "Önem",
    "status": "Durum",
    "subtitle": "Bildirilen buglar; her biri kaydın ilgili anına bağlıdır.",
    "title": "Buglar",
    "titleCol": "Başlık"
  },
  "severity": {
    "Critical": "Kritik",
    "Major": "Büyük",
    "Minor": "Küçük",
    "Trivial": "Önemsiz"
  },
  "bugStatus": {
    "Confirmed": "Doğrulandı",
    "Duplicate": "Kopya",
    "Fixed": "Düzeltildi",
    "New": "Yeni",
    "Rejected": "Reddedildi"
  },
  "bugDetail": {
    "actual": "Gerçekleşen sonuç",
    "atStep": "Bildirildiği adım: {{n}}",
    "attachments": "Ekler",
    "decision": "Karar",
    "duplicateHint": "Benzer başlıklı buglar listelenir; aramayı değiştirebilirsiniz.",
    "duplicateOf": "Hangi bug'ın kopyası?",
    "duplicates": "Kopyaları ({{count}})",
    "environment": "Ortam",
    "expected": "Beklenen sonuç",
    "isDuplicate": "Bu bug başka bir kaydın kopyası:",
    "lastTriage": "Son değerlendirme: {{name}}, {{at}}",
    "measured": "Ölçülen cihaz",
    "noCandidates": "Benzer bug bulunamadı.",
    "noEnvironment": "Ortam bilgisi yok",
    "note": "Not",
    "notePlaceholder": "Bildirene iletilecek not (isteğe bağlı)",
    "original": "Asıl kaydı aç",
    "reportedBy": "{{name}} bildirdi · {{at}}",
    "saveTriage": "Kararı kaydet",
    "steps": "Tekrar adımları",
    "triage": "Değerlendirme",
    "triageHint": "Doğrulanan buglar bildirene itibar puanı kazandırır.",
    "triageNote": "Değerlendirme notu",
    "triaged": "Karar kaydedildi.",
    "watch": "Kaydı izle",
    "watchAt": "Kaydı {{at}} anından izle"
  },
  "proposals": {
    "approve": "Onayla",
    "approveHint": "Onaylanan senaryo aktif olur ve sonraki döngülerde seçilebilir.",
    "approveTitle": "\"{{title}}\" onaylansın mı?",
    "approved": "{{key}} onaylandı ve aktif senaryolara eklendi.",
    "by": "{{name}} önerdi",
    "emptyBody": "Test uzmanları serbest test sırasında yeni senaryolar önerebilir; öneriler burada onayınızı bekler.",
    "emptyRejected": "Reddedilmiş öneri yok",
    "emptyTitle": "Bekleyen öneri yok",
    "filter": "Öneri durumu",
    "noSuites": "Önce bir senaryo grubu oluşturun.",
    "pending": "Bekleyen",
    "reject": "Reddet",
    "rejectNote": "Ret gerekçesi",
    "rejectNoteHint": "Öneriyi yapan test uzmanı bu notu görür.",
    "rejectTitle": "\"{{title}}\" reddedilsin mi?",
    "rejected": "Öneri reddedildi.",
    "rejectedTab": "Reddedilen",
    "rejectionNote": "Ret gerekçesi",
    "subtitle": "Test uzmanlarının önerdiği yeni test senaryoları.",
    "title": "Senaryo önerileri"
  },
  "projectSettings": {
    "defaults": "Varsayılanlara dön",
    "general": "Genel",
    "installMode": "Kurulum yöntemi",
    "integration": "Kayıt SDK'sı",
    "integrationHint": "Uygulamanıza bir kez eklenir; ziyaretçileriniz için hiçbir şey kaydetmez.",
    "note1": "SDK yalnızca sayfa TestRome'un verdiği bağlantıyla (#tp=…) açıldığında etkinleşir; normal kullanıcılar etkilenmez.",
    "note2": "Parola alanları ve hassas girişler kayıtta maskelenir.",
    "note3": "Kontrol noktası olayları için önemli işlemlerden sonra checkpoint('ad') çağırın.",
    "penalty": "Ceza puanı",
    "perStep": "/ adım",
    "publicKey": "Proje anahtarı",
    "readOnly": "Bu ayarları yalnızca sahip ve yöneticiler değiştirebilir.",
    "retention": "Kayıt saklama süresi (gün)",
    "retentionHint": "Bu süreden eski oturum kayıtları otomatik silinir.",
    "rotate": "Anahtarı yenile",
    "rotateBody": "Eski anahtarla gelen kayıtlar reddedilir. Uygulamanızdaki anahtarı da güncellemeniz gerekir.",
    "rotateTitle": "Proje anahtarı yenilensin mi?",
    "rotated": "Yeni anahtar oluşturuldu.",
    "rule": "Kural",
    "scoring": "Güven puanı kuralları",
    "scoringApplies": "Değişiklikler yeni puanlamalara uygulanır; mevcutlar için \"Yeniden puanla\" kullanın.",
    "scoringHint": "Puan 100'den başlar; her bulgu kendi cezası kadar düşürür. 80+ güvenilir, 50–79 kontrol edilmeli, 50 altı şüpheli.",
    "scoringSaved": "Puanlama kuralları kaydedildi.",
    "snippetCheckpoint": "Önemli bir iş adımı tamamlandığında (senaryodaki \"Olay\" kontrol noktası):",
    "snippetInit": "Uygulama başlarken, ilk render'dan önce:",
    "title": "Proje ayarları",
    "androidNote1": "SDK yalnızca uygulama TestRome'un verdiği bağlantıyla (#tp=…) açıldığında ya da test uzmanı eşleştirme kodunu yazdığında kayda başlar; normal kullanıcılar etkilenmez.",
    "androidNote2": "Ekranlar, dokunmalar (yalnızca öğe adı; yazılan metin değil), ağ istekleri, hatalar ve çökmeler kaydedilir. Parola alanlarının içeriği hiç okunmaz.",
    "androidNote3": "Emülatörde bilgisayarın adresi 10.0.2.2'dir; gerçek telefonda bilgisayarın ağ adresini kullanın (start.command --lan).",
    "androidInit": "Uygulama başlarken (Application.onCreate):",
    "androidManifestComment": "Telefon sayfasındaki \"Uygulamayı aç\" düğmesi uygulamayı bu bağlantıyla açar; aynı adresi işin \"Uygulama bağlantısı\" alanına yazın.",
    "iosNote1": "SDK yalnızca uygulama TestRome bağlantısıyla açıldığında ya da eşleştirme koduyla bağlandığında kayda başlar; normal kullanıcılar etkilenmez.",
    "iosNote2": "Ekranlar UIKit ekran adlarından kendiliğinden gelir (LoginViewController → /login); SwiftUI ekranlarına .testRomeScreen(\"/profil\") ekleyin.",
    "iosNote3": "Yazılanlar ve parolalar kaydedilmez; dokunulan öğenin accessibilityIdentifier'ı ve görünen etiketi kaydedilir.",
    "iosInit": "Uygulama açılırken (App init ya da didFinishLaunching)",
    "iosLink": "TestRome bağlantısı (Info.plist → URL Types'a uygulamanın şemasını ekleyin)"
  },
  "communities": {
    "activeCycles": "Aktif döngü",
    "emptyBody": "Bir test topluluğu kurun, test uzmanlarını davet edin ve müşterilerle partner kodu üzerinden eşleşin.",
    "emptyTitle": "Henüz bir topluluğun yok",
    "isPublic": "Freelance ekip olarak listele",
    "isPublicHint": "Ekipler sayfasında görünür; test uzmanları katılma isteği gönderebilir, ekip adına iş alabilirsiniz.",
    "members": "Üye",
    "name": "Topluluk adı",
    "new": "Yeni topluluk",
    "newHint": "Topluluğu kuran kişi lider olur.",
    "publicBadge": "Herkese açık",
    "subtitle": "Üyesi olduğun test toplulukları.",
    "title": "Topluluklar"
  },
  "community": {
    "accepted": "Kabul edilen",
    "activeCycles": "{{count}} aktif döngü",
    "activeMembers": "{{count}} aktif üye",
    "approve": "Onayla",
    "confirmedBugs": "Doğrulanan bug",
    "copyLink": "Bağlantıyı kopyala",
    "createInvite": "Davet oluştur",
    "decline": "Reddet",
    "details": "Topluluk bilgileri",
    "devices": "Cihazlar",
    "emptyUnlimited": "Boş = sınırsız",
    "expired": "süresi doldu",
    "expires": "{{at}} sona erer",
    "expiresInDays": "Geçerlilik (gün)",
    "inviteCreated": "Davet oluşturuldu ve bağlantı panoya kopyalandı.",
    "invitesTab": "Davetler",
    "joined": "{{at}} katıldı",
    "leaderboardTab": "Sıralama",
    "logsTab": "Kayıtlar",
    "maxUses": "Kullanım sınırı",
    "member": "Üye",
    "memberUpdated": "Üye güncellendi.",
    "membersTab": "Üyeler",
    "newInvite": "Yeni davet bağlantısı",
    "newInviteHint": "Bağlantıyı alan herkes, sınır dolana kadar topluluğa katılabilir.",
    "noDevices": "Cihaz eklenmemiş",
    "noExpiry": "süresiz",
    "noInvites": "Aktif davet bağlantısı yok",
    "noLeaderboard": "Henüz puan kazanan yok",
    "noPartners": "Henüz bağlı müşteri yok. Partner kodunu müşterinizle paylaşın.",
    "open": "Açık görev",
    "partnerCode": "Partner kodu",
    "partnerCodeHint": "Müşteri bu kodu organizasyon ayarlarına girerek topluluğunuza iş verebilir.",
    "partners": "Bağlı müşteriler",
    "points": "Puan",
    "regenerate": "Kodu yenile",
    "regenerateBody": "Eski kod geçersiz olur; mevcut bağlantılar etkilenmez.",
    "regenerateTitle": "Partner kodu yenilensin mi?",
    "reputation": "İtibar",
    "requests": "Katılma istekleri ({{count}})",
    "requestsHint": "Onayladığınız kişiler ekibe test uzmanı olarak katılır.",
    "revoke": "İptal et",
    "revokeBody": "Bu bağlantı ile artık katılım yapılamaz.",
    "revokeTitle": "Davet iptal edilsin mi?",
    "role": "Rol",
    "settingsTab": "Ayarlar",
    "showRemoved": "Çıkarılanları göster ({{count}})",
    "status": "Durum",
    "tabs": "Topluluk bölümleri",
    "uses": "{{uses}}/{{max}} kullanım",
    "workTab": "Ekip işleri"
  },
  "myAssignments": {
    "all": "Tümü",
    "allDone": "Bekleyen görevin yok",
    "allDoneBody": "Yeni bir döngüde görev aldığında burada görünecek.",
    "app": "Uygulama",
    "continue": "Devam et",
    "done": "Tamamlanan",
    "due": "Son tarih: {{at}}",
    "emptyBody": "Bir topluluğa katıldığında ve döngü başladığında görevlerin burada listelenir.",
    "emptyTitle": "Görev yok",
    "exploratory": "Serbest test",
    "filter": "Görev filtresi",
    "findJobs": "Yeni iş bul →",
    "instructions": "Müşterinin notları",
    "remaining": "{{count}} görev kaldı",
    "retry": "Yeniden çalıştır",
    "reviewNote": "İnceleme notu",
    "start": "Başla",
    "subtitle": "Sana atanan test senaryoları, döngülere göre.",
    "target": "Hedef: {{env}}",
    "teamNote": "{{team}} liderinin notu",
    "title": "Görevlerim",
    "todo": "Yapılacak"
  },
  "runner": {
    "abandoned": "Bu çalıştırma yarıda bırakıldı.",
    "actual": "Ne gördün?",
    "actualHint": "(Başarısız/engellendi için zorunlu)",
    "actualPlaceholder": "Uygulamada gerçekte olanı kısaca yaz…",
    "allDone": "Tüm adımlar tamamlandı. Kontrol edip teslim edebilirsin.",
    "backToAssignments": "Görevlerim",
    "bug": {
      "attach": "Dosya ekle",
      "contextAt": "Kayıttaki an: {{at}} · {{step}}",
      "created": "Bug #{{n}} bildirildi.",
      "noStep": "adım yok",
      "recordingNote": "Bug, kayıttaki bu ana bağlanır; inceleyen kişi doğrudan o noktadan izleyebilir.",
      "submit": "Bug bildir",
      "title": "Bug bildir",
      "titleLabel": "Kısa başlık",
      "titlePlaceholder": "Örn. İndirim kodu toplam tutarı değiştirmiyor"
    },
    "cannotStart": "Bu görev için yeni bir çalıştırma başlatılamaz.",
    "continue": "Kaldığın yerden devam et",
    "copyLink": "Bağlantıyı kopyala",
    "cycleNotActive": "Bu döngü aktif değil.",
    "devicesHint": "Sık kullandığın cihazları kaydet:",
    "elapsed": "Geçen süre",
    "environment": "Hangi cihazda test ediyorsun?",
    "evidence": {
      "add": "Ekran görüntüsü / video ekle",
      "paste": "ya da Ctrl+V ile yapıştır",
      "pasted": "Ekran görüntüsü eklendi.",
      "required": "{{kind}} gerekli",
      "title": "Kanıt",
      "tooLarge": "{{name}} çok büyük (en fazla 25 MB)."
    },
    "keysHint": "Kısayollar: 1 Geçti · 2 Başarısız · 3 Engellendi · 4 Atla · N/P adımlar · B bug",
    "keysHintExploratory": "Kısayollar: B bug · Ctrl+V ekran görüntüsü yapıştır",
    "native": {
      "notice": "Bu iş {{platform}} uygulamasının içindeki TestRome SDK'sıyla kaydedilir: ekranlar, dokunmalar, ağ istekleri, hatalar ve çökmeler. Teste başladıktan sonra uygulamayı QR kodla ya da eşleştirme koduyla bu teste bağlarsın.",
      "openOnPhone": "Telefonda aç",
      "pairingCode": "Eşleştirme kodu",
      "newCode": "Yeni kod",
      "typeCode": "Uygulamadaki TestRome düğmesine dokun ve bu kodu yaz:",
      "codeLabel": "Eşleştirme kodu {{code}}",
      "codeValid": "Tek kullanımlık · {{at}} saatine kadar geçerli",
      "codeExpired": "Kodun süresi doldu; yenisini al.",
      "receivingHint": "Uygulama bağlı, {{count}} olay alındı. Testi telefonda yap, sonuçları burada işaretle.",
      "waitingHint": "Uygulama bağlanınca kayıt kendiliğinden başlar.",
      "stalledHint": "Son olay {{at}} geldi. Uygulama kapandıysa yeniden aç; bağlantı kopmuşsa yeniden eşleştir.",
      "howInstall": "Test edilecek uygulamayı telefona ya da emülatöre kur.",
      "howConnect": "“Telefonda aç” ile QR kodu okut ya da uygulamadaki TestRome düğmesine eşleştirme kodunu yaz.",
      "howSteps": "Testi uygulamada yap; adımların sonucunu bu ekranda işaretle."
    },
    "openApp": "Uygulamayı aç",
    "otherDevice": "Başka bir cihaz",
    "otherDeviceHint": "Telefon veya tablette test edeceksen (QR kod ile açabilirsin)",
    "phone": {
      "fromPhone": "Telefondan yükle",
      "qrLabel": "Telefon bağlantısının QR kodu",
      "videoHint": "Telefonun kamerasıyla okut; açılan sayfadan ekran kaydını seç. Giriş yapman gerekmez, bağlantı yalnızca bu test için çalışır.",
      "appHint": "Telefonun kamerasıyla okut ve “Uygulamayı aç”a dokun; uygulama bu teste bağlanır. Giriş yapman gerekmez.",
      "validUntil": "{{at}} saatine kadar geçerli",
      "localOnly": "Bu sayfayı localhost adresinden açtın; telefon bu adrese ulaşamaz. TestRome'u start.command --lan ile başlatıp bilgisayarın ağ adresinden aç.",
      "creating": "Bağlantı hazırlanıyor…",
      "videoArrived": "Ekran kaydı telefondan geldi."
    },
    "problem": {
      "actualRequired": "Başarısız veya engellendi işaretlemeden önce ne gördüğünü yaz.",
      "evidenceRequired": "Bu adım için {{kind}} eklemelisin."
    },
    "propose": {
      "hint": "Bulduğun durumu tekrar edilebilir bir senaryoya dönüştür; müşteri onaylarsa ana senaryolara eklenir ve itibar puanı kazanırsın.",
      "sent": "Öneri gönderildi ({{key}}).",
      "submit": "Öneriyi gönder",
      "title": "Yeni senaryo öner"
    },
    "proposeCase": "Senaryo öner",
    "qr": "QR",
    "qrHint": "Telefonun kamerasıyla okut; uygulama kayıt bağlantısıyla açılır.",
    "recorded": "Kaydedilen sonuç: {{status}}",
    "recording": {
      "receiving": "Kayıt alınıyor",
      "receivingHint": "Uygulama bağlı, {{count}} olay alındı. Testi uygulamada yap, sonuçları burada işaretle.",
      "stalled": "Kayıt sinyali kesildi",
      "stalledHint": "Son olay {{at}} geldi. Uygulama sekmesi kapandıysa yeniden aç.",
      "waiting": "Uygulama henüz bağlanmadı",
      "waitingHint": "Uygulamayı bu ekrandaki düğmeyle aç; kendi açtığın sekme kaydedilmez."
    },
    "recordingNotice": "Uygulamayı buradan açtığında oturumun kaydedilir (tıklamalar, sayfa geçişleri, ekran). Parola alanları maskelenir. Kayıt yalnızca bu test için kullanılır.",
    "reportBug": "Bug",
    "start": "Testi başlat",
    "stepNav": "Adımlar",
    "stepOf": "Adım {{n}} / {{total}}",
    "stepTime": "Adımda geçen süre",
    "stepsLeft": "{{count}} adım kaldı",
    "submit": {
      "confirm": "Teslim et",
      "done": "Teslim edildi. Teşekkürler!",
      "exploratoryHint": "Notların ve kanıtların incelemeye gönderilecek.",
      "irreversible": "Teslimden sonra sonuçları değiştiremezsin; kayıt durur.",
      "notes": "Genel notlar",
      "notesPlaceholder": "İnceleyene iletmek istediğin bir şey var mı?",
      "scriptedHint": "Sonuçların ve oturum kaydın incelemeye gönderilecek.",
      "title": "Çalıştırmayı teslim et"
    },
    "submitAction": "Teslim et",
    "submitted": {
      "body": "{{at}} tarihinde teslim edildi.",
      "title": "Çalıştırma teslim edildi"
    },
    "targetHint": "Müşteri bu görev için {{env}} ortamını istiyor.",
    "thisBrowser": "Bu tarayıcı",
    "video": {
      "appLink": "Uygulamayı indir / aç",
      "clear": "{{order}}. adımın işaretini kaldır",
      "file": "Ekran kaydı dosyası",
      "goTo": "{{order}}. adımın başladığı yere git",
      "howExplore": "Uygulamayı aç ve serbestçe dene; bulduklarını not al.",
      "howStart": "Telefonunda ekran kaydını başlat (iPhone: Denetim Merkezi → Ekran Kaydı, Android: hızlı ayarlar → Ekran kaydı) ve “Kaydı başlattım”a bas.",
      "howSteps": "Uygulamayı aç, adımları sırayla yap ve her adımı burada işaretle.",
      "howUpload": "Bitince kaydı durdur ve videoyu buraya yükle (MP4, MOV ya da WebM, en fazla 500 MB).",
      "mark": "Adımları işaretle",
      "markHint": "Videoyu oynat; her adımın başladığı anda o adımın yanındaki “Burada başlıyor”a bas. İnceleyen kişi bu işaretlerle doğrudan o ana gider.",
      "markTitle": "Adımların videodaki yeri",
      "marked": "{{count}}/{{total}} adım videoda işaretli",
      "markersSaved": "Adım işaretleri kaydedildi.",
      "notMarked": "işaretsiz",
      "notVideo": "{{name}} bir video değil.",
      "notice": "Bu işte kayıt telefonunun ekran kaydıyla yapılır; uygulamaya SDK eklenmez. Testi başlatınca ekran kaydını aç, adımları yap, bitince videoyu yükle.",
      "player": "Ekran kaydı",
      "ready": "Ekran kaydı yüklendi · {{duration}}",
      "replace": "Değiştir",
      "started": "Kaydı başlattım",
      "startedAt": "Kayıt {{at}} başladı; adımların videodaki yeri buna göre önerilecek.",
      "startsHere": "Burada başlıyor",
      "stepCovered": "Bu adımın videosu ekran kaydından alınır; ayrıca dosya yüklemen gerekmez.",
      "steps": "Adımlar",
      "title": "Ekran kaydıyla test",
      "tooLarge": "{{name}} çok büyük; en fazla 500 MB yüklenebilir.",
      "upload": "Videoyu yükle",
      "uploaded": "Ekran kaydı yüklendi.",
      "uploading": "Video yükleniyor",
      "uploadingPercent": "Yükleniyor… %{{percent}}"
    }
  },
  "exploratory": {
    "charter": "Amaç (charter)",
    "charterHint": "Neyi, hangi açıdan keşfedeceksin? Örn. \"Sepet: aynı ürünü farklı varyantlarla ekleme\"",
    "charterPlaceholder": "Bu oturumda neyi araştıracaksın?",
    "cycle": "Döngü",
    "minutes": "{{count}} dk",
    "noCycles": "Serbest teste açık döngü yok",
    "noCyclesBody": "Müşteri bir döngüde serbest teste izin verdiğinde buradan oturum başlatabilirsin.",
    "notes": "Oturum notları",
    "notesPlaceholder": "Ne denedin, ne gözlemledin? Notlar otomatik kaydedilir.",
    "overTime": "Planlanan süre doldu; toparlayıp teslim edebilirsin.",
    "saveFailed": "Kaydedilemedi",
    "saved": "Kaydedildi",
    "saving": "Kaydediliyor…",
    "start": "Oturumu başlat",
    "subtitle": "Senaryo dışında, belirli bir amaçla zaman sınırlı keşif testi.",
    "timebox": "Süre",
    "title": "Serbest test oturumu"
  },
  "myBugs": {
    "emptyBody": "Test sırasında bulduğun hataları test ekranındaki Bug düğmesiyle bildirebilirsin.",
    "emptyTitle": "Henüz bug bildirmedin",
    "subtitle": "Bildirdiğin buglar ve müşterinin kararları.",
    "title": "Bildirdiğim buglar"
  },
  "reputation": {
    "emptyBody": "Kabul edilen çalıştırmalar ve doğrulanan buglar puan kazandırır.",
    "emptyTitle": "Henüz puan hareketi yok",
    "history": "Geçmiş",
    "rule": {
      "bugCritical": "Doğrulanan kritik bug",
      "bugMajor": "Doğrulanan büyük bug",
      "bugMinor": "Doğrulanan küçük bug",
      "bugRejected": "Reddedilen bug",
      "bugTrivial": "Doğrulanan önemsiz bug",
      "caseApproved": "Onaylanan senaryo önerisi",
      "executionAccepted": "Kabul edilen çalıştırma",
      "executionRejected": "Reddedilen çalıştırma"
    },
    "rules": "Puan kuralları",
    "subtitle": "Topluluk liderleri ve müşteriler görevleri dağıtırken itibarını dikkate alır.",
    "title": "İtibar puanım",
    "total": "Toplam puan"
  },
  "devices": {
    "add": "Cihaz ekle",
    "added": "Cihaz eklendi.",
    "browser": "Tarayıcı",
    "emptyBody": "Test için kullandığın cihazları ekle; görevler cihazlarına göre dağıtılabilir.",
    "emptyTitle": "Kayıtlı cihaz yok",
    "kind": "Cihaz türü",
    "model": "Model",
    "os": "İşletim sistemi",
    "osVersion": "Sürüm",
    "removeBody": "Bu cihaz listenden kaldırılır; geçmiş çalıştırmalar etkilenmez.",
    "removeTitle": "Cihaz silinsin mi?",
    "save": "Cihazı kaydet",
    "subtitle": "Test ettiğin cihazlar. Görev dağıtımında ortam matrisiyle eşleştirilir.",
    "title": "Cihazlarım"
  },
  "attachments": {
    "open": "{{name}} dosyasını aç"
  },
  "logs": {
    "action": {
      "account_updated": "profil bilgilerini güncelledi",
      "api_request": "işlem yaptı: {{method}} {{path}}",
      "assignment_expired": "süresi dolan görevi kapattı: {{subject}} · {{user}}",
      "auth_registered": "hesap oluşturdu",
      "auth_signed_in": "giriş yaptı",
      "auth_signed_out": "çıkış yaptı",
      "billing_info_updated": "fatura bilgilerini güncelledi",
      "bug_attachment_added": "buga dosya ekledi: {{fileName}} · {{subject}}",
      "bug_pushed": "bug'ı {{tool}} sistemine gönderdi: {{subject}} → {{externalKey}}",
      "bug_reported": "bug bildirdi: {{subject}} · {{severity}}",
      "bug_triaged": "bug durumunu değiştirdi: {{subject}} → {{status}}",
      "case_created": "test senaryosu oluşturdu: {{subject}}",
      "case_deleted": "test senaryosunu sildi: {{subject}}",
      "case_imported": "CSV'den {{count}} test senaryosu içe aktardı",
      "case_updated": "test senaryosunu düzenledi: {{subject}}",
      "community_created": "topluluk oluşturdu: {{subject}}",
      "community_invite_created": "davet bağlantısı oluşturdu: {{subject}} · {{role}}",
      "community_invite_revoked": "davet bağlantısını iptal etti: {{subject}}",
      "community_joined": "topluluğa katıldı: {{subject}}",
      "community_member_updated": "topluluk üyesini güncelledi: {{subject}} · {{role}} · {{memberStatus}}",
      "community_partner_code_regenerated": "ortaklık kodunu yeniledi: {{subject}}",
      "community_updated": "topluluk bilgilerini güncelledi: {{subject}}",
      "consent_recorded": "gizlilik onayını kaydetti",
      "cv_imported": "CV'sini PDF'ten doldurdu",
      "cv_updated": "CV'sini güncelledi",
      "cycle_activated": "test döngüsünü başlattı: {{subject}} · {{assignments}} görev",
      "cycle_closed": "test döngüsünü kapattı: {{subject}}",
      "cycle_created": "test döngüsü oluşturdu: {{subject}}",
      "cycle_updated": "test döngüsünü düzenledi: {{subject}}",
      "deposit_cancelled": "bakiye yüklemesini iptal etti: {{deposit}}",
      "deposit_completed": "kartla bakiye yüklendi: {{deposit}} · {{amount}} ₺",
      "deposit_confirmed": "havale ile bakiye yüklemesini onayladı: {{deposit}} · {{amount}} ₺",
      "deposit_created": "bakiye yüklemesi başlattı: {{deposit}} · {{amount}} ₺",
      "deposit_failed": "kartla bakiye yüklemesi tamamlanmadı: {{deposit}}",
      "deposit_rejected": "bakiye yüklemesini reddetti: {{deposit}}",
      "device_added": "cihaz ekledi: {{subject}}",
      "device_removed": "cihazı kaldırdı: {{subject}}",
      "escrow_released": "işin kalan bütçesini serbest bıraktı: {{subject}}",
      "escrow_reserved": "işe bütçe ayırdı: {{subject}} · {{amount}} ₺",
      "evidence_uploaded": "kanıt yükledi: {{fileName}} · {{subject}}",
      "execution_app_opened": "uygulamayı telefonda açtı · {{subject}}",
      "execution_notes_saved": "test notlarını kaydetti · {{subject}}",
      "execution_pairing_code_created": "uygulama için eşleştirme kodu aldı · {{subject}}",
      "execution_phone_link_created": "telefon bağlantısı (QR) oluşturdu · {{subject}}",
      "execution_relaunched": "testi yeniden açtı: {{subject}}",
      "execution_resumed": "teste kaldığı yerden devam etti: {{subject}}",
      "execution_scored": "güven puanını hesapladı: {{subject}} · {{band}} {{score}}",
      "execution_started": "teste başladı: {{subject}}",
      "execution_submitted": "testi gönderdi: {{outcome}} · {{subject}}",
      "execution_video_marked": "adımları videoda işaretledi · {{subject}}",
      "execution_video_started": "ekran kaydını başlattı · {{subject}}",
      "execution_video_uploaded": "ekran kaydı yükledi: {{fileName}} · {{subject}}",
      "exploratory_started": "serbest teste başladı: {{subject}}",
      "fraud_reviewed": "bağlantılı hesaplar hakkında karar verdi",
      "integration_removed": "{{tool}} entegrasyonunu kaldırdı",
      "integration_saved": "{{tool}} entegrasyonunu kaydetti",
      "integration_tested": "{{tool}} bağlantısını denedi",
      "job_application_accepted": "başvuruyu kabul etti: {{subject}}",
      "job_application_rejected": "başvuruyu reddetti: {{subject}}",
      "job_applied": "işe başvurdu: {{subject}} · {{unit}}",
      "job_claimed": "açık havuzdan görev aldı: {{subject}} · {{testCase}}",
      "job_invite_accepted": "iş davetini kabul etti: {{subject}}",
      "job_invite_declined": "iş davetini reddetti: {{subject}}",
      "job_invited": "işe davet etti: {{subject}}",
      "job_participant_removed": "katılımcıyı işten çıkardı: {{subject}}",
      "job_withdrawn": "başvurusunu geri çekti: {{subject}}",
      "known_issue_created": "bilinen hata ekledi: {{subject}}",
      "known_issue_deleted": "bilinen hatayı sildi: {{subject}}",
      "known_issue_updated": "bilinen hatayı düzenledi: {{subject}}",
      "legacy": "eski kayıt: {{event}}",
      "organization_community_linked": "topluluk bağladı: {{subject}}",
      "organization_created": "organizasyon oluşturdu: {{subject}}",
      "organization_member_removed": "organizasyondan üye çıkardı: {{subject}}",
      "organization_member_set": "organizasyon üyesini ayarladı: {{subject}} · {{role}}",
      "payout_account_updated": "ödeme hesabını güncelledi · {{payoutMethod}}",
      "payout_marked_paid": "test uzmanına aktarımı kaydetti: {{subject}} · {{amount}} ₺",
      "profile_updated": "freelance profilini güncelledi",
      "project_created": "proje oluşturdu: {{subject}}",
      "project_key_rotated": "SDK anahtarını yeniledi: {{subject}}",
      "project_scoring_updated": "güven puanı ağırlıklarını değiştirdi: {{subject}}",
      "project_updated": "proje ayarlarını güncelledi: {{subject}}",
      "proposal_approved": "öneriyi onayladı: {{subject}}",
      "proposal_rejected": "öneriyi reddetti: {{subject}}",
      "proposal_submitted": "test senaryosu önerdi: {{subject}}",
      "recording_device_details": "uygulamada cihaz ayrıntılarını gönderdi (açık rızayla) · {{subject}}",
      "recording_paired": "uygulamayı eşleştirme koduyla teste bağladı · {{subject}}",
      "recording_started": "uygulamada kayıt başlattı · {{subject}}",
      "recording_stopped": "uygulamada kaydı durdurdu · {{subject}}",
      "refund_rejected": "bakiye iadesini reddetti: {{subject}}",
      "refund_requested": "bakiye iadesi istedi: {{amount}} ₺",
      "refund_sent": "bakiye iadesini gönderdi: {{subject}} · {{amount}} ₺",
      "review_accepted": "testi kabul etti: {{subject}}",
      "review_rejected": "testi reddetti: {{subject}}",
      "review_rescored": "güven puanını yeniden hesaplattı: {{subject}} · {{score}}",
      "statement_cancelled": "hakedişi iptal etti: {{subject}}",
      "statement_created": "hakediş oluşturdu: {{subject}} · {{total}} ₺",
      "statement_marked_paid": "havale ödemesini onayladı: {{subject}}",
      "statement_paid": "hakediş kartla ödendi: {{subject}} · {{total}} ₺",
      "statement_paid_from_balance": "hakedişi bakiyeden ödedi: {{subject}}",
      "statement_payment_failed": "kartla ödeme tamamlanmadı: {{subject}}",
      "statement_payment_started": "kartla ödemeyi başlattı: {{subject}}",
      "statement_released": "aktarımı yeniden denedi: {{subject}}",
      "step_completed": "{{step}}. adımı tamamladı: {{status}} · {{subject}}",
      "step_started": "{{step}}. adıma başladı · {{subject}}",
      "suite_created": "test grubu oluşturdu: {{subject}}",
      "suite_deleted": "test grubunu sildi: {{subject}}",
      "suite_updated": "test grubunu düzenledi: {{subject}}",
      "team_join_request_cancelled": "katılma isteğini geri çekti: {{subject}}",
      "team_join_requested": "ekibe katılmak istedi: {{subject}}",
      "team_offer_accepted": "ekip teklifini kabul etti: {{subject}}",
      "team_offer_declined": "ekip teklifini reddetti: {{subject}}",
      "team_offer_sent": "ekibe katılma teklifi gönderdi: {{subject}} → {{user}}",
      "team_offer_withdrawn": "katılma teklifini geri çekti: {{subject}} → {{user}}",
      "team_shares_updated": "ekip kazanç paylarını güncelledi: {{subject}}",
      "team_work_assigned": "ekip görevini dağıttı: {{subject}} → {{user}}",
      "team_work_bulk_assigned": "{{count}} ekip görevini bir üyeye verdi: {{subject}} → {{user}}",
      "team_work_distributed": "{{count}} ekip görevini üyelere dağıttı: {{subject}}",
      "team_work_note_set": "ekip görevine not yazdı: {{subject}}",
      "tester_identity_set": "kimlik doğrulamasını değiştirdi: {{subject}}",
      "tester_qualification_set": "akademi durumunu değiştirdi: {{subject}}",
      "user_reinstated": "hesabı yeniden açtı: {{subject}}",
      "user_suspended": "hesabı askıya aldı: {{subject}}",
      "promotion_purchased": "öne çıkarma aldı: {{subject}} · {{promotion}} · {{days}} gün",
      "promotion_paid": "öne çıkarma kartla ödendi: {{subject}} · {{promotion}} · {{amount}} ₺",
      "promotion_payment_failed": "öne çıkarma ödemesi tamamlanmadı: {{subject}} · {{promotion}}",
      "promotion_settings_updated": "öne çıkarma fiyatlarını ve aylık hakları güncelledi",
      "promotion_cancelled": "öne çıkarmayı durdurdu: {{subject}} · {{promotion}}",
      "nda_accepted": "gizlilik sözleşmesini kabul etti: {{subject}}",
      "test_account_created": "test hesabı ekledi: {{subject}} · {{label}}",
      "test_account_updated": "test hesabını değiştirdi: {{label}}",
      "test_account_deleted": "test hesabını sildi: {{label}}",
      "test_account_released": "test hesabını boşa çıkardı: {{label}}",
      "test_account_claimed": "kişiye özel test hesabı aldı: {{subject}} · {{label}}",
      "test_account_revealed": "test hesabının parolasını görüntüledi: {{subject}} · {{label}}",
      "invoice_issued": "fatura düzenlendi: {{invoice}} · {{amount}} ₺",
      "invoice_failed": "fatura gönderilemedi: {{invoice}}",
      "invoice_retried": "faturayı yeniden gönderdi: {{invoice}}",
      "invoice_cancelled": "faturayı iptal etti: {{invoice}} · {{reason}}",
      "invoice_simulator_changed": "fatura entegratörü simülasyonunu değiştirdi",
      "error_status_changed": "hata kaydını işaretledi: {{error}}",
      "error_test_sent": "hata takibini denedi",
      "ci_token_created": "CI anahtarı oluşturdu: {{subject}} · {{token}}",
      "ci_token_revoked": "CI anahtarını iptal etti: {{subject}} · {{token}}",
      "ci_run_started": "CI ile test başlattı: {{subject}} · {{build}}",
      "ci_run_cancelled": "CI test çalıştırmasını durdurdu: {{subject}}",
      "membership_checkout_started": "üyelik ödemesine geçti: {{plan}} · {{interval}} · {{amount}} ₺",
      "membership_started": "üyelik başladı: {{plan}} · {{interval}} · {{amount}} ₺",
      "membership_renewed": "üyelik yenilendi",
      "membership_payment_failed": "üyelik ödemesi alındı",
      "membership_replace_cancel_failed": "önceki abonelik iptal edildi: {{subscription}}",
      "membership_cancelled": "üyeliği iptal etti",
      "membership_plan_changed": "üyelik planını değiştirdi: {{plan}} · {{interval}}",
      "membership_expired": "üyelik sona erdi",
      "membership_settings_updated": "üyelik ayarlarını güncelledi: deneme {{trialDays}} gün, ek süre {{graceDays}} gün, komisyon %{{platformFeePercent}}",
      "membership_plan_created": "üyelik planı ekledi: {{name}} · {{interval}} · {{price}} ₺",
      "membership_plan_updated": "üyelik planını güncelledi: {{name}}",
      "membership_admin_changed": "üyeliği düzenledi: {{subject}}",
      "membership_simulator_changed": "üyelik yenileme simülasyonunu değiştirdi",
      "membership_renewal_simulated": "üyelik yenilemesini simüle etti"
    },
    "adminOnlyBody": "Bu sayfa platform yöneticileri içindir.",
    "adminOnlyTitle": "Yalnızca platform yöneticileri",
    "adminSubtitle": "Bütün organizasyon ve topluluklardaki tüm kullanıcıların işlemleri, başarısız girişler dahil.",
    "adminTitle": "Tüm platform kayıtları",
    "allCycles": "Tüm döngüler",
    "allProjects": "Tüm projeler",
    "allTypes": "Tüm türler",
    "anonymous": "Oturum açmamış biri",
    "app": {
      "AppError": "Uygulama hatası: {{message}}",
      "AppWarning": "Uygulama uyarısı: {{message}}",
      "Checkpoint": "Kontrol noktası: {{name}}",
      "Click": "{{selector}} öğesine tıkladı",
      "ClickText": "“{{text}}” öğesine tıkladı",
      "ConsoleError": "Konsol hatası: {{message}}",
      "ConsoleWarning": "Konsol uyarısı: {{message}}",
      "Crash": "Uygulama çöktü: {{message}}",
      "Input": "{{selector}} alanına veri girdi",
      "Navigation": "{{path}} sayfasına gitti",
      "NetworkError": "Ağ hatası: {{method}} {{url}} → {{status}}",
      "NetworkRequest": "{{method}} {{url}} → {{status}}",
      "Screen": "{{path}} ekranına geçti",
      "Tap": "{{selector}} öğesine dokundu",
      "TapText": "“{{text}}” öğesine dokundu",
      "background": "uygulamayı arka plana aldı",
      "foreground": "uygulamaya döndü",
      "hidden": "sekmeden ayrıldı",
      "sessionStart": "kayıt oturumu başladı",
      "sessionStop": "kayıt oturumu bitti",
      "visible": "sekmeye döndü"
    },
    "appType": {
      "Checkpoint": "Kontrol noktası",
      "Click": "Tıklama",
      "ConsoleError": "Konsol hatası",
      "ConsoleWarning": "Konsol uyarısı",
      "Input": "Veri girişi",
      "Navigation": "Sayfa geçişi",
      "NetworkError": "Ağ hatası",
      "NetworkRequest": "Ağ isteği",
      "Session": "Kayıt oturumu",
      "VisibilityChange": "Sekme görünürlüğü"
    },
    "category": {
      "account": "Hesap",
      "auth": "Giriş / kayıt",
      "billing": "Ödemeler",
      "bug": "Bug",
      "community": "Topluluk",
      "cycle": "Döngü",
      "design": "Test tasarımı",
      "execution": "Test çalıştırma",
      "marketplace": "Pazar yeri",
      "organization": "Organizasyon",
      "other": "Diğer",
      "project": "Proje",
      "review": "İnceleme",
      "system": "Sistem"
    },
    "clear": "Kaldır",
    "clearFilters": "Filtreleri temizle",
    "clearPerson": "Herkesi göster",
    "cycle": "Döngü",
    "dayCount_one": "{{count}} kayıt",
    "dayCount_other": "{{count}} kayıt",
    "detail": {
      "community": "Topluluk",
      "data": "Veriler",
      "duration": "Süre",
      "error": "Hata",
      "failed": "Başarısız",
      "ip": "IP adresi",
      "kind": "İşlem kodu",
      "ok": "Başarılı",
      "organization": "Organizasyon",
      "request": "İstek",
      "result": "Sonuç",
      "time": "Zaman",
      "userAgent": "Tarayıcı"
    },
    "details": "Ayrıntılar",
    "emptyBody": "Kullanıcılar TestRome'da işlem yaptıkça ve testler kaydedildikçe burada görünecek.",
    "emptyTitle": "Henüz kayıt yok",
    "end_one": "Hepsi bu kadar ({{count}} kayıt)",
    "end_other": "Hepsi bu kadar ({{count}} kayıt)",
    "errorBadge": "Hata",
    "errorsCount": "{{count}} hata",
    "errorsOnly": "Yalnızca hatalar",
    "everyone": "Herkes",
    "exported": "CSV dosyası indirildi.",
    "failed": "başarısız deneme: {{action}}",
    "failedAction": {
      "auth_registered": "hesap oluşturamadı",
      "auth_signed_in": "giriş yapamadı",
      "job_applied": "işe başvuramadı: {{subject}}",
      "job_claimed": "açık havuzdan görev alamadı: {{subject}}",
      "statement_payment_failed": "kartla ödeme tamamlanmadı: {{subject}}",
      "membership_payment_failed": "üyelik ödemesi alınamadı",
      "membership_replace_cancel_failed": "önceki abonelik iptal edilemedi: {{subscription}}"
    },
    "failedBadge": "Başarısız",
    "findPerson": "Kişi ara",
    "lastSeen": "son etkinlik {{at}}",
    "live": "Canlı",
    "loadMore": "Daha eski kayıtlar",
    "locale": "tr-TR",
    "managersOnlyBody": "Bu sayfayı görmek için organizasyonda Sahip veya Yönetici rolüne sahip olmalısınız.",
    "managersOnlyTitle": "Kayıtları yalnızca yöneticiler görebilir",
    "mySubtitle": "TestRome'da yaptığınız her şey ve testlerde uygulamada kaydedilen olaylar. Müşteriler ve topluluk lideriniz de bu kayıtları görebilir.",
    "myTitle": "Etkinliğim",
    "noActivity": "Bu aralıkta etkinlik yok",
    "noMatchBody": "Filtreleri gevşetin ya da zaman aralığını genişletin.",
    "noMatchTitle": "Eşleşen kayıt yok",
    "noPeople": "Bu aralıkta kimse bir şey yapmamış.",
    "noSubject": "(adsız)",
    "oneRun": "Tek test çalıştırması",
    "openRun": "Teste git",
    "paymentProvider": "Ödeme altyapısı",
    "people": "Kişiler",
    "person": "Kişi",
    "personCounts": "{{actions}} işlem · {{events}} olay · {{sessions}} test",
    "personLogs": "Bu kişinin kayıtlarını göster",
    "project": "Proje",
    "range": "Zaman aralığı",
    "ranges": {
      "1h": "Son 1 saat",
      "24h": "Son 24 saat",
      "30d": "Son 30 gün",
      "7d": "Son 7 gün",
      "all": "Tüm zamanlar"
    },
    "search": "Kayıtlarda ara",
    "searchPlaceholder": "Ara: senaryo, URL, hata mesajı, e-posta…",
    "source": {
      "all": "Hepsi",
      "app": "Uygulamada",
      "platform": "TestRome"
    },
    "sourceHint": {
      "all": "TestRome işlemleri ve uygulamada kaydedilen olaylar birlikte",
      "app": "Test uzmanlarının test edilen uygulamada yaptıkları: sayfa geçişleri, tıklamalar, konsol ve ağ hataları…",
      "platform": "Kullanıcıların TestRome'da yaptıkları: giriş, test adımları, onaylar, bug bildirimleri…"
    },
    "sourceLabel": "Kaynak",
    "subtitle": "Organizasyonunuzdaki herkesin TestRome'da yaptıkları ve test uzmanlarının test edilen uygulamada yaptıkları, tek zaman çizelgesinde.",
    "system": "Sistem",
    "tile": {
      "actions": "TestRome işlemi",
      "errors": "Hata / başarısız",
      "events": "Uygulama olayı",
      "sessions": "Test"
    },
    "title": "Kim ne yaptı?",
    "type": "Tür",
    "unitSolo": "kendi adına",
    "unitTeam": "ekip adına",
    "unknownUser": "Bilinmeyen kullanıcı",
    "viaPhone": "telefondan",
    "watchMoment": "Kayıtta bu ana git"
  },
  "sourcing": {
    "Applications": "İlan ve başvuru",
    "Community": "Kendi topluluğum",
    "OpenPool": "Açık havuz"
  },
  "visibility": {
    "InviteOnly": "Yalnızca davetliler",
    "Public": "Herkese açık"
  },
  "participantStatus": {
    "Accepted": "Kabul edildi",
    "Applied": "Başvurdu",
    "Invited": "Davetli",
    "Rejected": "Reddedildi",
    "Removed": "Çıkarıldı",
    "Withdrawn": "Geri çekildi"
  },
  "earningStatus": {
    "Invoiced": "Faturalandı",
    "Paid": "Müşteri ödedi",
    "PaidOut": "Hesabına geçti",
    "Pending": "Bekliyor",
    "Void": "İptal"
  },
  "statementStatus": {
    "Cancelled": "İptal edildi",
    "Open": "Ödeme bekliyor",
    "Paid": "Ödendi"
  },
  "payoutStatus": {
    "Failed": "Hata",
    "NotSet": "Ayarlanmadı",
    "Ready": "Hazır"
  },
  "payoutMethod": {
    "BankTransfer": "Banka havalesi",
    "Iyzico": "Kartlı ödeme altyapısı (iyzico)",
    "None": "Yok"
  },
  "paymentMethod": {
    "Balance": "Bakiyeden",
    "BankTransfer": "Banka havalesi",
    "Card": "Kredi kartı"
  },
  "ineligible": {
    "Closed": "kapandı",
    "Deadline": "başvuru süresi doldu",
    "Device": "uygun cihaz yok",
    "Full": "kontenjan dolu",
    "Language": "istenen dil yok",
    "Level": "seviye yetersiz",
    "NotInvited": "yalnızca davetliler",
    "Reputation": "itibar puanı yetersiz"
  },
  "market": {
    "allCategories": "Tüm kategoriler",
    "categories": "Kategoriler",
    "categoryLimit": "{{count}}/{{max}} seçildi",
    "eligible": "Bu işe uygunsun",
    "freelancers": "Freelance test uzmanları",
    "pay": {
      "bug": "Bug başına {{amount}}",
      "bugRange": "Bug: {{min}}–{{max}}",
      "fixed": "Sabit {{amount}}",
      "perRun": "Test başına {{amount}}",
      "rowBug": "Doğrulanan bug ({{severity}})",
      "rowFixed": "Sabit ücret (katılımcı başına)",
      "rowPerRun": "Kabul edilen test başına",
      "unpaid": "Ücretsiz",
      "firstReporter": "Aynı bug birden çok kez bildirilirse ödül ilk bildirene verilir."
    },
    "solo": "Tek kişi",
    "stats": {
      "acceptedRuns": "Kabul edilen test",
      "averageConfidence": "Ortalama güven puanı",
      "confirmedBugs": "Doğrulanan bug",
      "reputation": "İtibar puanı"
    },
    "teamOf": "{{count}} kişilik ekip",
    "teams": "Ekipler"
  },
  "jobs": {
    "acceptInvite": "Daveti kabul et",
    "alert": "Haber ver",
    "alertHint": "Bu filtrelere uyan yeni bir iş yayınlanınca bildirim al",
    "alertManage": "Yönet",
    "alertSaved": "Arama kaydedildi. Uyan yeni işlerde haber vereceğiz.",
    "all": "Hepsi",
    "boardTab": "İlanlar",
    "cases": "{{count}} senaryo",
    "category": "Kategori",
    "createProfile": "Profilimi oluştur",
    "declineInvite": "Reddet",
    "due": "Bitiş {{at}}",
    "eligibleOnly": "Yalnızca bana uygun olanlar",
    "emptyBody": "Filtreleri gevşet ya da daha sonra tekrar bak. Profilindeki dilleri ve cihazları güncel tutmak daha çok işe uygun olmanı sağlar.",
    "emptyTitle": "Şu an uygun ilan yok",
    "goToWork": "Görevlerime git",
    "inviteAccepted": "Davet kabul edildi. Görevlerin hazır.",
    "mineEmptyBody": "İlanlar sekmesinden bir işe başvurduğunda ya da davet aldığında burada görünür.",
    "mineEmptyTitle": "Henüz başvurun yok",
    "mineTab": "Başvurularım",
    "noProfileBody": "Başvurmak ve görev almak için kısa bir profil yeter: başlık, yetenekler ve konuştuğun diller.",
    "noProfileTitle": "Önce freelance profilini oluştur",
    "search": "İş, proje ya da şirket ara",
    "seatsLeft": "{{count}} kontenjan",
    "slotsLeft": "{{count}} boş görev",
    "subtitle": "Müşterilerin açtığı test işleri. Başvur ya da açık havuzdan görev al; kabul edilen her test ve doğrulanan her bug için kazan.",
    "tabs": "İş ilanı sekmeleri",
    "title": "İş ilanları",
    "type": "İş türü",
    "typeHint": {
      "Applications": "Başvurursun, müşteri seçer",
      "OpenPool": "Uygunsan hemen görev alırsın"
    },
    "withdraw": "Başvuruyu geri çek"
  },
  "jobDetail": {
    "about": "İş hakkında",
    "accepted": "Bu işe kabul edildin. Görevlerin hazır.",
    "anyEnvironment": "Ortam şartı yok",
    "applied": "Başvurun gönderildi.",
    "apply": "Başvur",
    "applyHint": "Başvurunu müşteri değerlendirir. Kabul edilirsen bütün senaryolar sana (ekipsen liderine) atanır.",
    "applyTitle": "{{title}} için başvuru",
    "as": "Kimin adına",
    "asMe": "Kendi adıma",
    "asTeam": "{{name}} ekibi adına ({{count}} kişi)",
    "cases": "Senaryolar",
    "casesHint": "Başlıklar herkese açık; adımlar ve uygulama adresi yalnızca işe kabul edilenlere görünür.",
    "claim": "Görev al",
    "claimHint": "Bir senaryo seçilip sana atanır. {{hours}} saat içinde teslim etmezsen görev havuza geri döner. Aynı anda en fazla {{max}} açık görev.",
    "claimed": "{{key}} senin. Son teslim: {{at}}",
    "device": "Cihaz",
    "deviceRequired": "Ortamlardan birine uyan bir cihazın olmalı",
    "environments": "Test ortamları",
    "exploratory": "Serbest test",
    "freeSlots": "{{count}} boş",
    "join": "Katıl",
    "message": "Müşteriye not",
    "messageHint": "Hangi cihazlarla, ne zaman başlayabileceğini yaz.",
    "messagePlaceholder": "Örn. iPhone 15 ve Android cihazımla yarın başlayabilirim.",
    "myRecord": "Senin geçmişin",
    "openClaims": "Elinde {{count}} açık görev var.",
    "pay": "Ücret",
    "payHint": "Senin kazancın. Platform ücreti müşteriye ayrıca yansıtılır.",
    "requirements": "Koşullar",
    "seats": "Kontenjan",
    "seatsOpen": "Sınır yok ({{taken}} kabul edildi)",
    "seatsValue": "{{count}} katılımcı ({{taken}} kabul edildi)",
    "sendApplication": "Başvuruyu gönder",
    "slots": "Boş görev",
    "takeWork": "Görev al",
    "teamHint": "Lideri olduğun ekipler adına da başvurabilir ya da görev alabilirsin.",
    "waiting": "Başvurun müşterinin onayını bekliyor."
  },
  "profile": {
    "about": "Hakkında",
    "addSkill": "Yetenek ekle",
    "bio": "Kendini anlat",
    "categories": "Çalıştığım alanlar",
    "categoriesHint": "Hangi tür ürünleri test ediyorsun? Müşteriler test uzmanı ararken bu alanlara göre süzer.",
    "city": "Şehir",
    "country": "Ülke",
    "create": "Profilimi oluştur",
    "createSubtitle": "Kısa bir profil oluştur; iş ilanlarına başvurmaya hemen başlarsın.",
    "created": "Profilin oluşturuldu. Artık ilanlara başvurabilirsin.",
    "devicesNote": "Cihazların da profilinde görünür ve işlere uygunluğunu belirler:",
    "headline": "Başlık",
    "headlineHint": "Örn. Mobil ödeme akışlarında 5 yıllık deneyim",
    "isAvailable": "Yeni işlere açığım",
    "isAvailableHint": "Kapattığında listede “meşgul” olarak görünürsün.",
    "isListed": "Test uzmanı listesinde görün",
    "isListedHint": "Kapalıysa yalnızca başvurduğun işlerin müşterileri ve ekip liderlerin profilini görebilir.",
    "language": {
      "ar": "Arapça",
      "de": "Almanca",
      "en": "İngilizce",
      "es": "İspanyolca",
      "fr": "Fransızca",
      "ru": "Rusça",
      "tr": "Türkçe"
    },
    "languages": "Diller",
    "noSkills": "Henüz yetenek eklemedin.",
    "skills": "Yetenekler",
    "skillsHint": "Müşteriler test uzmanı ararken bu etiketleri kullanır.",
    "subtitle": "Müşteriler seni bu profille görür ve işlerine davet eder.",
    "title": "Freelance profilim",
    "viewPublic": "Herkese açık profilim",
    "visibility": "Görünürlük"
  },
  "earnings": {
    "account": "Ödeme hesabı",
    "accountHint": "IBAN'ın şifreli saklanır. Kimlik numaran yalnızca ödeme kuruluşuna iletilir, TestRome'da tutulmaz.",
    "accountSaved": "Ödeme hesabın kaydedildi.",
    "accountTitle": "Ödeme hesabı",
    "address": "Adres",
    "amount": "Tutar",
    "date": "Tarih",
    "email": "E-posta",
    "emptyBody": "Bir işe katıl:",
    "emptyTitle": "Henüz kazancın yok",
    "entries": "Hareketler",
    "entriesHint": "Kararlar değişirse kayıt silinmez; düzeltme satırı eklenir.",
    "holderName": "Hesap sahibinin adı soyadı",
    "ibanKeep": "Kayıtlı IBAN ••{{last4}}. Değiştirmek için yenisini girin.",
    "identityHint": "Ödeme kuruluşu alt üye hesabı açmak için ister.",
    "identityNumber": "T.C. kimlik numarası",
    "invoiced": "Faturalandı",
    "invoicedHint": "Müşterinin ödemesi bekleniyor",
    "job": "İş",
    "method": "Ödeme yöntemi",
    "methodHint": {
      "BankTransfer": "Müşteri ödedikten sonra TestRome kazancını bu IBAN'a havale eder.",
      "Iyzico": "Müşteri kartla ödediğinde payın iyzico üzerinden doğrudan IBAN'ına aktarılır."
    },
    "noAccount": "Kazancını alabilmek için bir ödeme hesabı ekle.",
    "paid": "Müşteri ödedi",
    "paidHint": "Hesabına aktarılacak",
    "paidOut": "Hesabına geçti",
    "paidOutHint": "Toplam aktarılan",
    "payouts": "Hesabına aktarılanlar",
    "pending": "Bekleyen",
    "pendingHint": "Henüz faturalanmadı",
    "phone": "Cep telefonu",
    "setAccount": "Hesap ekle",
    "status": "Durum",
    "subtitle": "Kabul edilen testler, doğrulanan buglar ve sabit ücretler. Müşteri hakedişi ödediğinde paran hesabına aktarılır.",
    "title": "Kazançlarım",
    "what": "Açıklama"
  },
  "teams": {
    "cancelRequest": "İsteği geri çek",
    "create": "Ekip kur",
    "emptyBody": "İlk ekibi sen kur.",
    "emptyTitle": "Henüz herkese açık ekip yok",
    "join": "Katılma isteği gönder",
    "joinMessage": "Lidere not",
    "joinMessageHint": "Cihazlarını ve deneyimini kısaca yaz.",
    "joinTitle": "{{name}} ekibine katıl",
    "ledBy": "Lider: {{name}}",
    "members": "Üyeler",
    "openMine": "Ekibimi aç",
    "requestSent": "İsteğin lidere iletildi.",
    "requested": "İstek gönderildi",
    "search": "Ekip ara",
    "sendRequest": "İsteği gönder",
    "subtitle": "Freelance test ekipleri. Bir ekibe katıl, işleri birlikte al; kazanç liderin belirlediği oranlarla bölüşülür.",
    "title": "Ekipler",
    "memberCount": "Üye sayısı",
    "minMembers": "En az",
    "maxMembers": "En çok",
    "size": {
      "small": "1–5 kişi",
      "medium": "6–10 kişi",
      "large": "10'dan fazla"
    },
    "clearSize": "Temizle",
    "sortBy": "Sırala",
    "sortName": "Ada göre",
    "sortMembers": "Üye sayısına göre (çoktan aza)",
    "crossedRange": "En çok üye sayısı, en az üye sayısından küçük olamaz.",
    "noMatchTitle": "Bu ölçütlere uyan ekip yok",
    "noMatchBody": "Üye sayısı aralığını genişletin ya da aramayı değiştirin.",
    "found_one": "{{count}} ekip",
    "found_other": "{{count}} ekip",
    "mine_one": "Ekiplerim ({{count}})",
    "mine_other": "Ekiplerim ({{count}})",
    "mineHint": "Birden fazla ekipte olabilirsin; bir işte ise tek başına ya da yalnızca bir ekibinle çalışırsın.",
    "private": "Özel topluluk"
  },
  "testers": {
    "acceptance": "Kabul oranı",
    "anyDevice": "Her cihaz",
    "availableOnly": "Yalnızca müsait olanlar",
    "busy": "Meşgul",
    "category": "Alan",
    "device": "Cihaz",
    "devices": "Cihazlar",
    "emptyBody": "Arama ölçütlerini değiştir.",
    "emptyTitle": "Eşleşen test uzmanı yok",
    "memberSince": "{{at}} tarihinden beri üye",
    "search": "İsim, başlık ya da şehir",
    "skill": "Yetenek (örn. iOS)"
  },
  "talent": {
    "subtitle": "Freelance test uzmanlarını ve ekipleri inceleyin. İşinize davet etmek için döngünün “Katılımcılar” sekmesini kullanın.",
    "tabs": "Arama sekmeleri",
    "title": "Test uzmanı bul"
  },
  "participants": {
    "accept": "Kabul et",
    "accepted": "{{name}} işe kabul edildi; görevleri oluşturuldu.",
    "alreadyIn": "Zaten işte",
    "cancelInvite": "Daveti geri al",
    "cancelInviteTitle": "{{name}} için davet geri alınsın mı?",
    "emptyBody": {
      "Applications": "İlan yayında olduğunda başvurular burada görünür. Beklemek istemezseniz test uzmanlarını davet edin.",
      "Community": "",
      "OpenPool": "Görev alan ilk test uzmanı burada görünür."
    },
    "emptyTitle": "Henüz başvuru yok",
    "group": {
      "accepted": "Katılımcılar",
      "applied": "Başvurular",
      "invited": "Davetliler",
      "past": "Geçmiş"
    },
    "intro": {
      "Applications": "Başvuruları inceleyin; kabul ettiğiniz her katılımcıya bütün senaryolar atanır (ekiplerde liderine).",
      "Community": "",
      "OpenPool": "Uygun her test uzmanı boş görevleri kendisi alır. İsterseniz belirli kişileri davet edebilir, uygun olmayanları çıkarabilirsiniz."
    },
    "invite": "Davet et",
    "inviteHint": "Davet ettiğiniz kişi ya da ekip kabul ettiğinde işe katılır.",
    "inviteKind": "Kimi davet edeceksiniz",
    "inviteMessage": "Mesaj (isteğe bağlı)",
    "inviteMessagePlaceholder": "Örn. Android deneyiminiz bu iş için çok uygun.",
    "inviteTitle": "İşe davet et",
    "invited": "{{name}} davet edildi.",
    "lead": "Lider: {{name}}",
    "noResults": "Sonuç yok.",
    "note": "Not: {{note}}",
    "reject": "Reddet",
    "rejectNote": "Gerekçe (isteğe bağlı)",
    "rejectNoteHint": "Başvuru sahibi bu notu görür.",
    "rejectTitle": "{{name}} reddedilsin mi?",
    "rejected": "Başvuru reddedildi.",
    "remove": "İşten çıkar",
    "removeBody": "Başlanmamış görevleri geri alınır; devam eden testler teslim edilebilir.",
    "removeTitle": "{{name}} işten çıkarılsın mı?",
    "search": "İsim ya da başlık ara",
    "showPast": "Geçmişi göster ({{count}})",
    "since": "{{at}}",
    "wasInvited": "davetle geldi",
    "work": "{{assignments}} görev · {{accepted}} kabul"
  },
  "billing": {
    "addInfo": "Fatura bilgilerini ekle",
    "code": "No",
    "createStatement": "Hakediş oluştur",
    "created": "{{code}} hakedişi oluşturuldu.",
    "cycle": "Döngü",
    "date": "Tarih",
    "entries": "Kalem",
    "fee": "Platform ücreti",
    "field": {
      "address": "Adres",
      "city": "Şehir",
      "companyName": "Ünvan",
      "contactName": "Yetkili adı",
      "contactSurname": "Yetkili soyadı",
      "country": "Ülke",
      "email": "E-posta",
      "identityNumber": "Yetkili T.C. kimlik no",
      "phone": "Telefon",
      "taxNumber": "Vergi numarası",
      "taxOffice": "Vergi dairesi"
    },
    "identityHint": "Kartla ödemede ödeme kuruluşu ister.",
    "infoHint": "Hakedişler bu bilgilerle düzenlenir. Kartla ödemek için yetkilinin T.C. kimlik numarası gerekir.",
    "infoTitle": "Fatura bilgileri",
    "managersOnly": "Ödemeleri yalnızca organizasyon sahipleri ve yöneticileri görebilir.",
    "markPaid": "Ödendi olarak işaretle",
    "markPaidTitle": "Havale ödemesini onayla",
    "markPaidTitleCode": "{{code}} ödendi olarak işaretlensin",
    "markedPaid": "Hakediş ödendi olarak işaretlendi.",
    "noInfoBody": "Hakediş oluşturmadan önce fatura bilgilerinizi ekleyin.",
    "noInfoTitle": "Fatura bilgileri eksik",
    "noStatements": "Henüz hakediş yok.",
    "nothingToBill": "Faturalanacak çalışma yok.",
    "paymentFailed": "Ödeme tamamlanmadı. Tekrar deneyebilir ya da havale ile ödeyebilirsiniz.",
    "reference": "Referans",
    "referenceHint": "Banka dekont numarası ya da açıklama.",
    "statements": "Hakedişler",
    "status": "Durum",
    "subtitle": "Test uzmanlarına ödenecek tutarlar ve hakedişler",
    "testers": "Test uzmanlarına",
    "title": "Ödemeler",
    "total": "Toplam",
    "unbilled": "Faturalanmamış çalışmalar",
    "unbilledHint": "Kabul ettiğiniz testler, doğruladığınız buglar ve kapanan işlerin sabit ücretleri. Hakediş oluşturunca ödenmeye hazır olur."
  },
  "statement": {
    "accountName": "Alıcı",
    "amount": "Tutar",
    "balanceFromAvailable": "Kullanılabilir bakiyenizden ({{available}}) ödenir.",
    "balanceFromReserve": "Tamamı bu işe ayrılan bütçeden ödenir.",
    "balanceShort": "Bakiye yetersiz: kullanılabilir {{available}}, bu işe ayrılan {{held}}.",
    "balanceSplit": "{{reserve}} bu işe ayrılan bütçeden, {{rest}} kullanılabilir bakiyenizden ödenir.",
    "bank": "Banka",
    "blocker": {
      "billingMissing": "Fatura bilgilerinde yetkilinin T.C. kimlik numarası eksik.",
      "notConfigured": "Kartlı ödeme altyapısı bu kurulumda açık değil.",
      "notOpen": "Hakediş ödemeye açık değil.",
      "payeesNotReady": "Bazı test uzmanlarının kartlı ödeme hesabı yok; havale ile ödeyin."
    },
    "cancel": "Hakedişi iptal et",
    "cancelBody": "Kalemler tekrar “faturalanmamış” olur, daha sonra yeni bir hakediş oluşturabilirsiniz.",
    "cancelTitle": "{{code}} iptal edilsin mi?",
    "cancelledBody": "Bu hakediş iptal edildi; kalemler yeniden faturalanabilir.",
    "cardBody": "Ödeme sayfasına yönlendirilirsiniz. Tutar her test uzmanının hesabına ayrı ayrı aktarılır, platform ücreti TestRome'da kalır.",
    "cardReady": "Kartla aktarılır",
    "entries": "Kalemler",
    "entriesHint": "Hakedişe giren her test, bug ve sabit ücret.",
    "fee": "Platform ücreti (%{{percent}})",
    "lines": "Kime ne ödenecek",
    "paidBalanceBody": "Tutar bakiyenizden ödendi; test uzmanlarına aktarım TestRome tarafından yapılır.",
    "paidCardBody": "Paylar test uzmanlarının hesaplarına aktarıldı.",
    "paidFromBalance": "Hakediş bakiyeden ödendi.",
    "paidOn": "Ödendi · {{method}}",
    "paidTransferBody": "Test uzmanlarına aktarım TestRome tarafından yapılır.",
    "payByCard": "Kartla öde",
    "payByTransfer": "Havale ile öde",
    "payFromBalance": "Bakiyeden öde",
    "payFromBalanceNow": "Bakiyeden öde",
    "payNow": "Kartla öde",
    "payee": "Test uzmanı",
    "payeeAmount": "Tutar",
    "payment": "Ödeme",
    "paymentSuccess": "Ödemeniz alındı. Teşekkürler!",
    "payout": "Aktarım",
    "reference": "Açıklama",
    "release": "Aktarımı yeniden dene",
    "released": "Aktarıldı",
    "subtotal": "Test uzmanlarına",
    "subtotalHint": "Tamamı test uzmanlarına aktarılır",
    "title": "Hakediş {{code}}",
    "topUp": "Bakiye yükle",
    "total": "Ödenecek toplam",
    "transferBody": "Açıklamaya hakediş numarasını yazın. Ödemeniz onaylanınca test uzmanlarına aktarılır.",
    "transferOnly": "Havaleyle aktarılır"
  },
  "adminBilling": {
    "account": "Hesap",
    "awaiting": "Havale bekleyen hakedişler",
    "awaitingHint": "Banka hesabına gelen ödemeyi kontrol edip işaretleyin.",
    "markPaidOut": "Aktarıldı",
    "noAccount": "Ödeme hesabı yok",
    "noPayouts": "Aktarılacak tutar yok.",
    "noneAwaiting": "Bekleyen hakediş yok.",
    "paidOut": "Aktarım kaydedildi.",
    "payoutTitle": "{{name}} için aktarımı onayla",
    "payouts": "Test uzmanlarına aktarılacaklar",
    "payoutsHint": "Müşterinin ödediği, henüz aktarılmamış kazançlar. Havaleyi yaptıktan sonra işaretleyin.",
    "recent": "Son ödenen hakedişler",
    "subtitle": "Havale onayları ve test uzmanlarına yapılacak aktarımlar",
    "title": "Ödemeler"
  },
  "teamWork": {
    "assigned": "{{key}} → {{name}}",
    "case": "Senaryo",
    "equal": "eşit",
    "equalSplit": "{{count}} üye arasında eşit",
    "holder": "Kimde",
    "holderOf": "{{key}} kimde",
    "items": "Ekibin görevleri",
    "itemsHint": "İşlere ekip adına kabul edildiğinizde görevler önce size gelir. Başlanmamış görevleri üyelere dağıtın.",
    "job": "İş",
    "jobs": "Ekibin işleri",
    "noItems": "Ekibin açık görevi yok",
    "noItemsBody": "Ekip adına bir işe başvur ya da açık havuzdan görev al:",
    "noJobs": "Ekip henüz bir işe başvurmadı.",
    "shareOf": "{{name}} payı",
    "shares": "Kazanç paylaşımı",
    "sharesHint": "Ekibin her kazancı bu oranlarla üyelere bölünür. Boş bırakırsanız eşit bölünür.",
    "sharesSaved": "Paylar kaydedildi.",
    "status": "Durum",
    "total": "Toplam %{{total}} (100 olmalı)"
  },
  "jobCategory": {
    "Api": "API ve backend",
    "DesktopApp": "Masaüstü uygulama",
    "Game": "Oyun",
    "MobileApp": "Mobil uygulama",
    "Other": "Diğer",
    "SmartDevice": "TV, saat ve akıllı cihaz",
    "WebApp": "Web uygulaması"
  },
  "notifications": {
    "alertDelete": "Aramayı sil",
    "alertEligible": "yalnızca uygun olduklarım",
    "alertLast": "Son eşleşme {{at}}",
    "alertNever": "Henüz eşleşen iş yok",
    "alertsCreate": "İş ilanlarına git",
    "alertsEmpty": "Kayıtlı araman yok.",
    "alertsHint": "Bu aramalara uyan yeni bir iş yayınlanınca haber verilir. İş ilanlarında filtreleri seçip “Haber ver”e bas.",
    "alertsTitle": "Kayıtlı aramalar",
    "all": "Hepsi",
    "bell": "Bildirimler",
    "bellUnread": "Bildirimler ({{count}} okunmamış)",
    "emailEnabled": "Bildirimleri e-postayla da gönder",
    "emailHint": "Bildirimler {{email}} adresine de gönderilir. Uygulamada okuduğun bildirim için e-posta gelmez; birden fazla bildirim tek e-postada toplanır.",
    "emailOff": "Bu kurulumda e-posta gönderimi açık değil; bildirimler yalnızca uygulamada görünür.",
    "emailTitle": "E-posta",
    "empty": "Henüz bildirim yok",
    "emptyBody": "İşlerinle ilgili bir gelişme olduğunda burada görünür.",
    "filter": "Göster",
    "group": {
      "jobs": "İşler ve başvurular",
      "messages": "Mesajlar",
      "payments": "Ödemeler",
      "reviews": "Değerlendirmeler ve itirazlar",
      "teams": "Ekipler",
      "work": "Görevler ve test sonuçları"
    },
    "groupHint": {
      "jobs": "Başvuru kararları, davetler, kayıtlı aramana uyan yeni işler",
      "messages": "Müşteri ve test uzmanı mesajları",
      "payments": "Hakediş ödemeleri ve hesabına aktarılanlar",
      "reviews": "Sana verilen puanlar, itirazların sonucu",
      "teams": "Katılma istekleri ve onaylar",
      "work": "Yeni görevler, yaklaşan teslim tarihleri, test ve bug kararları"
    },
    "groupsLegend": "Hangi konularda e-posta gelsin",
    "inAppAlways": "Uygulama içi bildirimler her zaman açıktır.",
    "kind": {
      "account_reinstated": "Hesabınız yeniden açıldı",
      "account_suspended": "Hesabınız askıya alındı. Sebep: {{reason}}",
      "job_alert": "Kayıtlı aramana uyan yeni iş: {{cycle}} ({{org}})",
      "job_application_accepted": "Başvurun kabul edildi: {{cycle}}. Görevlerin hazır.",
      "job_application_received": "{{name}} işinize başvurdu: {{cycle}}",
      "job_application_received_team": "{{team}} ekibi ({{name}}) işinize başvurdu: {{cycle}}",
      "job_application_rejected": "Başvurun kabul edilmedi: {{cycle}}",
      "job_invite_answered_false": "{{name}} davetinizi reddetti: {{cycle}}",
      "job_invite_answered_true": "{{name}} davetinizi kabul etti: {{cycle}}",
      "job_invited": "{{org}} seni bir işe davet etti: {{cycle}}",
      "job_invited_team": "{{org}}, {{team}} ekibini bir işe davet etti: {{cycle}}",
      "job_removed": "Müşteri seni işten çıkardı: {{cycle}}",
      "messages_question_answered": "Sorun yanıtlandı: {{cycle}}",
      "messages_question_asked": "{{name}} ilanınıza soru sordu: {{cycle}}",
      "messages_received": "{{name}} sana yazdı ({{cycle}}): {{preview}}",
      "payments_deposit_awaiting": "{{org}} {{code}} ile {{amount}} bakiye yüklemesi bildirdi; havaleyi onaylayın",
      "payments_deposit_completed": "{{amount}} bakiyenize eklendi ({{code}})",
      "payments_deposit_rejected": "{{code}} bakiye yüklemesi onaylanmadı",
      "payments_earnings_paid": "Müşteri {{cycle}} hakedişini ödedi: {{amount}} senin",
      "payments_escrow_released": "{{cycle}} için ayrılan bütçeden kalan {{amount}} bakiyenize döndü",
      "payments_payout_sent": "{{amount}} hesabına aktarıldı",
      "payments_refund_decided_Rejected": "{{amount}} tutarındaki iade talebiniz reddedildi; tutar bakiyenize döndü",
      "payments_refund_decided_Sent": "{{amount}} tutarındaki iadeniz gönderildi",
      "payments_refund_requested": "{{org}} bakiyesinden {{amount}} iade istedi",
      "payments_transfer_awaiting": "{{org}} {{code}} hakedişini oluşturdu ({{amount}}); havale bekleniyor",
      "reviews_dispute_escalated": "{{subject}} itirazı platform yöneticisine iletildi",
      "reviews_dispute_opened": "{{name}}, {{subject}} kararına itiraz etti",
      "reviews_dispute_resolved_Overturned": "Platform {{subject}} kararını bozdu",
      "reviews_dispute_resolved_ResolvedByCustomer": "Müşteri {{subject}} kararını değiştirdi",
      "reviews_dispute_resolved_Upheld": "Platform {{subject}} kararını onayladı",
      "reviews_received": "{{cycle}} için {{rating}} yıldızlı değerlendirme aldın",
      "team_join_approved": "{{team}} ekibine katıldın",
      "team_join_requested": "{{name}}, {{team}} ekibine katılmak istiyor",
      "team_offer_answered_false": "{{name}}, {{team}} ekibine katılma teklifinizi reddetti",
      "team_offer_answered_true": "{{name}}, {{team}} ekibine katılma teklifinizi kabul etti",
      "team_offer_received": "{{name}}, sizi {{team}} ekibine davet ediyor",
      "work_assigned": "{{count}} yeni görev: {{cycle}}",
      "work_assigned_case": "{{case}} sana verildi: {{cycle}}",
      "work_bug_triaged": "Bug #{{bug}}: {{status}} ({{title}})",
      "work_due_soon": "{{case}} için teslim süresi yaklaşıyor: {{cycle}} (son {{due}})",
      "work_qualified": "TestRome akademisini geçtin; Gümüş ve üstü seviyelere aday olabilirsin",
      "work_run_reviewed_Accepted": "{{case}} testin kabul edildi: {{cycle}}",
      "work_run_reviewed_Rejected": "{{case}} testin reddedildi: {{cycle}}",
      "system_error_reported": "Yeni hata: {{kind}} — {{message}}",
      "system_error_regressed": "Çözüldü işaretlenen hata yeniden oluştu: {{kind}} — {{message}}",
      "account_membership_trial_ending": "TestRome deneme sürenizin bitmesine {{days}} gün kaldı; devam etmek için bir plan seçin",
      "account_membership_trial_ending_org": "{{org}} için deneme süresinin bitmesine {{days}} gün kaldı; devam etmek için bir plan seçin",
      "account_membership_payment_failed": "Üyelik yenileme ödemeniz alınamadı: {{error}}",
      "account_membership_payment_failed_org": "{{org}} üyelik yenileme ödemesi alınamadı: {{error}}",
      "account_membership_expired": "Üyeliğiniz sona erdi; pazaryerinde yeni işe başvurmak için yenileyin",
      "account_membership_expired_org": "{{org}} üyeliği sona erdi; veriler duruyor ama yeni iş başlatılamıyor"
    },
    "markAll": "Tümünü okundu say",
    "more": "Daha fazla",
    "noUnread": "Okunmamış bildirim yok",
    "open": "Aç",
    "seeAll": "Tüm bildirimler",
    "subtitle": "İşlerin, testlerin ve ödemelerinle ilgili gelişmeler.",
    "tabAll": "Bildirimler",
    "tabSettings": "Ayarlar",
    "tabs": "Bildirim sekmeleri",
    "title": "Bildirimler",
    "unread": "okunmadı",
    "unreadCount": "Okunmamış ({{count}})"
  },
  "feedback": {
    "comment": "Yorum (isteğe bağlı)",
    "commentHint": "Herkese açık görünür. Kişisel bilgi yazmayın.",
    "customerGaveYou": "Müşterinin puanı:",
    "customerReviews": "{{name}} hakkında yorumlar",
    "customerShort": "Müşteri",
    "noRating": "Henüz puan yok",
    "noReviews": "Henüz değerlendirme yok.",
    "pickStars": "Bir puan seçin.",
    "rate": "Değerlendir",
    "rateCustomer": "Müşteriyi değerlendir",
    "rateCustomerHint": "Talimatlar açık mıydı, kararlar adil miydi, ödeme zamanında mı yapıldı? Puanın diğer test uzmanlarına yol gösterir.",
    "rateCustomerTitle": "{{name}} değerlendir",
    "rateHint": "İş kalitesi, iletişim ve testlerin titizliği. Puanınız katılımcının profilinde görünür.",
    "rateTitle": "{{name}} değerlendir",
    "ratingTitle": "{{count}} değerlendirmede ortalama {{avg}}",
    "reviewsTitle": "Değerlendirmeler",
    "saved": "Değerlendirmen kaydedildi.",
    "send": "Gönder",
    "starWord": {
      "1": "Kötü",
      "2": "Zayıf",
      "3": "Fena değil",
      "4": "İyi",
      "5": "Çok iyi"
    },
    "stars": "Puan",
    "starsLabel": "5 üzerinden {{value}} yıldız",
    "starsOption": "{{count}} yıldız",
    "theirRating": "Size verdikleri:",
    "youGaveCustomer": "Senin puanın:",
    "yourRating": "Sizin puanınız:"
  },
  "disputeStatus": {
    "Escalated": "Platform inceliyor",
    "Open": "Müşteri yanıtı bekleniyor",
    "Overturned": "Karar bozuldu",
    "ResolvedByCustomer": "Müşteri kararını değiştirdi",
    "Upheld": "Karar onaylandı",
    "Withdrawn": "Geri çekildi"
  },
  "disputes": {
    "active": "Süren ({{count}})",
    "adminEmpty": "Karar bekleyen itiraz yok.",
    "adminSubtitle": "Müşterinin arkasında durduğu kararlar. İki tarafı okuyup karar verin.",
    "adminTitle": "İtirazlar",
    "all": "Hepsi ({{count}})",
    "customerResponse": "Müşterinin yanıtı",
    "decided": "Karar kaydedildi.",
    "decision": {
      "Duplicate": "Kopya",
      "Rejected": "Reddedildi"
    },
    "decisionNote": "Müşterinin notu",
    "decisionWas": "Karar: {{decision}}",
    "escalated": "İtiraz platforma iletildi.",
    "filter": "Göster",
    "keep": "Kararımın arkasındayım",
    "keepBody": "Gerekçenizi yazın. İtiraz platform yöneticisine iletilir ve onun kararı geçerli olur.",
    "keepTitle": "{{subject}}: kararı koru",
    "kind": {
      "Bug": "Bug",
      "Run": "Test"
    },
    "label": "İtiraz",
    "myEmpty": "Reddedilen bir test ya da bug kararına “Görevlerim” ve “Bildirdiğim buglar” sayfalarından itiraz edebilirsin.",
    "mySubtitle": "Reddedilen testlerine ve buglarına yaptığın itirazlar.",
    "myTitle": "İtirazlarım",
    "none": "İtiraz yok",
    "noneActive": "Süren itiraz yok",
    "note": "Karar notu",
    "noteRequired": "Notu yazın.",
    "open": "İtiraz et",
    "openHint": "Müşteri kararını değiştirebilir ya da gerekçesini yazar; o zaman itirazı platform değerlendirir. Bir karara bir kez itiraz edilebilir (14 gün içinde).",
    "openTitle": "{{subject}} kararına itiraz et",
    "opened": "İtirazın müşteriye iletildi.",
    "orgEmpty": "Kararlarınıza itiraz edildiğinde burada görünür.",
    "orgSubtitle": "Test uzmanlarının kararlarınıza itirazları. Kararı değiştirin ya da gerekçenizi yazın.",
    "orgTitle": "İtirazlar",
    "overturn": "Kararı boz (kabul et)",
    "overturnBody": "Test kabul edilir (bug doğrulanır). Kazanç ve itibar güncellenir, iki taraf bilgilendirilir.",
    "overturnTitle": "{{subject}}: kararı boz",
    "platformDecision": "Platform kararı",
    "reason": "Gerekçe",
    "reasonHint": "Neyi yanlış değerlendirdiklerini, kanıtın nerede olduğunu kısa ve net yazın.",
    "reasonLabel": "İtiraz",
    "reasonRequired": "Gerekçeyi yazın.",
    "reply": "Gerekçe",
    "replyOptional": "Test uzmanına not (isteğe bağlı)",
    "reverse": "Kararı değiştir",
    "reverseBody": "Test kabul edilir (bug doğrulanır); kazanç ve itibar puanı buna göre güncellenir.",
    "reverseTitle": "{{subject}}: kararı değiştir",
    "reversed": "Karar değiştirildi.",
    "reviewersOnly": "İtirazları organizasyonun sahipleri, yöneticileri ve inceleyicileri görebilir.",
    "send": "İtirazı gönder",
    "uphold": "Kararı onayla",
    "upholdBody": "Müşterinin kararı geçerli kalır. İki taraf bilgilendirilir.",
    "upholdTitle": "{{subject}}: kararı onayla",
    "withPlatform": "Bu itirazı platform yöneticisi değerlendiriyor.",
    "withdraw": "İtirazı geri çek",
    "withdrawBody": "Aynı karara yeniden itiraz edemezsin.",
    "withdrawTitle": "İtiraz geri çekilsin mi?",
    "withdrawn": "İtiraz geri çekildi."
  },
  "messages": {
    "back": "Yazışmalara dön",
    "conversations": "Yazışmalar",
    "emptyBody": "Bir işin katılımcısıyla ya da müşterisiyle “Mesaj yaz” düğmesinden yazışma başlatabilirsiniz.",
    "emptyTitle": "Henüz yazışma yok",
    "linkUnread": "Mesajlar ({{count}} okunmamış yazışma)",
    "noMessagesYet": "Henüz mesaj yok",
    "pick": "Soldan bir yazışma seçin.",
    "placeholder": "Mesajınız… (göndermek için Ctrl+Enter)",
    "send": "Gönder",
    "startHint": "İlk mesajı yazın. Karşı taraf bildirim alır.",
    "subtitle": "Müşterilerle ve işlerinde çalışan test uzmanlarıyla yazışmalar.",
    "title": "Mesajlar",
    "unread": "{{count}} okunmamış",
    "write": "Mesaj yaz",
    "writeCustomer": "Müşteriye yaz"
  },
  "questions": {
    "answer": "Yanıtla",
    "answerLabel": "Yanıt: {{question}}",
    "answerPlaceholder": "Yanıtınız…",
    "answered": "Yanıt kaydedildi.",
    "answeredBy": "{{name}} yanıtladı",
    "ask": "Soru sor",
    "askHint": "Kişisel bilgi ya da şifre paylaşma; özel konular için katıldıktan sonra mesaj yaz.",
    "askPlaceholder": "Örn. Test hesabı herkese ortak mı?",
    "delete": "Soruyu sil",
    "hint": "İş hakkında soru sor; yanıtlar herkese açık görünür.",
    "none": "Henüz yanıtlanmış soru yok.",
    "noneCustomer": "Henüz soru yok",
    "noneCustomerBody": "Test uzmanlarının ilanınızla ilgili soruları burada görünür.",
    "private": "Gizli",
    "publicLabel": "Herkese açık yanıt",
    "sent": "Sorun müşteriye iletildi.",
    "title": "Sorular",
    "waiting": "yanıt bekleniyor"
  },
  "escrow": {
    "add": "Bütçe ekle",
    "addHint": "Kullanılabilir bakiyeniz {{available}}. Ayrılan tutar yalnızca bu işin hakedişlerinde kullanılır.",
    "addTitle": "Bu işe bütçe ekle",
    "added": "{{amount}} bu işe ayrıldı.",
    "amount": "Tutar",
    "amountInvalid": "Geçerli bir tutar girin (en fazla 2 ondalık basamak).",
    "autoRelease": "Kalan tutar {{date}} tarihinde kendiliğinden bakiyenize döner.",
    "badge": "Ödeme güvencede",
    "badgeAmount": "Ödeme güvencede · {{amount}}",
    "badgeHint": "Müşteri bu iş için bütçeyi önden ayırdı; onaylanan çalışmalar bu tutardan ödenir.",
    "blocker": {
      "active": "İş hâlâ yayında",
      "disputes": "Sonuçlanmamış itiraz var",
      "unreviewed": "İncelenmemiş test var",
      "untriaged": "Değerlendirilmemiş bug var"
    },
    "boardDone": "Bu işe ayrılan bütçe kullanıldı ya da serbest bırakıldı.",
    "boardHeld": "Ödeme güvencede: bu iş için {{amount}} ayrıldı.",
    "boardNone": "Bu iş için önden bütçe ayrılmadı.",
    "boardPlanned": "Yayınlanınca bakiyenizden {{amount}} bu işe ayrılacak.",
    "release": "Kalanı serbest bırak",
    "releaseBody": "Önce ödenmemiş hakedişler bu bütçeden ödenir ({{owed}}); kalan {{amount}} kullanılabilir bakiyenize döner.",
    "releaseTitle": "Kalan bütçe bakiyenize dönsün mü?",
    "released": "Kalan bütçe bakiyenize döndü."
  },
  "depositStatus": {
    "Cancelled": "İptal edildi",
    "Completed": "Yüklendi",
    "Failed": "Başarısız",
    "Pending": "Bekliyor"
  },
  "refundStatus": {
    "Rejected": "Reddedildi",
    "Requested": "İstendi",
    "Sent": "Gönderildi"
  },
  "walletEntry": {
    "Deposit": "Bakiye yükleme {{deposit}}",
    "RefundRequested": "İade istendi",
    "RefundReturned": "İade reddedildi, bakiyeye döndü",
    "Release": "İşten döndü: {{cycle}}",
    "Reserve": "İşe ayrıldı: {{cycle}}",
    "Spend": "Hakediş ödendi: {{statement}} · {{cycle}}",
    "Promotion": "Öne çıkarma {{promotion}}: {{cycle}}"
  },
  "wallet": {
    "amount": "Tutar",
    "amountRange": "{{min}} ile {{max}} arasında bir tutar girin.",
    "announceTransfer": "Havale bildir",
    "available": "Kullanılabilir",
    "availableHint": "Yeni işlere ayrılabilir ya da hakedişlerde kullanılabilir.",
    "balanceAfter": "Kalan bakiye",
    "cancelDeposit": "İptal et",
    "cancelDepositBody": "Henüz havale yapmadıysanız bu bildirimi iptal edebilirsiniz.",
    "cancelDepositTitle": "{{code}} iptal edilsin mi?",
    "card": "Kart",
    "cardBody": "Ödeme sayfasına yönlendirilirsiniz; ödeme tamamlanınca tutar hemen bakiyenize eklenir.",
    "cardDepositDone": "Kartla yükleme tamamlandı; tutar bakiyenize eklendi.",
    "cardDepositFailed": "Kartla yükleme tamamlanmadı.",
    "csv": {
      "available": "Kullanılabilir değişim",
      "availableAfter": "Kullanılabilir bakiye",
      "by": "İşlemi yapan",
      "date": "Tarih",
      "description": "Açıklama",
      "reserved": "Ayrılan değişim",
      "reservedAfter": "Ayrılan bakiye"
    },
    "exportCsv": "CSV indir",
    "held": "Ayrılan",
    "holderName": "Hesap sahibi",
    "ledger": "Hesap hareketleri",
    "method": "Ödeme yöntemi",
    "noEntries": "Henüz hareket yok.",
    "owed": "Ödenecek",
    "payByCard": "Kartla öde",
    "pending": "Bekleyen yüklemeler",
    "refund": "İade iste",
    "refundHint": "Kullanılabilir bakiyeniz {{available}}. Tutar talep anında bakiyeden düşer; TestRome havale ile gönderir.",
    "refundRequested": "İade talebiniz alındı.",
    "refundTitle": "Bakiye iadesi iste",
    "refundTooMuch": "En fazla {{available}} iade isteyebilirsiniz.",
    "refunds": "İade talepleri",
    "releasable": "{{amount}} serbest bırakılabilir",
    "releaseState": "Serbest bırakma",
    "requestRefund": "İade iste",
    "reservations": "İşlere ayrılan bütçeler",
    "reserved": "İşlere ayrılan",
    "reservedHint": "Yayındaki işler için güvenceye alınmış tutar.",
    "showAll": "Tüm hareketler ({{count}})",
    "showLess": "Daha az göster",
    "subtitle": "Önden yüklediğiniz tutar. İş yayınlarken bütçe buradan ayrılır, hakedişler buradan ödenir.",
    "system": "Sistem",
    "title": "Bakiye",
    "topUp": "Bakiye yükle",
    "topUpHint": "Yüklediğiniz tutar iş bütçelerinde ve hakediş ödemelerinde kullanılır; kullanılmayan kısmı iade isteyebilirsiniz.",
    "topUpTitle": "Bakiye yükle",
    "total": "Toplam",
    "transfer": "Havale / EFT",
    "transferAnnounced": "{{code}} oluşturuldu. Havale açıklamasına bu kodu yazın.",
    "transferBody": "Size bir yükleme kodu verilir. Havale açıklamasına bu kodu yazın; para hesaba ulaşınca TestRome onaylar ve tutar bakiyenize eklenir."
  },
  "adminWallet": {
    "confirmDeposit": "Geldi, onayla",
    "confirmTitle": "{{code}} · {{amount}} hesaba ulaştı mı?",
    "confirmed": "Yükleme onaylandı; tutar müşterinin bakiyesine eklendi.",
    "deposits": "Onay bekleyen bakiye yüklemeleri",
    "depositsHint": "Havale açıklamasındaki yükleme kodunu (YK-…) eşleştirip onaylayın.",
    "markSent": "Gönderildi",
    "noDeposits": "Onay bekleyen yükleme yok.",
    "noRefunds": "Bekleyen iade talebi yok.",
    "note": "Not (müşteri görür)",
    "organization": "Organizasyon",
    "recent": "Son bakiye işlemleri",
    "refund": "İade",
    "refunds": "İade talepleri",
    "refundsHint": "Tutarı müşterinin IBAN'ına gönderip gönderildi olarak işaretleyin.",
    "reject": "Reddet",
    "rejectDepositTitle": "{{code}} reddedilsin mi?",
    "rejectRefundTitle": "{{org}} iade talebi reddedilsin mi?",
    "rejected": "Reddedildi.",
    "sent": "İade gönderildi olarak işaretlendi.",
    "sentTitle": "{{org}} için {{amount}} gönderildi mi?",
    "totalAvailable": "Müşteri bakiyeleri (kullanılabilir)",
    "totalReserved": "İşlere ayrılan (güvencede)"
  },
  "documents": {
    "amount": "Tutar",
    "annual": "Yıllık kazanç dökümü",
    "annualDisclaimer": "Bu döküm TestRome kayıtlarından bilgilendirme amacıyla hazırlanmıştır. Fatura ya da serbest meslek makbuzu yerine geçmez; gelir beyanı ve vergi yükümlülükleriniz için mali müşavirinize danışın.",
    "annualTitle": "Yıllık kazanç dökümü · {{year}}",
    "byCustomer": "Müşterilere göre",
    "byMonth": "Aylara göre",
    "csv": {
      "customer": "Müşteri",
      "date": "Tarih",
      "earning": "Kazanç",
      "job": "İş",
      "payout": "Aktarım",
      "status": "Durum",
      "type": "Tür"
    },
    "customer": "Müşteri",
    "description": "Açıklama",
    "details": "Ayrıntılı döküm",
    "disclaimer": "Bu belge bilgilendirme amaçlıdır; fatura, e-Arşiv fatura ya da serbest meslek makbuzu yerine geçmez. Resmi belgeler ilgili mevzuata göre ayrıca düzenlenir; vergi konularında mali müşavirinize danışın.",
    "earned": "Kazanılan",
    "entries": "Kayıt",
    "entriesTitle": "Tüm kazanç kayıtları",
    "fee": "Hizmet bedeli belgesi",
    "feeColumn": "Hizmet bedeli (%{{percent}})",
    "feeLine": "TestRome platform hizmet bedeli · {{code}} hakedişi (%{{percent}})",
    "feeLines": "Hizmet bedeli",
    "feePassThrough": "Bu hakedişte {{count}} test uzmanına aktarılan {{amount}} hizmet bedeline dahil değildir; TestRome aracılığıyla ilgili kişilere iletilir.",
    "feeTitle": "Platform hizmet bedeli",
    "generated": "Oluşturulma: {{date}}",
    "howToPay": "Nasıl ödenir",
    "issued": "Düzenlenme: {{date}}",
    "job": "İş",
    "lines": "Test uzmanlarına ödenecekler",
    "method": "Yöntem",
    "month": "Ay",
    "notYetPaid": "Henüz aktarılmayan",
    "paidLine": "Ödendi: {{date}} · {{method}}",
    "paidOut": "Hesaba aktarılan",
    "payouts": "Hesaba aktarımlar",
    "print": "Yazdır / PDF",
    "reference": "Referans",
    "statement": "Hakediş belgesi",
    "statementTitle": "Hakediş belgesi",
    "taxLine": "Vergi dairesi: {{office}} · VKN/TCKN: {{number}}",
    "total": "Toplam",
    "transferLine": "{{amount}} tutarını {{name}} ({{bank}}, IBAN {{iban}}) hesabına, açıklamaya {{reference}} yazarak gönderin.",
    "year": "Yıl"
  },
  "recordingMode": {
    "ScreenVideo": "Mobil uygulama (ekran videosu)",
    "ScreenVideoHint": "SDK gerekmez. Test uzmanı telefonun ekran kaydını yükler ve her adımın videoda başladığı yeri işaretler.",
    "Sdk": "Web uygulaması (SDK ile otomatik kayıt)",
    "SdkHint": "Uygulamanıza eklediğiniz TestRome SDK'sı her oturumu, tıklamaları ve sayfa geçişlerini kendisi kaydeder.",
    "badge": "Ekran kaydıyla",
    "SdkApp": "Android uygulaması (SDK ile otomatik kayıt)",
    "SdkAppHint": "Uygulamanıza eklediğiniz TestRome Android SDK'sı ekranları, dokunmaları, ağ isteklerini, hataları ve çökmeleri kaydeder. Test uzmanı uygulamayı QR kodla ya da eşleştirme koduyla teste bağlar.",
    "SdkIos": "iOS uygulaması (SDK ile otomatik kayıt)",
    "SdkIosHint": "Uygulamanıza eklediğiniz TestRome iOS SDK'sı ekranları, dokunmaları, doldurulan alanları, ağ isteklerini, hataları ve çökmeleri kaydeder. Test uzmanı uygulamayı bağlantıyla ya da eşleştirme koduyla teste bağlar."
  },
  "level": {
    "Bronze": "Bronz",
    "Gold": "Altın",
    "New": "Yeni",
    "Platinum": "Platin",
    "Silver": "Gümüş",
    "academy": "Akademi",
    "academyHint": "Ücretsiz alıştırma işi; kabul edilen bir çalıştırma akademiyi geçmek demektir.",
    "academyHow": "Akademi işinde bir senaryoyu uygulayıp ekran kaydını yükle; TestRome ekibi inceler.",
    "academyNotPassed": "Akademiyi geçmedi",
    "academyPassed": "Akademiyi geçti",
    "adminHint": "Akademiyi başka yoldan geçtiyse ya da kimliğini belgelerle doğruladıysanız buradan işaretleyin.",
    "adminTitle": "Yönetici: seviye koşulları",
    "anyLevel": "Tüm seviyeler",
    "atLeast": "En az {{level}}",
    "check": {
      "acceptanceRate": "Kabul oranı en az %{{need}}",
      "acceptedRuns": "En az {{need}} kabul edilen test",
      "averageConfidence": "Ortalama güven puanı en az {{need}}",
      "confirmedBugs": "En az {{need}} doğrulanmış bug",
      "identityVerified": "Kimlik doğrulaması",
      "qualified": "Akademiyi geçmek",
      "rating": "Müşteri puanı en az {{need}} (yeterli değerlendirmeyle)"
    },
    "grantAcademy": "Akademiyi geçti say",
    "hint": "Seviye; kabul edilen çalışmalara, doğrulanan bug'lara, kabul oranına, güven puanına, akademiye ve kimlik doğrulamasına göre kendiliğinden belirlenir.",
    "identityHow": "Kazançlar bölümünden kartlı ödeme hesabı açınca ya da TestRome kimliğini doğrulayınca tamamlanır.",
    "met": "tamam",
    "minLevel": "En düşük seviye",
    "missing": "eksik",
    "nextIs": "{{level}} için gerekenler",
    "notVerified": "Kimliği doğrulanmadı",
    "openAcademy": "Akademi işini aç",
    "qualifiedOn": "Akademi: {{date}}",
    "revokeAcademy": "Akademiyi geri al",
    "revokeIdentity": "Doğrulamayı kaldır",
    "subtitle": "Seviyen, incelenen çalışmalarına, akademiye ve kimlik doğrulamasına göre kendiliğinden değişir. Müşteriler işlerde en düşük seviye isteyebilir.",
    "title": "Seviyen",
    "top": "En üst seviyedesin. Tebrikler!",
    "verified": "Kimliği doğrulandı",
    "verifiedByProvider": "Kimliği ödeme kuruluşu doğruladı",
    "verifiedHint": "Kimliği TestRome ya da ödeme kuruluşu tarafından doğrulandı.",
    "verifyIdentity": "Kimliği doğrula"
  },
  "integrations": {
    "allSeverities": "Hepsi",
    "autoOff": "elle gönderilir",
    "autoOn": "doğrulananlar kendiliğinden açılır",
    "connect": "Bağla",
    "edit": "Düzenle",
    "event": {
      "BugConfirmed": "Bug doğrulandı",
      "BugReported": "Yeni bug bildirildi",
      "CycleClosed": "Test döngüsü kapandı (raporla)",
      "CyclePublished": "Test döngüsü başladı"
    },
    "field": {
      "account": "Hesap e-postası",
      "accountHint": "Jira Cloud için gerekli; Data Center'da boş bırakın.",
      "autoCreate": "Doğrulanan bug'lar {{name}}'da kendiliğinden açılsın",
      "enabled": "Entegrasyon açık",
      "events": "Kanala gidecek olaylar",
      "githubApi": "API adresi",
      "githubApiHint": "GitHub Enterprise kullanıyorsanız değiştirin.",
      "issueType": "İş tipi",
      "issueTypeHint": "Projede bug'lar için kullanılan tip (çoğunlukla Bug).",
      "jiraSite": "Jira adresi",
      "minSeverity": "Kendiliğinden açılacak bug'lar",
      "minSeverityChat": "Bug bildirimleri",
      "projectKey": "Proje anahtarı",
      "repository": "Depo (sahip/depo)",
      "token": "Token",
      "webhook": "Webhook adresi"
    },
    "help": {
      "GitHub": "GitHub'da Ayarlar → Geliştirici ayarları → Fine-grained token ile yalnızca bu depo için \"Issues: Read and write\" izni olan bir token oluşturun.",
      "Jira": "Jira Cloud için hesap e-postanızı ve id.atlassian.com → Güvenlik → API token'ları bölümünden alacağınız token'ı girin. Jira Data Center'da e-postayı boş bırakıp kişisel erişim token'ı (PAT) kullanın.",
      "Slack": "Slack'te \"Incoming Webhooks\" uygulamasını kanalınıza ekleyin ve verdiği webhook adresini buraya yapıştırın."
    },
    "kind": {
      "GitHub": "GitHub",
      "Jira": "Jira",
      "Slack": "Slack"
    },
    "lastError": "Son hata ({{at}}): {{error}}",
    "lastSuccess": "Son başarılı gönderim: {{at}}",
    "noEvents": "olay seçilmedi",
    "notSendable": "Reddedilen ya da kopya bug'lar gönderilemez.",
    "openIn": "{{name}}'da aç",
    "pitch": {
      "GitHub": "Bug'lar GitHub deposunda issue olarak açılsın.",
      "Jira": "Doğrulanan bug'lar Jira'da iş olarak açılsın.",
      "Slack": "Yeni ve doğrulanan bug'lar, başlayan ve biten test döngüleri kanala düşsün."
    },
    "pushed": "{{name}}'da açıldı: {{key}}",
    "remove": "Kaldır",
    "removeBody": "Ayarlar ve token silinir. Daha önce açılan işlerin bağlantıları bug'larda kalır.",
    "removeTitle": "{{name}} bağlantısı kaldırılsın mı?",
    "removed": "{{name}} kaldırıldı",
    "saved": "{{name}} kaydedildi",
    "secretKept": "Kayıtlı: {{hint}}. Değiştirmek için yenisini yazın.",
    "secretPlaceholder": "Değiştirmeyecekseniz boş bırakın",
    "sendAgain": "Yeniden gönder",
    "sendTest": "Deneme mesajı gönder",
    "sendTo": {
      "Jira": "Jira'ya gönder",
      "GitHub": "GitHub'a gönder",
      "Slack": "Slack'e gönder"
    },
    "sending": {
      "Jira": "Jira'ya gönderiliyor…",
      "GitHub": "GitHub'a gönderiliyor…",
      "Slack": "Slack'e gönderiliyor…"
    },
    "severityAndUp": "{{severity}} ve üstü",
    "status": {
      "failing": "Hata veriyor",
      "notSet": "Bağlı değil",
      "off": "Kapalı",
      "on": "Açık"
    },
    "subtitle": "Bug'ları Jira'ya ya da GitHub'a gönderin; Slack kanalınız yeni bug'ları ve test döngülerini duysun.",
    "test": "Bağlantıyı dene",
    "title": "Entegrasyonlar",
    "trackers": "Hata takip sistemi",
    "uncertain": {
      "Jira": "Jira'daki sonucu belirsiz",
      "GitHub": "GitHub'daki sonucu belirsiz",
      "Slack": "Sonucu belirsiz"
    },
    "uncertainHelp": "Gönderimin sonucu belirsiz ({{error}}). {{name}}'da \"[TestRome #{{number}}]\" araması yapın; iş yoksa yeniden gönderin."
  },
  "report": {
    "bands": "Güven puanı dağılımı",
    "bugs": "Bug'lar",
    "bugsCsv": "Bug listesi (CSV)",
    "bySeverity": "Önem derecesine göre bug'lar",
    "cases": "Senaryolar",
    "col": {
      "accepted": "Kabul",
      "bugs": "Bug",
      "case": "Senaryo",
      "confidence": "Güven",
      "confirmed": "Doğrulanan",
      "date": "Tarih",
      "reporter": "Bildiren",
      "runs": "Çalıştırma",
      "severity": "Önem",
      "status": "Durum",
      "tester": "Test uzmanı",
      "title": "Başlık",
      "total": "Toplam",
      "tracker": "Takip"
    },
    "cost": "Maliyet",
    "costEarnings": "Test uzmanlarının kabul edilen işi",
    "costEscrow": "Ayrılan bütçe (kalan / ayrılan)",
    "costFee": "Platform hizmet bedeli",
    "costPaid": "Ödenen",
    "costTotal": "Toplam",
    "documentTitle": "{{name}} · Test raporu",
    "environments": "Ortamlar",
    "exploratory": "Keşif oturumları",
    "footer": "Bu rapor TestRome tarafından {{date}} tarihinde {{name}} için oluşturuldu. Rakamlar oluşturulduğu andaki durumu gösterir.",
    "generated": "Oluşturuldu: {{date}}",
    "noReasons": "Puanı düşüren bir şey görülmedi.",
    "noRuns": "Henüz gönderilmiş çalıştırma yok.",
    "ongoing": "sürüyor",
    "outcomes": "Senaryo sonuçları",
    "period": "Dönem",
    "platform": "Platform",
    "reasons": "Güven puanını düşüren nedenler",
    "results": "Sonuçlar",
    "runsCount_one": "{{count}} çalıştırma",
    "runsCount_other": "{{count}} çalıştırma",
    "sourcing": "Test uzmanları",
    "target": "Test edilen adres",
    "testers": "Test uzmanları",
    "tile": {
      "accepted": "Kabul oranı",
      "bugs": "Bulunan bug",
      "confidence": "Ortalama güven",
      "outOf": "100 üzerinden",
      "reviewed_one": "{{count}} incelenen çalıştırma",
      "reviewed_other": "{{count}} incelenen çalıştırma",
      "runs": "Çalıştırma",
      "serious_one": "{{count}} kritik ya da büyük",
      "serious_other": "{{count}} kritik ya da büyük",
      "testers_one": "{{count}} test uzmanı",
      "testers_other": "{{count}} test uzmanı"
    },
    "title": "Test raporu",
    "unknownEnvironment": "Belirtilmemiş",
    "version": "sürüm {{version}}"
  },
  "admin": {
    "acceptance": "Kabul oranı: {{value}}",
    "acceptedRuns": "Kabul edilen test",
    "account": "Hesap",
    "activeCycles": "Süren test döngüsü",
    "activeTesters_one": "Son 30 günde {{count}} aktif",
    "activeTesters_other": "Son 30 günde {{count}} aktif",
    "allTime": "Toplam: {{value}}",
    "awaitingPayout": "Aktarılacak",
    "awaitingTransfer": "Ödeme bekleyen hakediş: {{value}}",
    "bugs30": "Bildirilen bug",
    "bugsConfirmed_one": "{{count}} doğrulandı",
    "bugsConfirmed_other": "{{count}} doğrulandı",
    "clear": "Sorun yok",
    "clearBody": "Örneğin aynı bilgisayarı kullanan iki aile üyesi. Hesaplar birbirini işlerde engellemez; grup büyürse yeniden listelenir.",
    "clearTitle": "Bu hesaplar bağlantılı kalabilir mi?",
    "cleared": "Grup incelendi olarak işaretlendi",
    "clusterTitle_one": "{{count}} hesap",
    "clusterTitle_other": "{{count}} hesap",
    "col": {
      "earned": "Kazanç",
      "joined": "Katıldı",
      "lastSeen": "Son giriş",
      "roles": "Roller",
      "runs": "Test",
      "user": "Kullanıcı"
    },
    "confirmedBugs": "Doğrulanan bug",
    "customers": "Müşteri",
    "dashboardTitle": "Genel bakış",
    "days_one": "{{count}} gün",
    "days_other": "{{count}} gün",
    "decidedBy": "{{name}} · {{at}}",
    "decision": {
      "Cleared": "Sorun yok",
      "Suspended": "Askıya alındı"
    },
    "decisions": "Kararlar",
    "disputes": "Açık itiraz",
    "disputesHint": "30 günde {{resolved}} çözüldü · ortalama {{time}}",
    "earnedShort": "kazanç {{amount}}",
    "fees30": "Platform geliri",
    "filter": "Kullanıcı türü",
    "filters": {
      "all": "Tümü",
      "customers": "Müşteriler",
      "linked": "Bağlantılı",
      "suspended": "Askıda",
      "testers": "Test uzmanları"
    },
    "fraudSubtitle": "Aynı tarayıcıdan açılan, aynı IBAN'a ya da telefona ödeme alan hesaplar büyük olasılıkla aynı kişidir. Bu hesaplar aynı işte çalışamaz; burada inceleyip karar verin.",
    "fraudTitle": "Bağlantılı hesaplar",
    "generated": "{{at}} itibarıyla",
    "hours_one": "{{count}} saat",
    "hours_other": "{{count}} saat",
    "includeReviewed": "Karar verilenleri de göster",
    "joinedLine": "Katıldı: {{at}}",
    "lessThanHour": "1 saatten az",
    "linkedCount_one": "{{count}} bağlantılı hesap",
    "linkedCount_other": "{{count}} bağlantılı hesap",
    "linkedSince": "{{at}} tarihinden beri bağlantılı",
    "logs": "Kayıtlar",
    "memberships": "Üyelikler",
    "money": "Para (son 30 gün)",
    "new30_one": "Son 30 günde {{count}} yeni",
    "new30_other": "Son 30 günde {{count}} yeni",
    "next": "Sonraki",
    "noClusters": "Bağlantılı hesap yok",
    "noClustersBody": "Ortak tarayıcı, IBAN ya da telefon kullanan hesap bulunmadı.",
    "noSignals": "Henüz kayıt yok.",
    "noUsers": "Eşleşen kullanıcı yok",
    "note": "Not",
    "openJobs_one": "{{count}} açık ilan",
    "openJobs_other": "{{count}} açık ilan",
    "pageOf": "{{from}}–{{to}} / {{total}}",
    "payoutHeld": "Hesap askıda: ödeme bekletiliyor",
    "pendingReviews_one": "{{count}} test inceleme bekliyor",
    "pendingReviews_other": "{{count}} test inceleme bekliyor",
    "people": "Kişiler",
    "platformAdmin": "Platform yöneticisi",
    "prev": "Önceki",
    "profile": "Profil",
    "reason": "Sebep",
    "reinstate": "Yeniden aç",
    "reinstated": "Hesap yeniden açıldı",
    "reviewTime": "Ortalama inceleme süresi",
    "risk": {
      "High": "Yüksek risk",
      "Medium": "Orta risk"
    },
    "runs30": "Gönderilen test",
    "search": "Ara",
    "searchPlaceholder": "Ad, e-posta ya da filigran kodu (TR-…)",
    "selfDealing": "Bir hesabın çalıştığı şirketin işinde test yapıldı: {{job}} ({{org}}) —",
    "shared": {
      "Device": "Aynı tarayıcı",
      "Iban": "Aynı IBAN",
      "Ip": "Aynı IP adresi",
      "Phone": "Aynı telefon"
    },
    "sharedJob": "Aynı işte çalıştılar: {{job}} ({{org}}) —",
    "sharedWith": "Ortak:",
    "signal": {
      "Device": "Tarayıcı",
      "Iban": "IBAN",
      "Ip": "IP adresi",
      "Phone": "Telefon"
    },
    "signalSeen_one": "İlk {{first}} · son {{last}} · {{count}} kez",
    "signalSeen_other": "İlk {{first}} · son {{last}} · {{count}} kez",
    "signals": "Tanıtıcı bilgiler",
    "signalsHint": "Bu hesabın kullanıldığı tarayıcılar, IP adresleri ve ödeme bilgileri. Başka hesaplarla ortak olanlar işaretlidir.",
    "suspend": "Askıya al",
    "suspendAll": "Hepsini askıya al",
    "suspendAllBody": "Gruptaki tüm hesaplar (platform yöneticileri hariç) askıya alınır ve sebep kendilerine e-postayla bildirilir.",
    "suspendAllTitle_one": "{{count}} hesap askıya alınsın mı?",
    "suspendAllTitle_other": "{{count}} hesap askıya alınsın mı?",
    "suspendBody": "Hesaptan hemen çıkış yapılır ve tekrar giriş yapılamaz. Açık görevleri başkalarına açılır, bekleyen başvuruları geri çekilir, ödemeleri bekletilir. Kişiye sebep e-postayla bildirilir.",
    "suspendTitle": "{{name}} askıya alınsın mı?",
    "suspended": "Hesap askıya alındı",
    "suspendedAll": "Hesaplar askıya alındı",
    "suspendedBadge": "Askıda",
    "suspendedCount_one": "{{count}} hesap askıda",
    "suspendedCount_other": "{{count}} hesap askıda",
    "suspendedLine": "{{at}} tarihinde {{by}} tarafından askıya alındı: {{reason}}",
    "tester": "Test uzmanı",
    "testers": "Test uzmanı",
    "todo": "Bekleyen işler",
    "todoDeposits": "Onay bekleyen havale ile bakiye yüklemesi",
    "todoDisputes": "Platforma iletilen itiraz",
    "todoFraud": "Karar bekleyen bağlantılı hesap grubu",
    "todoPayouts": "Test uzmanlarına aktarılacak: {{amount}}",
    "todoRefunds": "Gönderilmesi gereken bakiye iadesi",
    "todoTransfers": "Ödemesi beklenen hakedişler: {{amount}}",
    "users": "Kullanıcı",
    "usersCount_one": "{{count}} kullanıcı",
    "usersCount_other": "{{count}} kullanıcı",
    "usersTitle": "Kullanıcılar",
    "volume30": "Ödenen tutar",
    "walletReserved": "İşlere ayrılan: {{value}}",
    "wallets": "Müşteri bakiyeleri",
    "weekRuns": "Gönderilen test",
    "weekUsers": "Yeni kullanıcı",
    "weekVolume": "Ödenen tutar",
    "weeks": "Son 12 hafta",
    "work": "İş (son 30 gün)",
    "watermarkCodeHint": "Gizli işlerde ekranlara basılan filigran kodu"
  },
  "privacy": {
    "acceptNotice": "Kişisel verilerimin işlenmesine ilişkin aydınlatma metnini okudum.",
    "acknowledge": "Okudum, anladım",
    "always": "Her testte kaydedilenler",
    "consents": "Onaylar",
    "deviceAllow": "İzin veriyorum",
    "deviceAskBody": "Müşteri, uygulamasının hangi donanımda test edildiğini görebilir; hatalar aynı ortamda daha kolay yeniden üretilir. İşletim sistemi sürümü, ekran çözünürlüğü, işlemci çekirdek sayısı, yaklaşık bellek, ekran kartı ve bağlantı türü toplanır. İsteğe bağlıdır, iş almanızı etkilemez; Gizlilik sayfasından istediğiniz zaman geri alabilirsiniz.",
    "deviceAskTitle": "Ayrıntılı cihaz bilgilerini paylaşır mısınız?",
    "deviceDeclined": "Tamam; ayrıntılı cihaz bilgileriniz toplanmayacak.",
    "deviceDeny": "İzin vermiyorum",
    "deviceGranted": "Teşekkürler; cihaz bilgileriniz testlerde paylaşılacak.",
    "deviceOptional": "İsteğe bağlı: test sırasında ayrıntılı cihaz bilgilerimin (işletim sistemi sürümü, ekran, işlemci, bellek, ekran kartı, bağlantı) toplanmasına açık rıza veriyorum.",
    "deviceWithdrawn": "Açık rızanız geri alındı; daha önce toplanan ayrıntılar silindi.",
    "gateIntro": "Devam etmeden önce kişisel verilerinizin nasıl işlendiğini anlatan metni okuyun.",
    "hideText": "Metni gizle",
    "history": "Onay geçmişi",
    "historyNo": "reddedildi / geri alındı",
    "historyYes": "onaylandı",
    "kind": {
      "DeviceDetails": "Ayrıntılı cihaz bilgileri (açık rıza)",
      "PrivacyNotice": "Aydınlatma metni"
    },
    "kindHint": {
      "DeviceDetails": "Test sırasında işletim sistemi sürümü, ekran, işlemci, bellek, ekran kartı ve bağlantı bilgilerinin toplanması. İsteğe bağlıdır.",
      "PrivacyNotice": "Hangi verilerin, neden ve ne kadar süreyle işlendiğini ve haklarınızı anlatır. Platformu kullanmak için okunması gerekir."
    },
    "latestRun": "{{run}} · {{at}}",
    "loading": "Yükleniyor…",
    "menu": "Gizlilik",
    "nothingYet": "Henüz bir test yapmadınız.",
    "noticeRequired": "Devam etmek için aydınlatma metnini okuyup onaylayın.",
    "readConsent": "Açık rıza metni",
    "readFull": "Metnin tamamı",
    "readNotice": "Metni oku",
    "recordedHint_one": "En son testinizden. Ayrıntılı bilgiler {{count}} testinizde var.",
    "recordedHint_other": "En son testinizden. Ayrıntılı bilgiler {{count}} testinizde var.",
    "recordedTitle": "Hakkınızda kaydedilen cihaz bilgileri",
    "showText": "Metni göster",
    "signOut": "Çıkış yap",
    "state": {
      "acknowledged": "Okundu",
      "declined": "İzin verilmedi",
      "granted": "İzin verildi",
      "pending": "Okunmadı",
      "unanswered": "Yanıtlanmadı"
    },
    "subtitle": "Kişisel verileriniz, verdiğiniz onaylar ve hakkınızda kaydedilen cihaz bilgileri",
    "title": "Gizlilik",
    "version": "metin {{version}}",
    "withdraw": "Rızayı geri al",
    "withdrawBody": "Bundan sonra ayrıntılı cihaz bilgileriniz toplanmaz ve daha önce toplananlar silinir. Temel kayıtlar (tarayıcı, işletim sistemi, ekran kaydı) hizmetin parçası olduğu için devam eder.",
    "withdrawTitle": "Açık rızanız geri alınsın mı?"
  },
  "device": {
    "available": "Kullanılabilir alan",
    "browser": "Tarayıcı",
    "collectedAt": "{{at}} tarihinde toplandı",
    "cores_one": "{{count}} çekirdek",
    "cores_other": "{{count}} çekirdek",
    "cpu": "İşlemci",
    "environment": "Ortam",
    "formFactor": "Cihaz biçimi",
    "formFactors": {
      "Desktop": "Masaüstü",
      "Mobile": "Mobil",
      "Tablet": "Tablet",
      "XR": "XR (sanal/artırılmış gerçeklik)",
      "EInk": "E-mürekkep",
      "Watch": "Saat",
      "Automotive": "Araç"
    },
    "fromBrowser": "Tarayıcının bildirdikleri",
    "fromVideo": "Ekran kaydı dosyasının bildirdikleri",
    "gpu": "Ekran kartı",
    "language": "Dil",
    "languages": "Diller",
    "memory": "Bellek (RAM)",
    "memoryAtLeast": "{{gb}} GB ve üzeri",
    "model": "Cihaz modeli",
    "network": "Bağlantı",
    "noTouch": "yok",
    "none": "Bu test için ayrıntılı cihaz bilgisi yok.",
    "os": "İşletim sistemi",
    "recordedAt": "Kayıt zamanı",
    "reducedMotion": "hareket azaltma açık",
    "saveData": "veri tasarrufu açık",
    "scheme": {
      "dark": "koyu tema",
      "light": "açık tema"
    },
    "screen": "Ekran",
    "storage": "Tarayıcı depolama kotası",
    "theme": "Görünüm",
    "timezone": "Saat dilimi",
    "touch": "Dokunmatik",
    "touchPoints_one": "{{count}} dokunma noktası",
    "touchPoints_other": "{{count}} dokunma noktası",
    "userAgent": "Tarayıcı kimliği (user agent)",
    "videoDevice": "Cihaz",
    "videoSize": "Video çözünürlüğü",
    "window": "Pencere"
  },
  "offers": {
    "accept": "Katıl",
    "accepted": "{{team}} ekibine katıldınız.",
    "decline": "Reddet",
    "declined": "{{team}} ekibinin teklifini reddettiniz.",
    "dialogHint": "Kısa bir mesaj yazın: ekibin hangi işlere girdiği, ondan ne beklediğiniz. Kabul ederse ekibe test uzmanı olarak katılır; kazanç payını sonra Kazanç payları bölümünden ayarlarsınız.",
    "dialogTitle": "{{name}} ekibe davet edilsin",
    "from": "{{name}} gönderdi · {{at}}",
    "inboxHint": "Bir ekip lideri sizi ekibine davet etti. Katılırsanız lider, ekibin aldığı işlerden size görev verebilir; kazanç ekibin paylarına göre bölüşülür.",
    "inboxTitle_one": "Size gelen ekip teklifi",
    "inboxTitle_other": "Size gelen ekip teklifleri ({{count}})",
    "invite": "Ekibe davet et",
    "message": "Mesajınız",
    "messageHint": "En fazla 1000 karakter; test uzmanı teklifle birlikte görür.",
    "messagePlaceholder": "Örn. Mobil ödeme işlerinde Android tarafı için destek arıyoruz.",
    "send": "Teklif gönder",
    "sent": "Teklif gönderildi: {{name}}",
    "status": {
      "Accepted": "Kabul etti",
      "Declined": "Reddetti",
      "Pending": "Yanıt bekliyor",
      "Withdrawn": "Geri çekildi"
    },
    "team": "Ekip",
    "withdraw": "Geri çek",
    "withdrawBody": "Test uzmanı teklifi artık göremez ve kabul edemez.",
    "withdrawTitle": "{{name}} için teklif geri çekilsin mi?",
    "withdrawn": "Teklif geri çekildi."
  },
  "teamPanel": {
    "acceptance": "Kabul oranı {{rate}}",
    "acceptanceShort": "Kabul",
    "activeJobs": "Aktif işler",
    "allHint": "Ekibin aktif işlerindeki bütün görevler. Başlanmamış olanlar başka bir üyeye verilebilir.",
    "allJobs": "Bütün işler",
    "allTitle": "Bütün görevler",
    "alreadyMember": "Ekipte",
    "anyone": "Herkes",
    "applyPlan_one": "{{count}} görevi dağıt",
    "applyPlan_other": "{{count}} görevi dağıt",
    "badge": "Yönetim paneli",
    "chooseMember": "Üye seçin",
    "deadlines": "Teslim tarihleri",
    "deviceFit": "Bu üyenin bu ortam için cihazı var",
    "distributeHint": "Seçtiğiniz üyelere dağıtılır: teslim tarihi yakın olanlar önce yerleşir; uygun cihazı olan ve elinde en az iş bulunan üye öne alınır. Aynı işte aynı senaryo bir kişiye iki kez verilmez. Önce planı görürsünüz.",
    "distributeTitle_one": "{{count}} görevi dağıt",
    "distributeTitle_other": "{{count}} görevi dağıt",
    "distributed_one": "{{count}} görev dağıtıldı.",
    "distributed_other": "{{count}} görev dağıtıldı.",
    "dueSoon_one": "48 saat içinde {{count}} teslim",
    "dueSoon_other": "48 saat içinde {{count}} teslim",
    "earned30": "Kazanç (30 gün)",
    "earned30Short": "Kazanç (30 g)",
    "earningsSub": "Bekleyen {{pending}} · ödenen {{paid}}",
    "equalShort": "eşit",
    "findHint": "Profili olan test uzmanları arasında arayın ve ekibe katılma teklifi gönderin.",
    "findTitle": "Test uzmanı bul",
    "findWork": "İş bul",
    "fitCount_one": "{{count}} üyede uygun cihaz",
    "fitCount_other": "{{count}} üyede uygun cihaz",
    "fits": "cihazı uygun",
    "give": "Ver",
    "giveTo": "Kime",
    "given_one": "{{count}} görev verildi: {{name}}",
    "given_other": "{{count}} görev verildi: {{name}}",
    "holder": "Kimde",
    "inProgress": "Devam eden",
    "inProgressShort": "Devam",
    "job": "İş",
    "last30": "Son 30 günde teslim",
    "last30Detail": "{{accepted}} kabul, {{rejected}} red",
    "last30Short": "30 günde teslim",
    "lastActive": "Son çalışma",
    "moved": "Toplu dağıtım, ekip özeti ve teklifler yönetim panelinde.",
    "noDeviceFit": "Seçilen üyelerde bu ortam için cihaz yok",
    "noOffers": "Henüz teklif göndermediniz.",
    "noTeamBody": "Ekip paneli, herkese açık bir ekibin liderleri içindir.",
    "noTeamTitle": "Yönettiğiniz bir ekip yok",
    "note": "Not",
    "noteClear": "Notu kaldır",
    "noteCleared": "Not kaldırıldı.",
    "noteFor": "{{key}} için not",
    "noteHint": "Görevi alan üye bu notu görev listesinde ve testi başlatırken görür.",
    "noteOptional": "Not (isteğe bağlı)",
    "notePlaceholder": "Örn. iPhone ile test et, kuponu iki kez dene",
    "noteSaved": "Not kaydedildi.",
    "noteTitle": "{{key}} · lider notu",
    "nothingWaiting": "Dağıtılmayı bekleyen görev yok",
    "nothingWaitingBody": "Ekibin aldığı yeni işlerin görevleri önce liderde toplanır ve burada listelenir.",
    "offersHint": "Yanıt bekleyen teklifler ve son 30 günde yanıtlananlar.",
    "offersOpen_one": "{{count}} teklif yanıt bekliyor",
    "offersOpen_other": "{{count}} teklif yanıt bekliyor",
    "offersTitle": "Gönderilen teklifler",
    "open": "Açık görev",
    "openNow_one": "Şu an {{count}} açık görev",
    "openNow_other": "Şu an {{count}} açık görev",
    "openPanel": "Yönetim paneli",
    "openPeople": "İncele",
    "openTasks": "Açık görevler",
    "overdue_one": "{{count}} görevin teslim tarihi geçti",
    "overdue_other": "{{count}} görevin teslim tarihi geçti",
    "pendingApplications_one": "{{count}} başvuru yanıt bekliyor",
    "pendingApplications_other": "{{count}} başvuru yanıt bekliyor",
    "pendingOf": "Bekleyen {{amount}}",
    "plan": "Plan",
    "previewPlan": "Planı göster",
    "requestsWaiting_one": "{{count}} katılma isteği onay bekliyor",
    "requestsWaiting_other": "{{count}} katılma isteği onay bekliyor",
    "select": "{{key}} seç",
    "selectAll": "Hepsini seç",
    "selected_one": "{{count}} görev seçildi",
    "selected_other": "{{count}} görev seçildi",
    "share": "Pay",
    "spread": "Eşit dağıt…",
    "switchTeam": "Ekip",
    "tabOverview": "Genel bakış",
    "tabPeople": "Üyeler ve teklifler",
    "tabShares": "Kazanç payları",
    "tabWork": "İş dağıtımı",
    "tabs": "Ekip paneli bölümleri",
    "teamPage": "Ekip sayfası",
    "view": "Görünüm",
    "viewAll": "Bütün görevler",
    "viewWaiting": "Dağıtılmayı bekleyenler",
    "waitingHint": "Liderde duran ve henüz başlanmamış görevler. Seçip bir üyeye verin ya da seçtiklerinizi üyelere eşit dağıtın.",
    "waitingTitle": "Dağıtılmayı bekleyen görevler",
    "whoGetsWork": "Kimler iş alsın?",
    "withLeads_one": "{{count}} görev liderde bekliyor",
    "withLeads_other": "{{count}} görev liderde bekliyor",
    "workload": "Üyelerin iş yükü",
    "workloadHint": "Aktif işlerdeki açık görevler, son 30 günde teslim edilen testler (kabul/red) ve ekipten gelen kazanç.",
    "tabRhythm": "Çalışma ritmi"
  },
  "cv": {
    "title": "CV'm",
    "subtitle": "Müşteriler test uzmanı seçerken CV'ne bakar. Hiçbir alan zorunlu değil.",
    "welcomeTitle": "CV'ni doldur",
    "welcomeSubtitle": "Hoş geldin {{name}}! Başlamadan önce kendini kısaca tanıt: müşteriler işlerine test uzmanı seçerken CV'ne bakar. Hiçbir alan zorunlu değil; doldurduğun kadarı görünür.",
    "visibility": "CV'ni müşteriler (iş veren şirketler), ekip liderlerin ve platform yöneticileri görebilir; diğer test uzmanları göremez. Telefon, e-posta ya da adres yazma: iletişim TestRome mesajlarıyla yürür.",
    "viewAsCustomer": "Müşterilerin gördüğü hali",
    "summary": "Özet",
    "summaryHint": "Ne tür ürünleri test ettin, nelerde iyisin?",
    "summaryLabel": "Kısa özet",
    "summaryPlaceholder": "Örn. 3 yıldır e-ticaret ve ödeme akışlarını test ediyorum…",
    "testingYears": "Test deneyimi (yıl)",
    "testingTypes": "Test türleri",
    "testingTypesHint": "Yaptığın test türlerini seç.",
    "type": {
      "Manual": "Manuel test",
      "Exploratory": "Keşif testi",
      "Regression": "Regresyon",
      "Automation": "Otomasyon",
      "Api": "API testi",
      "Performance": "Performans",
      "Security": "Güvenlik",
      "Accessibility": "Erişilebilirlik",
      "Usability": "Kullanılabilirlik",
      "Localization": "Yerelleştirme",
      "Mobile": "Mobil",
      "Game": "Oyun testi"
    },
    "experience": "İş deneyimi",
    "addExperience": "Deneyim ekle",
    "noExperience": "Henüz deneyim eklemedin.",
    "experienceRow": "Deneyim {{n}}",
    "jobTitle": "Pozisyon",
    "company": "Şirket",
    "startYear": "Başlangıç yılı",
    "endYear": "Bitiş yılı",
    "current": "Halen burada çalışıyorum",
    "description": "Açıklama",
    "education": "Eğitim",
    "addEducation": "Eğitim ekle",
    "noEducation": "Henüz eğitim eklemedin.",
    "educationRow": "Eğitim {{n}}",
    "school": "Okul",
    "degree": "Derece",
    "field": "Bölüm",
    "graduationYear": "Mezuniyet yılı",
    "certificates": "Sertifikalar",
    "addCertificate": "Sertifika ekle",
    "noCertificates": "Henüz sertifika eklemedin.",
    "certificateRow": "Sertifika {{n}}",
    "certificateName": "Sertifika",
    "issuer": "Veren kurum",
    "year": "Yıl",
    "languages": "Diller",
    "addLanguage": "Dil ekle",
    "noLanguages": "Henüz dil eklemedin.",
    "language": "Dil",
    "languageLevel": "Seviye",
    "level": {
      "Basic": "Başlangıç",
      "Intermediate": "Orta",
      "Advanced": "İleri",
      "Native": "Ana dil"
    },
    "tools": "Araçlar",
    "toolsHint": "Kullandığın test ve hata takip araçları.",
    "addTool": "Araç ekle",
    "noTools": "Henüz araç eklemedin.",
    "links": "Bağlantılar",
    "linksHint": "LinkedIn, GitHub ya da portfolyo (en fazla 5).",
    "addLink": "Bağlantı ekle",
    "noLinks": "Henüz bağlantı eklemedin.",
    "linkLabel": "Başlık",
    "linkUrl": "Adres",
    "removeRow": "Kaldır: {{row}}",
    "optionalNote": "Boş bırakıp devam edebilirsin; CV'ni sonra menüdeki “CV'm” sayfasından tamamlarsın.",
    "optionalShort": "Hiçbir alan zorunlu değil.",
    "saveAndContinue": "Kaydet ve devam et",
    "welcomeSaved": "CV'n kaydedildi.",
    "section": "CV",
    "open": "CV",
    "titleOf": "{{name}} · CV",
    "emptyTitle": "CV doldurulmamış",
    "emptyBody": "{{name}} henüz CV'sine bir şey yazmadı.",
    "present": "Halen",
    "untitled": "(adsız)",
    "yearsOfTesting_one": "{{count}} yıl test deneyimi",
    "yearsOfTesting_other": "{{count}} yıl test deneyimi",
    "updatedAt": "Son güncelleme: {{at}}",
    "languageRow": "Dil {{n}}",
    "linkRow": "Bağlantı {{n}}",
    "import": {
      "title": "CV'n PDF olarak hazır mı?",
      "hint": "Yükle, alanları senin için dolduralım. Kaydetmeden önce her şeyi görüp düzeltebilirsin.",
      "pick": "PDF'ten doldur",
      "file": "CV PDF dosyası",
      "privacyRules": "Dosya yüklenmez: tarayıcın PDF'teki metni okur, TestRome alanlara dağıtır. Sen kaydetmeden hiçbir şey saklanmaz.",
      "privacyAi": "PDF, alanlara dağıtılması için yapay zekâya (Anthropic Claude) gönderilir ve saklanmaz. Sen kaydetmeden hiçbir şey saklanmaz.",
      "reading": "PDF okunuyor…",
      "placing": "Alanlar dolduruluyor…",
      "placingAi": "Yapay zekâ CV'ni okuyor; biraz sürebilir…",
      "notPdf": "{{name}} bir PDF değil.",
      "tooLarge": "{{name}} çok büyük; en fazla {{mb}} MB olabilir.",
      "unreadable": "PDF açılamadı. Şifreli ya da bozuk olabilir.",
      "noText": "PDF'te okunabilir metin yok. Taranmış (fotoğraf) bir PDF olabilir: Word'den ya da bir CV sitesinden alınmış PDF'i dene ya da alanları elle doldur.",
      "resultTitle": "PDF'ten eklendi",
      "byAi": "yapay zekâ ile okundu",
      "check": "Kontrol et, yanlış ya da eksik yerleri düzelt ve Kaydet'e bas. Formda zaten olanlar değiştirilmedi.",
      "nothingNew": "PDF'te formda olmayan yeni bir bilgi bulunamadı.",
      "undo": "Geri al",
      "undone": "PDF'ten eklenenler geri alındı.",
      "added": {
        "summary": "özet",
        "testingYears": "test deneyimi (yıl)",
        "experience_one": "{{count}} deneyim",
        "experience_other": "{{count}} deneyim",
        "education_one": "{{count}} eğitim",
        "education_other": "{{count}} eğitim",
        "certificates_one": "{{count}} sertifika",
        "certificates_other": "{{count}} sertifika",
        "languages_one": "{{count}} dil",
        "languages_other": "{{count}} dil",
        "tools_one": "{{count}} araç",
        "tools_other": "{{count}} araç",
        "testingTypes_one": "{{count}} test türü",
        "testingTypes_other": "{{count}} test türü",
        "links_one": "{{count}} bağlantı",
        "links_other": "{{count}} bağlantı"
      }
    }
  },
  "phone": {
    "title": "Telefondan teste katıl",
    "tester": "Test uzmanı",
    "job": "İş",
    "validUntil": "Bu bağlantı {{at}} saatine kadar ve test teslim edilene kadar çalışır.",
    "invalidTitle": "Bağlantı geçersiz",
    "closedTitle": "Bağlantı kapandı",
    "videoTitle": "Ekran kaydı",
    "videoStep1": "Telefonun ekran kaydını başlat (iPhone: Denetim Merkezi → Ekran Kaydı, Android: hızlı ayarlar → Ekran kaydı).",
    "videoStep2": "Testi uygulamada yap, bitince kaydı durdur.",
    "videoStep3": "Aşağıdaki düğmeyle videoyu seç; bilgisayardaki test ekranına kendiliğinden gelir.",
    "videoPick": "Ekran kaydını seç",
    "videoReplace": "Başka bir video yükle",
    "videoDone": "Ekran kaydı yüklendi",
    "videoDoneHint": "{{at}} · Bilgisayardaki test ekranından devam edebilirsin.",
    "appTitle": "Uygulama",
    "appHint": "Uygulama bu telefonda kuruluysa aşağıdaki düğme onu açar ve bu teste bağlar; kayıt hemen başlar.",
    "openApp": "Uygulamayı aç",
    "openedHint": "Uygulama açılmadıysa kurulu olduğundan emin ol ya da eşleştirme kodunu kullan.",
    "showCode": "Eşleştirme kodu göster",
    "newCode": "Yeni eşleştirme kodu",
    "tapToOpen": "Uygulama açılmadıysa buraya dokun"
  },
  "promotion": {
    "featured": "Öne çıkan",
    "featuredUntil": "{{at}} tarihine kadar öne çıkarıldı",
    "featuredShort": "Öne çıkıyor · {{at}}",
    "promote": "Öne çıkar",
    "titleJob": "İlanı öne çıkar",
    "titleTeam": "Ekibi öne çıkar",
    "hintJob": "Öne çıkan ilanlar iş panosunda en üstte, “Öne çıkan” rozetiyle görünür; test uzmanları onları ilk görür.",
    "hintTeam": "Öne çıkan ekipler ekip dizininde en üstte, “Öne çıkan” rozetiyle görünür; müşteriler onları ilk görür.",
    "runningUntil": "Şu an öne çıkıyor: {{at}} tarihine kadar.",
    "choose": "Öne çıkarma süresi",
    "free": "Ücretsiz · {{count}} gün",
    "freeLeft": "Bu ay {{left}}/{{total}} ücretsiz hakkınız kaldı",
    "levelBonus": "lider seviyesinden +{{count}}",
    "days": "{{count}} gün",
    "perDay": "günü {{amount}}",
    "method": "Ödeme yöntemi",
    "fromBalance": "Bakiyeden ({{amount}})",
    "teamPaysByCard": "Ekipler öne çıkarmayı kartla öder.",
    "balanceShort": "Bakiye bu paket için yetmiyor.",
    "topUp": "Bakiye yükleyin",
    "cardOff": "Kartla ödeme şu an kullanılamıyor.",
    "billingMissing": "Kartla ödemek için fatura bilgileri (T.C. kimlik no dahil) gerekli.",
    "fillBilling": "Fatura bilgilerini doldurun",
    "buyerHint": "Fatura bu bilgilerle kesilir. Kimlik numaranız şifrelenerek saklanır.",
    "buyer": {
      "name": "Ad",
      "surname": "Soyad",
      "identityNumber": "T.C. kimlik no",
      "phone": "Telefon",
      "address": "Adres",
      "city": "Şehir"
    },
    "pickOne": "Bir seçenek seçin",
    "useFree": "Ücretsiz öne çıkar",
    "payBalance": "{{amount}} bakiyeden öde",
    "payCard": "Kartla öde ({{amount}})",
    "startNote": "Öne çıkarma hemen başlar.",
    "queueNote": "Yeni öne çıkarma, şu anki süre bittiğinde başlar; arka arkaya eklenir.",
    "done": "{{code}}: {{from}} – {{to}} arasında öne çıkarılacak.",
    "cardDone": "Ödeme alındı; öne çıkarma başladı.",
    "cardFailed": "Kartla ödeme tamamlanmadı; öne çıkarma başlamadı.",
    "history": "Geçmiş ({{count}})",
    "payment": {
      "Free": "Ücretsiz",
      "Balance": "Bakiye",
      "Card": "Kart"
    },
    "phase": {
      "Live": "Yayında",
      "Queued": "Sırada",
      "Ended": "Bitti",
      "Pending": "Ödeme bekliyor",
      "Failed": "Ödenmedi",
      "Cancelled": "Durduruldu",
      "Active": "Etkin"
    },
    "blocker": {
      "notActive": "Yalnızca yayında olan işler öne çıkarılabilir.",
      "notPublic": "Yalnızca herkese açık ilanlar öne çıkarılabilir.",
      "notMarketplace": "Yalnızca pazaryerindeki işler öne çıkarılabilir."
    }
  },
  "promotionAdmin": {
    "live": "Şu an öne çıkan",
    "paidThisMonth": "Bu ay öne çıkarma geliri",
    "freeThisMonth": "Bu ay ücretsiz öne çıkarma",
    "settings": "Öne çıkarma paketleri",
    "settingsHint": "Aylık ücretsiz haklar ve ücretli paketler. Değişiklik hemen geçerli olur; alınmış öne çıkarmalar etkilenmez.",
    "jobFree": "Müşteri başına aylık ücretsiz iş",
    "teamFree": "Ekip başına aylık ücretsiz",
    "teamFreeHint": "Altın seviye lider +1, Platin +2",
    "freeDays": "Ücretsiz öne çıkarma (gün)",
    "plansJob": "İş ilanı paketleri",
    "plansTeam": "Ekip paketleri",
    "days": "Gün",
    "price": "Fiyat (₺)",
    "active": "Satışta",
    "addPlan": "Paket ekle",
    "saved": "Öne çıkarma ayarları kaydedildi.",
    "updatedAt": "Son değişiklik: {{at}}",
    "liveTitle": "Yayında ve sırada",
    "liveHint": "Kurallara uymayan bir ilanı ya da ekibi buradan durdurabilirsiniz; ücret iadesi ayrıca yapılır.",
    "noneLive": "Şu an öne çıkan ilan ya da ekip yok.",
    "recent": "Son öne çıkarmalar",
    "what": "İlan / ekip",
    "window": "Süre",
    "payment": "Ödeme",
    "target": {
      "Job": "İş ilanı",
      "Team": "Ekip"
    },
    "stop": "Durdur",
    "stopTitle": "{{code}} durdurulsun mu?",
    "stopBody": "Öne çıkarma hemen biter; sıradaki öne çıkarmalar öne kayar. Ödenen tutar otomatik iade edilmez.",
    "stopped": "Öne çıkarma durduruldu."
  },
  "nda": {
    "badge": "Gizli · NDA",
    "badgeHint": "Gizli iş: ayrıntılar gizlilik sözleşmesi kabul edilince açılır; ekranlar filigranlıdır.",
    "title": "Gizlilik sözleşmesi",
    "gateHint": "{{org}} bu işi gizli tuttu. Senaryoları, talimatları ve uygulamayı görmek için sözleşmeyi okuyup kabul edin.",
    "agree": "Sözleşmeyi okudum, kabul ediyorum",
    "accept": "Kabul et ve devam et",
    "accepted": "Gizlilik sözleşmesini kabul ettiniz; işin ayrıntıları açıldı.",
    "acceptedOn": "Gizlilik sözleşmesini {{at}} tarihinde kabul ettiniz.",
    "cannotAccept": "Sözleşmeyi işte test yapanlar kabul eder; bu yalnızca bir önizleme.",
    "recordNote": "Kabul zamanı, metnin özeti ve bağlandığınız adres kayıt altına alınır. Ekranlarda adınız ve kodunuzla filigran bulunur.",
    "acceptFirst": "Önce gizlilik sözleşmesini kabul edin.",
    "casesHidden": "Senaryolar sözleşme kabul edilince görünür.",
    "acceptancesButton": "Sözleşme · {{count}} kabul",
    "acceptancesTitle": "Gizlilik sözleşmesini kabul edenler",
    "acceptancesHint": "Her test uzmanı işe başlamadan önce kabul eder. Bağlandıkları adres platformda saklanır, size gösterilmez.",
    "noneYet": "Henüz kabul eden yok.",
    "person": "Kişi",
    "acceptedAt": "Kabul zamanı",
    "fingerprint": "Metin özeti",
    "showText": "Sözleşme metnini göster",
    "casesOpen": "Sözleşmeyi kabul ettiğiniz için görünüyor; adımlar ve uygulama adresi görev alınca açılır."
  },
  "vault": {
    "title": "Test hesapları",
    "testerHint": "Bu işin uygulamasına girmek için kullanılacak hesaplar. Parolayı yalnızca gerektiğinde gösterin.",
    "customerHint": "Test edilen uygulamanın giriş bilgileri. Parolalar şifreli saklanır; yalnızca bu işte test yapanlar görür ve her görüntüleme kaydedilir.",
    "shared": "Paylaşılan",
    "exclusive": "Kişiye özel",
    "yours": "Sizin hesabınız",
    "username": "Kullanıcı adı",
    "password": "Parola",
    "notes": "Not",
    "show": "Göster",
    "claimHint": "Size özel bir hesap verilebilir ({{count}} boş).",
    "claim": "Hesabımı al",
    "claimed": "{{label}} artık sizin; başkası kullanmaz.",
    "recorded": "Parolayı her gösterişiniz müşteriye kaydedilir.",
    "add": "Hesap ekle",
    "addTitle": "Test hesabı ekle",
    "editTitle": "Test hesabını düzenle",
    "formHint": "Parola ve not şifrelenerek saklanır; müşteri ekibi ve işte test yapanlar dışında kimse göremez.",
    "label": "Ad",
    "labelPlaceholder": "Ör. Standart müşteri",
    "keepPassword": "Boş bırakırsanız parola değişmez.",
    "notesHint": "İsteğe bağlı: ör. kart numarası, 2FA kodu nereden alınır.",
    "notesReplace": "Yazarsanız eski notun yerine geçer; boş bırakmak notu siler.",
    "exclusiveLabel": "Kişiye özel (her test uzmanına ayrı hesap)",
    "exclusiveHint": "Kişiye özel hesaplar test uzmanlarına birer birer verilir; böylece iki kişi aynı sepeti ya da profili değiştirmez.",
    "added": "Test hesabı eklendi.",
    "updated": "Test hesabı güncellendi.",
    "deleted": "Test hesabı silindi.",
    "deleteTitle": "{{label}} silinsin mi?",
    "deleteBody": "Hesap ve görüntüleme kaydı silinir; test uzmanları artık göremez.",
    "empty": "Henüz test hesabı yok. Uygulamaya giriş gerekiyorsa buraya ekleyin; talimatlara parola yazmayın.",
    "holder": "Kimde",
    "free": "Boşta",
    "everyone": "Herkes",
    "looks": "Görüntüleme",
    "release": "Boşa çıkar",
    "released": "Hesap boşa çıkarıldı.",
    "showLog": "Görüntüleme kaydını göster",
    "hideLog": "Görüntüleme kaydını gizle",
    "noLooks": "Henüz kimse parola görüntülemedi."
  },
  "invoice": {
    "title": "Faturalar",
    "orgHint": "TestRome'un size kestiği e-Fatura / e-Arşiv faturalar: üyelik ödemeleri, ücretli öne çıkarmalar ve (komisyon uygulanan dönemlerde) hakediş hizmet bedelleri. Ödemeyle birlikte hazırlanır ve kısa süre içinde düzenlenir.",
    "mineTitle": "Faturalarım",
    "mineHint": "Üyelik ödemelerinizin ve ekibiniz için ödediğiniz öne çıkarmaların e-Arşiv faturaları.",
    "none": "Henüz fatura yok.",
    "number": "Fatura no",
    "description": "Açıklama",
    "vat": "KDV",
    "draft": "Taslak",
    "nextTry": "Yeniden deneme: {{at}}",
    "kind": {
      "EArsiv": "e-Arşiv Fatura",
      "EFatura": "e-Fatura"
    },
    "status": {
      "Pending": "Bekliyor",
      "Retrying": "Yeniden denenecek",
      "Issued": "Düzenlendi",
      "Failed": "Gönderilemedi",
      "Cancelled": "İptal edildi"
    },
    "back": {
      "org": "Faturalama",
      "my": "Kazançlarım",
      "admin": "Platform faturalaması",
      "orgMembership": "Üyelik",
      "myMembership": "Üyeliğim"
    },
    "doc": {
      "draftTitle": "Fatura taslağı",
      "date": "Düzenlenme: {{date}}",
      "buyer": "Sayın",
      "details": "Fatura bilgileri",
      "scenario": "Senaryo",
      "type": "Fatura tipi",
      "currency": "Para birimi",
      "taxLine": "Vergi dairesi: {{office}} · VKN: {{number}}",
      "tcknLine": "T.C. kimlik no: {{number}}",
      "lines": "Mal / hizmet",
      "item": "Açıklama",
      "quantity": "Miktar",
      "unitPrice": "Birim fiyat",
      "vatRate": "KDV oranı",
      "vatAmount": "KDV tutarı",
      "lineTotal": "Tutar",
      "subtotal": "Mal / hizmet toplamı",
      "vat": "Hesaplanan KDV ({{rate}})",
      "withTaxes": "Vergiler dahil toplam",
      "payable": "Ödenecek tutar",
      "cancelled": "Bu fatura {{date}} tarihinde iptal edildi: {{reason}}",
      "note": "Bu belge, e-Fatura / e-Arşiv faturanın görüntüsüdür; geçerli hali entegratör ve GİB sisteminde ETTN ile doğrulanır.",
      "draftNote": "Bu belge henüz düzenlenmedi; entegratöre iletildiğinde fatura numarası ve tarih kesinleşir."
    }
  },
  "invoiceAdmin": {
    "title": "e-Fatura / e-Arşiv",
    "hint": "Ödenen hakedişlerin hizmet bedeli ve ücretli öne çıkarmalar için kesilen faturalar. Gönderilemeyenler birkaç kez yeniden denenir; sonra burada bekler.",
    "provider": "Entegratör",
    "simulated": "Simülasyon",
    "none": "Ayarlanmamış",
    "pending": "Bekleyen",
    "failed": "Gönderilemeyen",
    "issuedThisMonth": "Bu ay düzenlenen",
    "vatThisMonth": "KDV: ₺{{amount}}",
    "noProvider": "Fatura entegratörü ayarlanmamış: faturalar hazırlanıyor ve bekliyor. Entegratör ayarlanınca sırayla gönderilir.",
    "simulatorFailing": "Entegratör yanıt vermesin (simülasyon)",
    "simulatorDown": "Simülasyon entegratörü şu an faturaları reddediyor; yeni faturalar bekleyecek ve yeniden denenecek.",
    "filter": "Duruma göre",
    "sendNow": "Şimdi gönder",
    "sent": "{{number}} düzenlendi.",
    "notSent": "Gönderilemedi: {{error}}",
    "cancel": "İptal et",
    "cancelTitle": "{{number}} iptal edilsin mi?",
    "cancelIssued": "e-Arşiv fatura entegratörde iptal edilir; müşteriye iptal bilgisi gider. Tutar kendiliğinden iade edilmez.",
    "cancelDraft": "Bu fatura henüz düzenlenmedi; iptal edilirse hiç gönderilmez.",
    "reason": "İptal nedeni",
    "cancelled": "Fatura iptal edildi."
  },
  "crash": {
    "title": "Bu sayfa açılamadı",
    "body": "Beklenmeyen bir hata oluştu ve ekibimize bildirildi. Sayfayı yenileyebilir ya da tekrar deneyebilirsiniz.",
    "reload": "Sayfayı yenile",
    "retry": "Tekrar dene"
  },
  "errorTracking": {
    "title": "Hatalar",
    "subtitle": "API'de, arka plan işlerinde ve kullanıcıların tarayıcısında oluşan beklenmeyen hatalar; aynı hata tek satırda sayılır.",
    "test": "Test hatası gönder",
    "testSent": "Test hatası gönderildi; birkaç saniye içinde listede görünür.",
    "open": "Açık",
    "regressedTile": "Yeniden oluşan",
    "last24": "Son 24 saatte görülen",
    "releaseNow": "Çalışan sürüm",
    "list": "Hata grupları",
    "byStatus": "Duruma göre",
    "bySource": "Kaynağa göre",
    "noneOpen": "Açık hata yok.",
    "none": "Kayıt yok.",
    "details": "Ayrıntılar",
    "count": "Kaç kez oldu",
    "seen": "son: {{last}} · ilk: {{first}}",
    "regressed": "Yeniden oluştu",
    "resolve": "Çözüldü",
    "ignore": "Yok say",
    "reopen": "Yeniden aç",
    "kind": "Tür",
    "release": "Sürüm",
    "lastUser": "Son karşılaşan",
    "browser": "Tarayıcı",
    "source": {
      "Api": "API",
      "Worker": "Arka plan işi",
      "Web": "Web uygulaması"
    },
    "status": {
      "Open": "Açık",
      "Resolved": "Çözüldü",
      "Ignored": "Yok sayıldı"
    },
    "changed": {
      "Open": "Hata yeniden açıldı.",
      "Resolved": "Çözüldü olarak işaretlendi; yeniden olursa açılır.",
      "Ignored": "Yok sayıldı; sayılmaya devam eder."
    }
  },
  "duplicates": {
    "copyOf": "#{{n}} kopyası",
    "copies": "{{count}} kopya",
    "suspected": "Olası kopya: #{{n}}",
    "suspectedLong": "Daha önceki bir bildirime benziyor:",
    "isCopyOf": "Bu bildirim şunun kopyası:",
    "match": "%{{percent}} benzer",
    "markAsCopy": "Kopyası olarak işaretle",
    "marked": "Kopya olarak işaretlendi.",
    "turnedRound": "Bu bildirim #{{n}} numaralı bildirimden önce yapılmış: grubun ilk kaydı bu oldu, #{{n}} bunun kopyası olarak işaretlendi. Ödül ilk bildirene verilir.",
    "groupHint": "Bu bildirim grubun ilk kaydı; aynı sorunun sonraki bildirimleri buraya bağlanır ve ödül yalnızca ilk bildirene verilir.",
    "firstIsPaid": "Aynı sorun birden çok kez bildirilirse ödül ilk bildirene verilir.",
    "alreadyReported": "Bu döngüde benzer bildirimler var",
    "yours": "Sizin",
    "showCopies": "Kopyaları göster",
    "reason": {
      "sameStep": "aynı adım",
      "sameCase": "aynı senaryo",
      "similarTitle": "benzer başlık",
      "similarResult": "benzer sonuç"
    }
  },
  "automation": {
    "toTest": "Otomatik teste dönüştür",
    "title": "Playwright testi",
    "hint": "Bu kabul edilen çalıştırmanın kaydından üretildi: açılan sayfalar, tıklamalar ve doldurulan alanlar, senaryonun adımlarına bölünmüş olarak.",
    "summary": "{{actions}} işlem, {{assertions}} kontrol (sayfa adresi ve beklenen sonuçtaki tırnaklı metinler). Kayıt alanlara yazılanları saklamaz; giriş alanları ortam değişkenlerinden, diğerleri dosyadaki VALUES'tan okunur.",
    "env": "Ortam değişkenleri:",
    "values": "Doldurulacak değerler:",
    "copy": "Kopyala",
    "copied": "Test kopyalandı.",
    "copyFailed": "Kopyalanamadı; dosyayı indirin.",
    "download": "İndir ({{name}})",
    "cycle": "Playwright testleri",
    "cycleHint": "Kabul edilen web çalıştırmalarından her senaryo için bir test içeren, çalışmaya hazır Playwright projesi (zip)"
  },
  "ci": {
    "title": "CI'dan test başlatma",
    "hint": "Her derlemede (ör. her pull request'te) bir şablon döngüsünün kopyası yayımlanır; test uzmanları çalışır, sonuç commit durumu ve PR yorumu olarak GitHub'a, ya da CI çıktısına döner.",
    "newKey": "Yeni CI anahtarı",
    "newKeyHint": "Anahtar, onu oluşturan kişinin yetkisiyle yalnızca bu projede çalıştırma başlatır ve sonucunu okur.",
    "name": "Ad",
    "nameHint": "Hangi pipeline kullandığını hatırlatsın: GitHub Actions, GitLab, Jenkins…",
    "template": "Şablon döngü",
    "templateHint": "Her derlemede kopyalanan döngü: senaryolar, talimatlar, ortamlar, test uzmanları ve ücretler ondan gelir. CI isteği başka bir şablon da verebilir.",
    "noTemplate": "Önce bir döngü oluşturun",
    "failOn": "Derlemeyi düşüren bug'lar",
    "failOnHint": "Açık (yeni ya da onaylı) bug'lardan hangileri derlemeyi başarısız sayar.",
    "failOnValue": {
      "Critical": "Kritik",
      "Major": "Büyük ve üstü",
      "Minor": "Küçük ve üstü",
      "Any": "Her bug",
      "Never": "Hiçbiri (yalnızca bildir)"
    },
    "create": "Anahtarı oluştur",
    "createdTitle": "\"{{name}}\" anahtarı hazır",
    "createdHint": "Bu anahtar yalnızca şimdi gösterilir; kopyalayıp CI'ınızın gizli değişkenlerine kaydedin.",
    "key": "CI anahtarı",
    "step1": "GitHub: Settings → Secrets and variables → Actions → New repository secret: TESTROME_TOKEN (GitLab: Settings → CI/CD → Variables, maskeli).",
    "step2": "Aşağıdaki yapılandırmayı deponuza ekleyin.",
    "step3": "Sonucun pull request'e yazılması için organizasyon ayarlarından GitHub'ı bağlayın.",
    "savedIt": "Kaydettim",
    "noKeys": "Henüz CI anahtarı yok.",
    "managersOnly": "CI anahtarlarını organizasyonun sahipleri ve yöneticileri oluşturur.",
    "keyTemplate": "şablon: {{name}}",
    "keyNoTemplate": "şablon: istekte verilir",
    "keyFailOn": "eşik: {{value}}",
    "lastUsed": "son kullanım {{when}}",
    "neverUsed": "hiç kullanılmadı",
    "revoke": "Anahtarı iptal et",
    "revokeTitle": "CI anahtarı iptal edilsin mi?",
    "revokeBody": "Bu anahtarı kullanan pipeline'lar hemen çalışamaz hale gelir. Başlamış test çalıştırmaları sürer.",
    "revoked": "Anahtar iptal edildi.",
    "where": "CI",
    "snippetSecret": "TESTROME_TOKEN'ı gizli değişken olarak ekleyin",
    "snippetWait": "Durumu sorun: state Running, Passed, Failed, Incomplete ya da Cancelled",
    "snippetPreview": "--target-url ile önizleme ortamını, --wait ile sonucu beklemeyi ekleyebilirsiniz",
    "note1": "Aynı commit için tekrar çalışan iş yeni döngü açmaz; --cancel-previous aynı pull request'in eski derlemesini durdurur.",
    "note2": "--wait ile iş sonucu bekler: geçerse 0, başarısız ya da eksikse 1 ile çıkar. Elle test saatler sürebileceği için çoğu ekip beklemeden PR yorumuna bakar.",
    "note3": "Döngü, başlatılan her senaryonun bir kararı olunca, süresi dolunca ya da kapatılınca biter.",
    "build": "Derleme",
    "cycle": "Döngü",
    "result": "Sonuç",
    "started": "Başladı",
    "job": "CI işi",
    "fromCi": "CI ile başlatıldı",
    "reportError": "GitHub'a yazılamadı: {{error}}",
    "state": {
      "Running": "Test ediliyor",
      "Passed": "Geçti",
      "Failed": "Başarısız",
      "Incomplete": "Eksik",
      "Cancelled": "İptal edildi"
    }
  },
  "recommend": {
    "title": "Bu işe uygun test uzmanları",
    "none": "Şu an bu işin koşullarını karşılayan, işte olmayan bir serbest test uzmanı yok.",
    "footer": "{{considered}} serbest test uzmanına bakıldı; {{ineligible}} kişi işin koşullarını (itibar, seviye, dil, cihaz) karşılamıyor. Sıralama: uygun cihaz, bu tür işlerdeki deneyim, kabul oranı, puanlar, doğrulanmış bug'lar, sizinle çalışması ve müsaitlik.",
    "scoreLabel": "Uygunluk {{value}}/100",
    "reason": {
      "device": "Uygun cihaz: {{value}}",
      "noDevice": "İşin istediği cihaz yok",
      "categoryRuns": "Bu tür işlerde {{value}} kabul edilen test",
      "category": "Bu tür işleri seçmiş",
      "level": "{{level}} seviye",
      "acceptance": "Kabul oranı %{{value}}",
      "lowAcceptance": "Kabul oranı düşük (%{{value}})",
      "rating": "Müşteri puanı {{value}}",
      "lowRating": "Müşteri puanı düşük ({{value}})",
      "bugs": "{{value}} doğrulanmış bug",
      "workedWithYou": "Sizin için {{value}} kabul edilen test",
      "yourRating": "Sizden aldığı puan {{value}}",
      "available": "Şu an müsait",
      "busy": "{{value}} açık görevi var"
    }
  },
  "quality": {
    "title": "Sürüm kalitesi",
    "intro": "Her uygulama sürümünün test sonuçları: geçme oranı, bug'lar, yayına hazır olup olmadığı, zayıf noktaları ve Türkiye'deki kullanıma göre hangi cihazlarda test edildiği. Sürüm, döngünün \"Uygulama sürümü\" alanından gelir; taslak döngüler ve reddedilen çalıştırmalar sayılmaz.",
    "version": "Sürüm",
    "noVersion": "Sürümsüz",
    "emptyTitle": "Henüz yayınlanmış bir test döngüsü yok",
    "emptyBody": "Döngüler yayınlanıp test edildikçe her sürümün kalitesi burada görünür. Döngü sihirbazında uygulama sürümünü yazmayı unutmayın.",
    "trendTitle": "Sürümlere göre geçme oranı",
    "trendHint": "Çubuğun yüksekliği geçme oranını, rengi kararı gösterir. Bir sürüme tıklayınca ayrıntıları açılır.",
    "trendLabel": "Sürümlerin geçme oranları",
    "trendItem": "{{version}}: geçme oranı {{rate}}, {{bugs}} bug, {{verdict}}",
    "bugCount_one": "{{count}} bug",
    "bugCount_other": "{{count}} bug",
    "verdict": {
      "Ready": "Yayına hazır",
      "Risky": "Riskli",
      "NotReady": "Hazır değil",
      "NoData": "Veri yok"
    },
    "verdictTitle": "{{version}} sürümü",
    "verdictTitleNone": "Sürüm yazılmamış döngüler",
    "verdictMeta": "{{cycles}} döngü · {{from}} – {{to}}",
    "verdictLead": {
      "Ready": "Test sonuçlarına göre bu sürüm yayına hazır görünüyor.",
      "Risky": "Yayınlanabilir ama riskli: önce aşağıdakilere bakın.",
      "NotReady": "Bu sürüm henüz yayına hazır değil.",
      "NoData": "Bu sürümde henüz teslim edilmiş bir test yok."
    },
    "finding": {
      "allClear": "Geçme oranı %{{value}}; açık kritik ya da büyük bug yok.",
      "openCritical": "{{value}} açık kritik bug var.",
      "lowPassRate": "Geçme oranı çok düşük: %{{value}} (en az %70 olmalı).",
      "passRate": "Geçme oranı %{{value}} (hazır saymak için en az %90).",
      "openMajor": "{{value}} açık büyük bug var.",
      "untestedCases": "Planlanan senaryolardan {{value}} tanesi hiç çalıştırılmadı.",
      "lowCoverage": "Test edilen cihazlar kullanıcıların yalnızca %{{value}} kadarını kapsıyor (en az %50).",
      "openMinor": "{{value}} açık küçük ya da önemsiz bug var.",
      "pendingReview": "{{value}} çalıştırma henüz incelenmedi.",
      "testing": "Test sürüyor; sonuçlar değişebilir.",
      "noRuns": "Henüz teslim edilmiş çalıştırma yok."
    },
    "passRate": "Geçme oranı",
    "outcomes": "{{passed}} geçti · {{failed}} kaldı · {{blocked}} engellendi",
    "comparedTo": "{{version}} sürümüne göre",
    "deltaPoints": "{{value}} puan",
    "deltaCount": "{{value}}",
    "same": "değişmedi",
    "bugs": "Bug'lar",
    "openFixed": "{{open}} açık · {{fixed}} düzeltildi",
    "cases": "Çalıştırılan senaryolar",
    "runsLine": "{{runs}} çalıştırma · {{pending}} incelemede",
    "coverage": "Cihaz kapsamı",
    "coverageHint": {
      "Web": "Test edilen cihaz türü ve işletim sistemlerinin Türkiye'deki kullanım payı",
      "Android": "Test edilen Android sürümlerinin Türkiye'deki kullanım payı",
      "Ios": "Test edilen iOS sürümlerinin Türkiye'deki kullanım payı"
    },
    "coverageTitle": "Cihaz kapsam haritası",
    "coverageIntro": "Bu sürümün hangi cihaz, işletim sistemi ve tarayıcılarda test edildiği, Türkiye'deki kullanım paylarıyla.",
    "reach": {
      "Web": "Türkiye'deki web ziyaretçilerinin kullandığı cihaz türü ve işletim sistemlerinden test edilenlerin payı: {{value}}.",
      "Android": "Türkiye'deki Android kullanıcılarının sistem sürümlerinden test edilenlerin payı: {{value}}.",
      "Ios": "Türkiye'deki iPhone ve iPad kullanıcılarının iOS sürümlerinden test edilenlerin payı: {{value}}."
    },
    "gapsTitle": "En büyük eksikler",
    "gap": "{{label}} · {{value}}",
    "gapsHint": "Yüzdeler Türkiye'deki kullanıcıların içindeki paydır. Bunları bir sonraki döngünün ortam matrisine ekleyebilir ya da bu cihazlara sahip test uzmanlarını davet edebilirsiniz.",
    "gapIn": {
      "mobileBrowser": "{{label}} (telefon)",
      "desktopBrowser": "{{label}} (masaüstü)",
      "mobileOs": "{{label}} telefonlar",
      "desktopOs": "{{label}} bilgisayarlar"
    },
    "group": {
      "platform": "Cihaz türü",
      "mobileOs": "Telefon işletim sistemi",
      "androidVersion": "Android sürümleri",
      "iosVersion": "iOS sürümleri",
      "desktopOs": "Bilgisayar işletim sistemi",
      "windowsVersion": "Windows sürümleri",
      "mobileBrowser": "Telefon tarayıcıları",
      "desktopBrowser": "Masaüstü tarayıcıları"
    },
    "groupCovered": "{{value}} kapsandı",
    "runs_one": "{{count}} çalıştırma",
    "runs_other": "{{count}} çalıştırma",
    "notTested": "test edilmedi",
    "other": "Listede olmayan ortamlar: {{list}}.",
    "unknown_one": "{{count}} çalıştırmanın cihazı anlaşılamadı.",
    "unknown_other": "{{count}} çalıştırmanın cihazı anlaşılamadı.",
    "source": "Kullanım payları: {{name}}, Türkiye, {{period}}.",
    "sourceLink": "Kaynak",
    "weakTitle": "Zayıf noktalar",
    "weakHint": "Kalan, engellenen ya da bug çıkan senaryolar",
    "noWeakAreas": "Bu sürümde kalan senaryo ya da bug yok.",
    "exploratory": "Keşif testleri",
    "weakLine": "{{runs}} çalıştırma · {{failed}} kaldı/engellendi · {{bugs}} bug · geçme {{rate}}",
    "cyclesTitle": "Bu sürümün döngüleri",
    "cycleLine": "{{runs}} çalıştırma · geçme {{rate}} · {{bugs}} bug",
    "report": "Rapor"
  },
  "duration": {
    "s": "{{s}} sn",
    "m": "{{m}} dk",
    "ms": "{{m}} dk {{s}} sn",
    "h": "{{h}} sa",
    "hm": "{{h}} sa {{m}} dk",
    "d": "{{d}} gün",
    "dh": "{{d}} gün {{h}} sa"
  },
  "idle": {
    "threshold": "Aralar",
    "thresholdHint": "Bu süreden uzun aralar gösterilir. Seçim bu tarayıcıda saklanır.",
    "off": "Aralar gizli",
    "atLeast": "Ara: {{duration}} ve üstü",
    "logGap": "{{duration}} ara · önceki işlem {{at}}",
    "logGapUser": "{{name}}: {{duration}} ara · önceki işlemi {{at}}",
    "title": "Süre ve aralar",
    "total": "Toplam",
    "active": "Çalışma",
    "idle": "Ara",
    "hidden": "Aralar gizli; göstermek için bir süre seçin.",
    "none": "{{duration}} ya da daha uzun ara yok.",
    "summary_one": "{{count}} ara, toplam sürenin %{{share}} kadarı.",
    "summary_other": "{{count}} ara, toplam sürenin %{{share}} kadarı.",
    "summaryHidden": "Aralarda uygulama {{hidden}} boyunca ekranda değildi.",
    "between": "Önce: {{from}} · sonra: {{to}}",
    "offScreen": "{{duration}} boyunca uygulama ekranda değildi",
    "inStep": "{{duration}} ara",
    "kind": {
      "start": "çalıştırmayı başlattı",
      "end": "teslim etti",
      "Click": "tıkladı",
      "Input": "bir alana yazdı",
      "Navigation": "sayfa değiştirdi",
      "Checkpoint": "kontrol noktasına ulaştı",
      "Session": "uygulamayı açtı",
      "VisibilityChange_from": "uygulamadan ayrıldı",
      "VisibilityChange_to": "uygulamaya döndü",
      "execution_started": "çalıştırmayı başlattı",
      "execution_submitted": "teslim etti",
      "step_started": "adımı başlattı",
      "step_completed": "adımı tamamladı",
      "evidence_uploaded": "kanıt yükledi",
      "bug_reported": "bug bildirdi",
      "execution_notes_saved": "not yazdı",
      "execution_video_uploaded": "ekran kaydını yükledi",
      "execution_video_started": "ekran kaydını başlattı",
      "execution_app_opened": "uygulamayı telefonda açtı",
      "execution_pairing_code_created": "eşleştirme kodu aldı",
      "execution_phone_link_created": "telefon bağlantısı aldı",
      "execution_video_marked": "kayıtta adımları işaretledi",
      "execution_relaunched": "çalıştırmayı yeniden başlattı",
      "other": "bir işlem yaptı"
    }
  },
  "appearance": {
    "title": "Görünüm",
    "description": "Her görünüm kendi renkleri ve yazı tipiyle çiziliyor. Seçtiğiniz görünüm hemen uygulanır ve bu tarayıcıda saklanır.",
    "open": "Görünümleri karşılaştır…",
    "current": "Şu anki görünüm",
    "desc": {
      "system": "Bilgisayarınızın açık ya da koyu ayarını izler.",
      "light": "Mineral kâğıt, koyu yeşil mürekkep, mor vurgu.",
      "dark": "Aynı görünümün koyusu; uzun inceleme oturumları için.",
      "fosforlu": "Kâğıt beyazı ve mürekkep mavisi; bulunduğunuz yer fosforlu kalemle işaretli.",
      "ozalit": "Ozalit mavisi, çizim ızgarası ve camgöbeği çizgiler; her sayfa bir teknik çizim gibi."
    }
  },
  "rhythm": {
    "period": "Dönem",
    "periods": {
      "7d": "Son 7 gün",
      "30d": "Son 30 gün",
      "90d": "Son 90 gün"
    },
    "cycle": "Döngü",
    "allCycles": "Bütün döngüler",
    "job": "İş",
    "allJobs": "Bütün işler",
    "otherCycle": "Seçili döngü",
    "tester": "Test uzmanı",
    "allTesters": "Bütün test uzmanları",
    "otherTester": "Seçili kişi",
    "thresholdHint": "Bu süreden uzun duraklamalar ara sayılır. Seçim kayıtlar ve inceleme sayfasıyla ortaktır, bu tarayıcıda saklanır.",
    "note": "Bu pano işlerin nasıl ilerlediğini görmeniz içindir; güven puanını ya da ödemeyi etkilemez. Ekran videosuyla yapılan çalıştırmalarda yalnızca TestRome'daki adımlar bilindiği için aralar daha kaba ölçülür.",
    "truncated": "Bu seçimde çok fazla çalıştırma var; yalnızca en son teslim edilen {{max}} çalıştırma incelendi. Dönemi daraltın ya da bir döngü seçin.",
    "emptyTitle": "Bu dönemde teslim edilmiş çalıştırma yok",
    "emptyBody": "Dönemi genişletin ya da filtreleri kaldırın.",
    "reviewersOnlyTitle": "Çalışma ritmini inceleyiciler görür",
    "reviewersOnlyBody": "Bu sekme sahip, yönetici ve inceleyici rolündekilere açıktır.",
    "kpi": {
      "runs": "İncelenen çalıştırma",
      "runsSub": "Bu dönemde teslim edilenler",
      "runsCoarse_one": "{{count}} tanesi ekran videosu: kaba ölçüm",
      "runsCoarse_other": "{{count}} tanesi ekran videosu: kaba ölçüm",
      "withBreaks": "Ara verilen çalıştırma",
      "withBreaksSub_one": "Çalıştırmaların {{share}} kadarı · {{count}} ara",
      "withBreaksSub_other": "Çalıştırmaların {{share}} kadarı · {{count}} ara",
      "breakTime": "Toplam ara",
      "breakTimeSub": "Çalışma süresinin {{share}} kadarı",
      "active": "Çalıştırma başına aktif süre",
      "activeSub": "Aralar hariç; toplam {{total}}",
      "hidden": "Aranın ekran dışı kısmı",
      "hiddenSub": "Uygulama {{duration}} boyunca ekranda değildi",
      "hiddenNone": "Bu eşikte ara yok"
    },
    "showTable": "Tablo olarak göster",
    "showChart": "Grafik olarak göster",
    "lengthTitle": "Ara uzunlukları",
    "lengthHint": "Bir dakikadan uzun bütün duraklamalar; eşiğin altındakiler ara sayılmaz.",
    "legendBreak": "Ara ({{duration}} ve üstü)",
    "legendShort": "Eşiğin altında",
    "bucket": {
      "1-2": "1–2 dk",
      "2-5": "2–5 dk",
      "5-15": "5–15 dk",
      "15+": "15 dk+"
    },
    "bucketTip_one": "{{count}} duraklama · toplam {{duration}}",
    "bucketTip_other": "{{count}} duraklama · toplam {{duration}}",
    "counted": "Ara sayılır",
    "notCounted": "Eşiğin altında, ara sayılmaz",
    "trendTitle": "Günlük eğilim",
    "trendHint": "Gün gün teslim edilen çalıştırmalar; ara verilenler altta.",
    "trendLabel": "Günlük çalıştırma grafiği. Günler arasında ok tuşlarıyla gezinin.",
    "legendWithBreaks": "Ara verilen çalıştırma",
    "legendWithout": "Arasız çalıştırma",
    "tipWithBreaks": "ara verilen",
    "tipWithout": "arasız",
    "dayRuns_one": "{{count}} çalıştırma",
    "dayRuns_other": "{{count}} çalıştırma",
    "dayWithBreaks_one": "{{count}} tanesinde ara",
    "dayWithBreaks_other": "{{count}} tanesinde ara",
    "dayBreakTime": "toplam ara {{duration}}",
    "col": {
      "day": "Gün",
      "runs": "Çalıştırma",
      "withBreaks": "Ara verilen",
      "breaks": "Ara",
      "breakTime": "Toplam ara",
      "length": "Uzunluk",
      "pauses": "Duraklama",
      "counted": "Durum",
      "tester": "Test uzmanı",
      "perRun": "Ara / çalıştırma",
      "longest": "En uzun ara",
      "share": "Aradaki pay",
      "case": "Senaryo",
      "topStep": "En çok ara verilen adım"
    },
    "testersTitle": "Test uzmanları",
    "testersHint": "Toplam ara süresi en çok olandan aza.",
    "testersHintLogs": "Toplam ara süresi en çok olandan aza. İsme tıklayınca kişinin kayıtları açılır.",
    "openLogsOf": "{{name}}: kayıtları aç",
    "casesTitle": "Senaryolar ve adımlar",
    "casesHint": "En çok ara verilen senaryolar (en fazla 10); çalıştırma sütunu ara verilenleri ve hepsini gösterir.",
    "casesNone": "Bu eşikte senaryolarda ara yok.",
    "exploratory": "Keşif testleri",
    "stepBreaks_one": "{{count}} ara, {{duration}}",
    "stepBreaks_other": "{{count}} ara, {{duration}}",
    "longestTitle": "En uzun aralar",
    "longestHint": "Tıklayınca kayıtta o ana gidilir.",
    "longestHintLogs": "Tıklayınca o çalıştırmanın kayıtları açılır.",
    "longestNone": "Bu eşikte ara yok.",
    "openRecording": "Kayda git",
    "openLogs": "Kayıtlarda aç",
    "coarse": "Ekran videosu: kaba ölçüm"
  },
  "membership": {
    "titleOrg": "Üyelik",
    "subtitleOrg": "Organizasyonunuzdaki herkes bu üyelikle çalışır",
    "titleMine": "Üyeliğim",
    "subtitleMine": "Pazaryerindeki işler için kendi üyeliğiniz; toplulukların işlerini organizasyonları karşılar",
    "state": {
      "NotStarted": "Başlamadı",
      "Trial": "Deneme",
      "Active": "Aktif",
      "PastDue": "Ödeme bekliyor",
      "Cancelled": "İptal edildi",
      "Granted": "Tanımlandı",
      "Expired": "Süresi doldu"
    },
    "interval": {
      "Monthly": "Aylık",
      "Yearly": "Yıllık"
    },
    "per": {
      "Monthly": "/ ay",
      "Yearly": "/ yıl"
    },
    "line": {
      "NotStarted": "Pazaryerinde iş almak için üyelik gerekir. {{days}} günlük deneme süreniz ilk başvurunuzla başlar.",
      "Trial_one": "Deneme süreniz {{date}} tarihinde bitiyor. Sonrasında devam etmek için bir plan seçin.",
      "Trial_other": "Deneme süreniz {{date}} tarihinde bitiyor. Sonrasında devam etmek için bir plan seçin.",
      "Active": "{{plan}}. Bir sonraki yenileme {{date}} tarihinde kayıtlı karttan otomatik çekilir.",
      "PastDue": "Son yenileme ödemesi alınamadı. Ödeme yeniden denenir; erişiminiz {{date}} tarihine kadar sürer. Kartınızı değiştirmek için aşağıdan yeni kartla ödeyebilirsiniz.",
      "CancelledOpen": "Üyelik iptal edildi; otomatik yenileme yapılmayacak. {{date}} tarihine kadar kullanmaya devam edebilirsiniz.",
      "Granted": "Platform tarafından tanımlanan üyelik: {{date}} tarihine kadar geçerli.",
      "GrantedForever": "Platform tarafından süresiz tanımlanan üyelik.",
      "Expired": "Üyelik sona erdi. Verileriniz duruyor ve görüntülenebilir, ancak yeni iş başlatılamaz. Devam etmek için bir plan seçin.",
      "ExpiredTester": "Üyeliğiniz sona erdi. Pazaryerinde yeni işe başvurmak için bir plan seçin; topluluk işleriniz bundan etkilenmez."
    },
    "daysLeft_one": "{{count}} gün kaldı",
    "daysLeft_other": "{{count}} gün kaldı",
    "notRequired": "Şu an test uzmanlarından üyelik istenmiyor; pazaryerindeki işlere üyeliksiz başvurabilirsiniz.",
    "notRequiredTitle": "Üyelik gerekmiyor",
    "lastError": "Sağlayıcının yanıtı: {{error}}",
    "nextPlan": "{{date}} tarihinden itibaren {{plan}} planına geçilecek ({{amount}}).",
    "lockedOrg": "Projeler, test turları ve sonuçlar görüntülenebilir; yeni tur başlatmak, test eklemek ve ekibe kişi çağırmak üyelikle açılır.",
    "lockedTester": "Pazaryerinde yeni işlere başvurmak ve yeni test başlatmak üyelikle açılır.",
    "managersOnly": "Üyeliği organizasyonun sahipleri ve yöneticileri yönetir.",
    "statusTitle": "Durum",
    "plansTitle": "Planlar",
    "plansHintOrg": "Fiyatlara KDV dahildir. Komisyon yoktur: test uzmanlarına ödediğinizin üzerine platform ücreti eklenmez.",
    "plansHintTester": "Fiyatlara KDV dahildir. Kazançlarınızdan komisyon kesilmez.",
    "saving": "%{{percent}} tasarruf",
    "currentPlan": "Mevcut plan",
    "nextPlanBadge": "Sıradaki plan",
    "vatIncluded": "KDV dahil",
    "perMonthApprox": "ayda yaklaşık {{amount}}",
    "start": "Üyeliği başlat",
    "payNewCard": "Yeni kartla öde",
    "switch": "Bu plana geç",
    "keepPlan": "Bu planda kal",
    "keepDone": "Plan değişikliği geri alındı",
    "switchScheduled": "{{date}} itibarıyla bu plana geçilecek.",
    "switchTitle": "{{plan}} planına geçilsin mi?",
    "switchBody": "Değişiklik mevcut dönemin sonunda, {{date}} tarihinde başlar; o gün kayıtlı karttan {{amount}} ({{interval}}) çekilir.",
    "switchDone": "Plan {{date}} tarihinde değişecek",
    "cancel": "Üyeliği iptal et",
    "cancelTitle": "Üyelik iptal edilsin mi?",
    "cancelBody": "Otomatik yenileme durur. {{date}} tarihine kadar çalışmaya devam edersiniz; sonra veriler silinmez ama yeni iş başlatılamaz.",
    "cancelConfirm": "İptal et",
    "cancelled": "Üyelik iptal edildi; otomatik yenileme yapılmayacak",
    "startsToday": "Ödeme yaptığınız gün ilk dönem başlar; kalan deneme ya da önceki dönem günleri eklenmez.",
    "noPlans": "Şu an seçilebilecek bir plan yok; platform yöneticisine başvurun.",
    "autoRenew": "Ödeme iyzico güvenli ödeme sayfasında alınır; her dönem sonunda aynı karttan otomatik yenilenir. İstediğiniz zaman iptal edebilirsiniz. Her ödeme için e-Arşiv / e-Fatura kesilir.",
    "blocker": {
      "notConfigured": "Kartlı ödeme bu kurulumda açık değil; üyelik için platform yöneticisine başvurun.",
      "billing": "Kartla ödemek için önce fatura bilgilerini (yetkilinin T.C. kimlik numarası, telefon ve adres dahil) doldurun."
    },
    "fillBilling": "Fatura bilgilerine git",
    "paymentsTitle": "Ödemeler",
    "paymentsHint": "Her ödemenin faturası ödemeyle birlikte hazırlanır.",
    "paidAt": "Tarih",
    "plan": "Plan",
    "period": "Dönem",
    "amount": "Tutar",
    "invoice": "Fatura",
    "forever": "süresiz",
    "buyerTitle": "Fatura ve ödeme bilgileri",
    "buyerHint": "{{plan}} · {{interval}} · {{amount}}. Bu bilgiler faturanızda ve iyzico ödeme kaydında kullanılır.",
    "identityAgain": "Kayıtlı: {{masked}} — güvenlik için yeniden girin",
    "toPayment": "Ödeme sayfasına geç",
    "checkoutDone": "Ödeme alındı, üyeliğiniz başladı. Faturanız hazırlanıyor.",
    "checkoutFailed": "Ödeme tamamlanmadı; kartınızdan para çekilmedi. Yeniden deneyebilirsiniz.",
    "openPage": "Üyelik sayfası",
    "banner": {
      "Trial_one": "Deneme süresinin bitmesine {{count}} gün kaldı ({{date}}).",
      "Trial_other": "Deneme süresinin bitmesine {{count}} gün kaldı ({{date}}).",
      "PastDue": "Üyelik yenileme ödemesi alınamadı. Erişim {{date}} tarihine kadar sürer.",
      "Cancelled": "Üyelik iptal edildi ve {{date}} tarihinde bitecek.",
      "Expired": "Üyelik sona erdi: veriler görüntülenebilir ama yeni iş başlatılamaz.",
      "ExpiredTester": "Pazaryerinde yeni işe başvurmak için üyelik gerekiyor; topluluk işleriniz etkilenmez.",
      "choose": "Plan seç",
      "open": "Üyeliğe git",
      "askManager": "Organizasyon yöneticinize başvurun"
    }
  },
  "membershipAdmin": {
    "title": "Üyelikler",
    "provider": "Ödeme altyapısı: {{name}}",
    "simulation": "Simülasyon",
    "mrr": "Aylık yinelenen gelir",
    "mrrHint": "Yıllık planlar 12'ye bölünür",
    "settings": "Ayarlar",
    "settingsHint": "Deneme süresi yeni organizasyonlara ve pazaryerine ilk kez başvuran test uzmanlarına uygulanır.",
    "trialDays": "Deneme süresi (gün)",
    "trialDaysHint": "0: deneme yok",
    "graceDays": "Ödeme için ek süre (gün)",
    "graceDaysHint": "Yenileme ödemesi alınamazsa erişimin süreceği gün sayısı",
    "fee": "Komisyon (%)",
    "feeHint": "0: komisyon yok. Test uzmanı ödemelerinin üzerine eklenir.",
    "testerRequired": "Test uzmanlarından pazaryeri işleri için üyelik iste",
    "testerRequiredHint": "Kapalıyken test uzmanları pazaryerine üyeliksiz başvurur. Topluluk işleri her zaman organizasyonun üyeliğiyle yapılır.",
    "plans": "Planlar ve fiyatlar",
    "plansHint": "Fiyatlar KDV dahildir. Aynı adı taşıyan aylık ve yıllık planlar arasındaki tasarruf otomatik hesaplanır.",
    "newPlan": "Plan ekle",
    "editPlan": "Planı düzenle",
    "planHint": "Planın adı, maddeleri ve sırası her zaman değişebilir.",
    "priceLocked": "Kullanılmış bir planın fiyatı, dönemi ve kimin için olduğu değişmez: yeni bir plan ekleyip bunu kapatın; mevcut üyeler değiştirene kadar bu planda kalır.",
    "audience": "Kimin için",
    "audienceOf": {
      "Organization": "Organizasyon",
      "Tester": "Test uzmanı"
    },
    "planName": "Plan adı",
    "price": "Fiyat (₺, KDV dahil)",
    "priceHint": "Her dönem karttan çekilecek tutar",
    "description": "Kısa açıklama",
    "features": "Öne çıkan maddeler",
    "featuresHint": "Her satıra bir madde",
    "featureCount_one": "{{count}} madde",
    "featureCount_other": "{{count}} madde",
    "sortOrder": "Sıra",
    "active": "Satışta",
    "simulatorTitle": "Yenileme simülasyonu",
    "simulatorHint": "Simülasyon altyapısında dönemi biten üyelikler burada yenilenir. Hata akışını denemek için yenilemeleri başarısız yapabilirsiniz.",
    "failRenewals": "Yenilemeler başarısız olsun (kart reddi)",
    "subjects": "Organizasyonlar ve test uzmanları",
    "subjectsHint": "Deneme süresini uzatabilir ya da belirli bir tarihe kadar ücretsiz üyelik tanımlayabilirsiniz.",
    "filterLabel": "Gösterilen",
    "filter": {
      "all": "Tümü",
      "Organization": "Organizasyonlar",
      "Tester": "Test uzmanları",
      "attention": "İlgi bekleyen"
    },
    "noRows": "Gösterilecek kayıt yok.",
    "subject": "Hesap",
    "status": "Durum",
    "accessUntil": "Erişim",
    "paid": "Ödenen",
    "renewNow": "Şimdi yenile",
    "renewed": "Yenileme çalıştırıldı",
    "subjectHint": "Değişiklikler hemen geçerli olur.",
    "trialEnds": "Deneme bitişi",
    "trialEndsHint": "Günün sonunda (Türkiye saati) biter.",
    "grant": "Ücretsiz üyelik",
    "grantHint": "Belirtilen tarihe kadar ödeme istenmez; abonelik varsa ondan bağımsızdır.",
    "grantUntil": "Bitiş tarihi",
    "forever": "Süresiz",
    "grantNote": "Not (üyeye gösterilir)",
    "clearGrant": "Ücretsiz üyeliği kaldır"
  }
}
